
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6g38M", function(module, exports) {
/**
 * @generated SignedSource<<efe5cd7303cce063c3c1cc22a192e0ea>>
 * @relayHash c8147ea7d06264c113941f070cc9c557
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bb20320983fb57f96674e457880159113245958ae698e240254febfcb07a08a
const $c2366b7346451a87$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c8147ea7d06264c113941f070cc9c557",
            "id": "7bb20320983fb57f96674e457880159113245958ae698e240254febfcb07a08a",
            "metadata": {},
            "name": "getAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query getAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$c2366b7346451a87$var$node.hash = "4187f33183c6b803fad92aa55dc76eee";
var $c2366b7346451a87$export$2e2bcd8739ae039 = $c2366b7346451a87$var$node;



var $a2xFu = parcelRequire("a2xFu");


var $ge2sX = parcelRequire("ge2sX");


var $iSXh4 = parcelRequire("iSXh4");


var $c0rhi = parcelRequire("c0rhi");

const $c7fe11d803ab2486$var$getAutomatedMeetingNotesPagePropertiesQuery = (0, $c2366b7346451a87$export$2e2bcd8739ae039);
const $c7fe11d803ab2486$export$803a631454411196 = async (pageId)=>{
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const pageAri = (0, $a2xFu.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: pageId
    }).toString();
    // There is no non-hook alternative for getApolloClient AFAIK
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: $c7fe11d803ab2486$var$getAutomatedMeetingNotesPagePropertiesQuery,
        variables: {
            pageAri: pageAri
        },
        errorPolicy: 'none',
        __callerPackage__: "@confluence/automated-meeting-notes"
    });
    return (0, $iSXh4.extractAmnPageProperties)(data);
};
module.exports["getAutomatedMeetingNotesPageProperties"] = $c7fe11d803ab2486$export$803a631454411196;

});

parcelRegister("55DRn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<62e4821be56f673f3b418922e201e328>>
 * @relayHash 12bf64819ab2d36ef483ee5ce9a88bcd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e36b48f3ac80d1bdaf2651dfef6e79d93108bbf1591800d929192d29cad0fe9
const $abcb93b73f298879$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "targetSpaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageTopLevel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMovePageHandlerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMovePageHandlerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "12bf64819ab2d36ef483ee5ce9a88bcd",
            "id": "4e36b48f3ac80d1bdaf2651dfef6e79d93108bbf1591800d929192d29cad0fe9",
            "metadata": {},
            "name": "useMovePageHandlerMovePageTopLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useMovePageHandlerMovePageTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id,links{webui,editui}}}}"
        }
    };
}();
$abcb93b73f298879$var$node.hash = "0bbc6a612473c98695dd3973cd86fb2e";
var $abcb93b73f298879$export$2e2bcd8739ae039 = $abcb93b73f298879$var$node;


/**
 * @generated SignedSource<<24c5c848bb472d3b8482ee05e39a7dcc>>
 * @relayHash 73d70478feb019b3126a56695522224e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcb8f2b74d1f3407e9d560434e38dd34ba07c7239fa51e37b8fc40e8b08a8400
const $ce5feb6c0fc292c7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "parentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAppend",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMovePageHandlerMovePageAppendMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMovePageHandlerMovePageAppendMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "73d70478feb019b3126a56695522224e",
            "id": "fcb8f2b74d1f3407e9d560434e38dd34ba07c7239fa51e37b8fc40e8b08a8400",
            "metadata": {},
            "name": "useMovePageHandlerMovePageAppendMutation",
            "operationKind": "mutation",
            "text": "mutation useMovePageHandlerMovePageAppendMutation($pageId:ID!,$parentId:ID!){movePageAppend(input:{pageId:$pageId,parentId:$parentId}){page{id,links{webui,editui}}}}"
        }
    };
}();
$ce5feb6c0fc292c7$var$node.hash = "438afe9b7f5abfdc270fb984ae9947ec";
var $ce5feb6c0fc292c7$export$2e2bcd8739ae039 = $ce5feb6c0fc292c7$var$node;


/**
 * @generated SignedSource<<2c78b180afbe8902eb42b85f88ef28ca>>
 * @relayHash e4fc157144ff80433929db438252274a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6d8a439313151ac4be2392b04a56ad04abc753676cb8a365d2172b825c4f835
const $89aad801432cf2f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siblingId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "siblingId",
                            "variableName": "siblingId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageBefore",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMovePageHandlerMovePageBeforeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMovePageHandlerMovePageBeforeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e4fc157144ff80433929db438252274a",
            "id": "e6d8a439313151ac4be2392b04a56ad04abc753676cb8a365d2172b825c4f835",
            "metadata": {},
            "name": "useMovePageHandlerMovePageBeforeMutation",
            "operationKind": "mutation",
            "text": "mutation useMovePageHandlerMovePageBeforeMutation($pageId:ID!,$siblingId:ID!){movePageBefore(input:{pageId:$pageId,siblingId:$siblingId}){page{id,links{webui,editui}}}}"
        }
    };
}();
$89aad801432cf2f9$var$node.hash = "4c865d6cf9059b124024ddd239f00b20";
var $89aad801432cf2f9$export$2e2bcd8739ae039 = $89aad801432cf2f9$var$node;


/**
 * @generated SignedSource<<33570c0aa82a9989fc2555765c7b2cf4>>
 * @relayHash f007e6a1a06e284145a6e359d559abc7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2285585fad428a22ba24da19e8d732ed06f7f166ce87970eb39db8bac4964e0e
const $96207dc70cedc05c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siblingId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "siblingId",
                            "variableName": "siblingId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAfter",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMovePageHandlerMovePageAfterMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMovePageHandlerMovePageAfterMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f007e6a1a06e284145a6e359d559abc7",
            "id": "2285585fad428a22ba24da19e8d732ed06f7f166ce87970eb39db8bac4964e0e",
            "metadata": {},
            "name": "useMovePageHandlerMovePageAfterMutation",
            "operationKind": "mutation",
            "text": "mutation useMovePageHandlerMovePageAfterMutation($pageId:ID!,$siblingId:ID!){movePageAfter(input:{pageId:$pageId,siblingId:$siblingId}){page{id,links{webui,editui}}}}"
        }
    };
}();
$96207dc70cedc05c$var$node.hash = "9d4a33e40b8e98aa3f260ac26bd6fa66";
var $96207dc70cedc05c$export$2e2bcd8739ae039 = $96207dc70cedc05c$var$node;



var $308Wd = parcelRequire("308Wd");

const $49c0c7f1efa9aabd$export$6dd12ebb9a442472 = ()=>{
    const $ = (0, $frIzR.c)(7);
    const [movePageAfter] = (0, $308Wd.useMutationInterop)((0, $96207dc70cedc05c$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/page-tree"
    });
    const [movePageBefore] = (0, $308Wd.useMutationInterop)((0, $89aad801432cf2f9$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/page-tree"
    });
    const [movePageAppend] = (0, $308Wd.useMutationInterop)((0, $ce5feb6c0fc292c7$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/page-tree"
    });
    const [movePageTopLevel] = (0, $308Wd.useMutationInterop)((0, $abcb93b73f298879$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/page-tree"
    });
    let t0;
    if ($[0] !== movePageAfter || $[1] !== movePageAppend || $[2] !== movePageBefore || $[3] !== movePageTopLevel) {
        t0 = async (params)=>{
            const thenFn = $49c0c7f1efa9aabd$var$_temp;
            if ("parentId" in params) return movePageAppend({
                variables: {
                    pageId: params.pageId,
                    parentId: params.parentId
                }
            }).then(thenFn($49c0c7f1efa9aabd$var$_temp2));
            else {
                if ("spaceKey" in params) return movePageTopLevel({
                    variables: {
                        pageId: params.pageId,
                        spaceKey: params.spaceKey
                    }
                }).then(thenFn($49c0c7f1efa9aabd$var$_temp3));
                else {
                    if (params.positionToSibling === "after") return movePageAfter({
                        variables: {
                            pageId: params.pageId,
                            siblingId: params.siblingId
                        }
                    }).then(thenFn($49c0c7f1efa9aabd$var$_temp4));
                    else return movePageBefore({
                        variables: {
                            pageId: params.pageId,
                            siblingId: params.siblingId
                        }
                    }).then(thenFn($49c0c7f1efa9aabd$var$_temp5));
                }
            }
        };
        $[0] = movePageAfter;
        $[1] = movePageAppend;
        $[2] = movePageBefore;
        $[3] = movePageTopLevel;
        $[4] = t0;
    } else t0 = $[4];
    const movePage = t0;
    let t1;
    if ($[5] !== movePage) {
        t1 = {
            movePage: movePage
        };
        $[5] = movePage;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
function $49c0c7f1efa9aabd$var$_temp(resultFormatter) {
    return (t0)=>{
        const { data: data, ...rest } = t0;
        return {
            ...rest,
            data: typeof data === "undefined" ? undefined : {
                mutationResult: resultFormatter(data)
            }
        };
    };
}
function $49c0c7f1efa9aabd$var$_temp2(data_0) {
    return data_0.movePageAppend;
}
function $49c0c7f1efa9aabd$var$_temp3(data_1) {
    return data_1.movePageTopLevel;
}
function $49c0c7f1efa9aabd$var$_temp4(data_2) {
    return data_2.movePageAfter;
}
function $49c0c7f1efa9aabd$var$_temp5(data_3) {
    return data_3.movePageBefore;
}
module.exports["useMovePageHandler"] = $49c0c7f1efa9aabd$export$6dd12ebb9a442472;

});

parcelRegister("88DkZ", function(module, exports) {
const $641409054108cb84$export$65f8db878a2225f1 = ({ source: source, contentStatus: contentStatus, pageId: pageId, previousParentPageId: previousParentPageId, newParentPageId: newParentPageId, previousSpaceId: previousSpaceId, newSpaceId: newSpaceId, referrer: referrer, isLivePage: isLivePage, isOnEditRoute: isOnEditRoute, instructionType: instructionType, isAmnPage: isAmnPage = false })=>({
        type: 'sendTrackEvent',
        data: {
            action: 'updated',
            source: source,
            containerType: 'space',
            containerId: previousSpaceId,
            objectType: 'page',
            objectId: pageId,
            actionSubject: 'page',
            attributes: {
                contentStatus: contentStatus ?? null,
                previousSpaceId: previousSpaceId,
                previousParentPageId: previousParentPageId,
                newSpaceId: newSpaceId,
                newParentPageId: newParentPageId,
                ...referrer ? {
                    referrer: referrer
                } : undefined,
                isLivePage: isLivePage,
                isOnEditRoute: isOnEditRoute,
                instructionType: instructionType,
                isAmnPage: isAmnPage
            }
        }
    });
const $641409054108cb84$export$2077471dee1c6ca0 = ()=>({
        type: 'sendUIEvent',
        data: {
            action: 'dragged',
            actionSubject: 'pageTree',
            source: 'viewPageScreen'
        }
    });
const $641409054108cb84$export$231aa440646a5d8b = (isValidTarget)=>({
        type: 'sendUIEvent',
        data: {
            action: 'dropped',
            actionSubject: 'pageTree',
            source: 'viewPageScreen',
            attributes: {
                isValidTarget: isValidTarget
            }
        }
    });
const $641409054108cb84$export$ab5b8960d8c25b71 = ()=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'pageTreeDragDropUndo',
            source: 'viewPageScreen'
        }
    });
const $641409054108cb84$export$c10d8b9fe448cd40 = ()=>({
        type: 'sendUIEvent',
        data: {
            action: 'pressed',
            actionSubject: 'keyboardShortcut',
            actionSubjectId: 'pageTreeDragDropUndo',
            source: 'viewPageScreen'
        }
    });
const $641409054108cb84$export$aa83874b4391f46b = (action, spaceId, isInDrawer, status, contentId, contentType, navdexPointType, isOnEditRoute, contentTreeSize, spaceKey)=>{
    const event = {
        type: 'sendUIEvent',
        data: {
            containerType: 'space',
            containerId: spaceId,
            objectType: contentType ?? 'page',
            objectId: contentId ?? '',
            action: action,
            actionSubject: 'pageTree',
            source: isInDrawer ? 'pageTreeDrawer' : 'containerNavigation',
            attributes: {
                navigationLayer: 'container',
                navigationContainer: 'sidebar',
                spaceView: 'TREE',
                contentStatus: status ?? null,
                isOnEditRoute: // status/contentStatus is used to distinguish published page vs draft when clicking on a page tree item
                isOnEditRoute,
                contentTreeSize: contentTreeSize,
                navVersion: '4',
                spaceKey: spaceKey
            }
        }
    };
    if (navdexPointType) event.data.attributes['navdexPointType'] = navdexPointType;
    return event;
};
const $641409054108cb84$export$6606cf45794cc2de = (spaceId, pageCount, source, direction)=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            containerId: spaceId,
            actionSubject: 'button',
            actionSubjectId: 'showAllButton',
            source: source || 'containerNavigation',
            attributes: {
                pageCount: pageCount,
                direction: direction
            }
        }
    });
const $641409054108cb84$export$dd155dee114de315 = (oneOnOnePagesCount, totalPagesCount, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'OneOnOneTitlesShown',
            actionSubject: 'pageTree',
            actionSubjectId: 'OneOnOneTitles',
            source: 'containerNavigation',
            containerType: 'space',
            containerId: spaceId,
            attributes: {
                oneOnOnePagesCount: oneOnOnePagesCount,
                totalPagesCount: totalPagesCount
            }
        }
    });
module.exports["dragDropEndTrackEvent"] = $641409054108cb84$export$65f8db878a2225f1;
module.exports["dragStartUIEvent"] = $641409054108cb84$export$2077471dee1c6ca0;
module.exports["dragEndUIEvent"] = $641409054108cb84$export$231aa440646a5d8b;
module.exports["undoClickUIEvent"] = $641409054108cb84$export$ab5b8960d8c25b71;
module.exports["undoShortcutUIEvent"] = $641409054108cb84$export$c10d8b9fe448cd40;
module.exports["pageTreeUIAnalytics"] = $641409054108cb84$export$aa83874b4391f46b;
module.exports["pageTreePaginationEvent"] = $641409054108cb84$export$6606cf45794cc2de;
module.exports["oneOnOnePagesDetectedEvent"] = $641409054108cb84$export$dd155dee114de315;

});

parcelRegister("6FfmH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iXCQx = parcelRequire("iXCQx");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $aXWIB = parcelRequire("aXWIB");

const $66e892a19b0f4c22$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    noCreatePermissionsErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.no-create-permissions-error.title",
        defaultMessage: "You can\u2019t move this content"
    },
    noCreatePermissionsErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.no-create-permissions-error.description",
        defaultMessage: "To move content to another space, you need permission to create in that space."
    },
    permissionsErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.permissions-error.title",
        defaultMessage: "You don\u2019t have permission to move this content"
    },
    permissionsErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.permissions-error.description",
        defaultMessage: "Contact a space admin to get the content moved or to give you the permissions you need."
    },
    parentChildLoopErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.parent-child-loop.title",
        defaultMessage: "Select a different destination"
    },
    parentChildLoopErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.parent-child-loop.description",
        defaultMessage: "The destination cannot be nested below the content being moved."
    },
    singleConflictingContentNameErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name.title",
        defaultMessage: "Content with this title already exists"
    },
    singleConflictingContentNameErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name.description",
        defaultMessage: "<strong>{conflictingPageName}</strong> already exists in the {destinationSpace} space. Rename your content before moving."
    },
    singleConflictingPageNameWithinEditorErrorCallToAction: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.call-to-action",
        defaultMessage: "Rename this page"
    },
    singleConflictingLivePageNameWithinEditorErrorCallToAction: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-live-page-name-within-editor.call-to-action",
        defaultMessage: "Rename this doc"
    },
    singleConflictingPageNameWithinEditorErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.title",
        defaultMessage: "Rename this page to make it unique"
    },
    singleConflictingLivePageNameWithinEditorErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-live-page-name-within-editor.title",
        defaultMessage: "Rename this doc to make it unique"
    },
    singleConflictingPageNameWithinEditorErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.description",
        defaultMessage: "A page titled <strong>{conflictingPageName}</strong> already exists in the {destinationSpace} space. To move this page, you\u2019ll first need to give it a unique title and publish it."
    },
    singleConflictingLivePageNameWithinEditorErrorDescription: {
        id: "page-tree.move-page-dialog.live-page.move-error.single-conflicting-page-name-within-editor.description",
        defaultMessage: "There\u2019s already a page named <strong>{conflictingPageName}</strong> in {destinationSpace}. Give this page a unique title to move it."
    },
    singleConflictingLiveDocNameWithinEditorErrorDescription: {
        id: "page-tree.move-page-dialog.live-doc.move-error.single-conflicting-page-name-within-editor.description",
        defaultMessage: "There\u2019s already a live doc named <strong>{conflictingPageName}</strong> in {destinationSpace}. Give this doc a unique title to move it."
    },
    multipleConflictingContentNamesErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.multiple-conflicting-page-name.title",
        defaultMessage: "Content with these names already exist"
    },
    multipleConflictingContentNamesErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.multiple-conflicting-page-name.description",
        defaultMessage: "The following content already exists in the {destinationSpace} space: {listOfConflictingNames}. Rename your content before moving."
    },
    restrictionsPermissionErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.no-restrictions-permissions.title",
        defaultMessage: "You can\u2019t move restricted content to this space"
    },
    restrictionsPermissionErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.no-restrictions-permissions.description",
        defaultMessage: "This content is restricted, and you don\u2019t have permission to create restricted content in the new space. Remove restrictions before moving it."
    },
    destinationDoesNotExistErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.destination-does-not-exist.title",
        defaultMessage: "Select a different destination"
    },
    destinationDoesNotExistErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.destination-does-not-exist.description",
        defaultMessage: "This destination has recently been deleted or archived. Please select a different destination."
    },
    sourceDoesNotExistErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.source-does-not-exist.title",
        defaultMessage: "This content can\u2019t be moved"
    },
    sourceDoesNotExistErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.source-does-not-exist.description",
        defaultMessage: "This content has recently been deleted or archived and therefore cannot be moved."
    },
    draftPermissionsErrorTitle: {
        id: "page-tree.move-page-dialog.draft-page.move-error.default.title",
        defaultMessage: "You can\u2019t move this content"
    },
    draftPermissionsErrorDescription: {
        id: "page-tree.move-page-dialog.draft-page.move-error.default.description",
        defaultMessage: "Only the owner can move a draft to another space. Contact them or a space admin for help."
    },
    draftWithChildrenErrorTitle: {
        id: "page-tree.move-page-dialog.draft-page.children.move-error.default.title",
        defaultMessage: "You can\u2019t move this content"
    },
    draftWithChildrenErrorDescription: {
        id: "page-tree.move-page-dialog.draft-page.children.move-error.default.description",
        defaultMessage: "This draft has children and cannot be moved to another space. Move them first to relocate this draft or contact a space admin for help."
    },
    defaultErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.default.title",
        defaultMessage: "We\u2019re having issues moving this content"
    },
    defaultErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.default.description",
        defaultMessage: "We\u2019re having issues moving this content. Refresh and try again; if that doesn\u2019t solve the issue, please contact support."
    },
    tooManyPagesErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.too-many-pages.title",
        defaultMessage: "We couldn\u2019t move this many items at once."
    },
    tooManyPagesErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.too-many-pages.description",
        defaultMessage: "Try again by selecting an item with fewer child items."
    },
    moreThan100PagesErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.more-than-hundred-pages.title",
        defaultMessage: "We couldn\u2019t move this many items at once."
    },
    moreThan100PagesErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.more-than-hundred-pages.description",
        defaultMessage: "Try again by selecting an item with fewer than 100 child items."
    },
    movingContentToSelfErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.source-same-as-target.title",
        defaultMessage: "You can\u2019t move any content to a position relative to itself"
    },
    movingContentToSelfErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.source-same-as-target.description",
        defaultMessage: "Uh, oh! You are attempting to move content to itself. Please choose other content you wish to move to."
    },
    currentlyUpdatedErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.currently-updated.title",
        defaultMessage: "We can\u2019t move this content right now"
    },
    currentlyUpdatedErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.currently-updated.description",
        defaultMessage: "Someone just updated this content. Refresh and try moving it again."
    },
    partiallyMovedErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.partially-moved.title",
        defaultMessage: "The move could not be fully completed"
    },
    partiallyMovedErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.partially-moved.description",
        defaultMessage: "Some of the content was not able to be moved to the target space. If you have trouble finding any content, please reach out to Support for help."
    },
    notSpaceAdminForCrossSpaceMoveTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.not-space-admin-cross-space.title",
        defaultMessage: "You can\u2019t move this content"
    },
    notSpaceAdminForCrossSpaceMoveDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.not-space-admin-cross-space.description",
        defaultMessage: "Only space admins can move content to another space. Contact your admin for help."
    }
});


const $0deb5c3dbfed5cc8$var$isConflictingPageNameError = (errorMessage)=>{
    return (errorMessage.includes('A page with the name(s)') || errorMessage.includes('A content with the name(s)')) && errorMessage.includes('already exist(s) in the space');
};
const $0deb5c3dbfed5cc8$var$convertToCommaSeparatedString = (listOfPageNames)=>{
    if (listOfPageNames.length === 2) return listOfPageNames.join(' and ');
    else if (listOfPageNames.length > 2) return `${listOfPageNames.slice(0, listOfPageNames.length - 1).join(', ')}, and ${listOfPageNames[listOfPageNames.length - 1]}`;
    return listOfPageNames.join(', ');
};
const $0deb5c3dbfed5cc8$var$getErrorMessageForConflictingPageNamesError = (errorMessage, IsInEditor, onActionClick, isLivePage)=>{
    let firstPartOfMessage = 'A page with the name(s) ';
    const middlePartOfMessage = ' already exist(s) in the space ';
    let lastPartOfMessage = '. You must rename the page title before moving it.';
    if (errorMessage.indexOf(firstPartOfMessage) === -1) {
        firstPartOfMessage = 'A content with the name(s) ';
        lastPartOfMessage = '. You must rename the content title before moving it.';
    }
    const listOfConflictingNames = errorMessage.substring(errorMessage.indexOf(firstPartOfMessage) + firstPartOfMessage.length, errorMessage.indexOf(middlePartOfMessage)).split(',');
    const destinationSpace = errorMessage.substring(errorMessage.indexOf(middlePartOfMessage) + middlePartOfMessage.length, errorMessage.indexOf(lastPartOfMessage));
    if (listOfConflictingNames.length === 1) {
        const conflictingPageNameWithinEditorErrorTitle = isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingLivePageNameWithinEditorErrorTitle : (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingPageNameWithinEditorErrorTitle;
        // Show different messages depending on whether the move page dialog is triggered from within the editor or outside of it
        const title = IsInEditor ? conflictingPageNameWithinEditorErrorTitle : (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingContentNameErrorTitle;
        let description;
        if (isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in')) description = (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingLiveDocNameWithinEditorErrorDescription;
        else if (isLivePage) description = (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingLivePageNameWithinEditorErrorDescription;
        else if (IsInEditor) description = (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingPageNameWithinEditorErrorDescription;
        else description = (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingContentNameErrorDescription;
        const actions = {
            ...IsInEditor && {
                actions: [
                    {
                        key: 'move-page-error-error-cta',
                        text: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingLivePageNameWithinEditorErrorCallToAction : (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).singleConflictingPageNameWithinEditorErrorCallToAction,
                        onClick: onActionClick
                    }
                ]
            }
        };
        return {
            title: title,
            description: description,
            props: {
                values: {
                    conflictingPageName: listOfConflictingNames[0],
                    destinationSpace: destinationSpace,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                            as: "strong"
                        }, chunks)
                }
            },
            ...actions
        };
    } else return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).multipleConflictingContentNamesErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).multipleConflictingContentNamesErrorDescription,
        props: {
            values: {
                listOfConflictingNames: $0deb5c3dbfed5cc8$var$convertToCommaSeparatedString(listOfConflictingNames),
                destinationSpace: destinationSpace
            }
        }
    };
};
const $0deb5c3dbfed5cc8$var$isRestrictionsPermissionError = (errorMessage)=>{
    return errorMessage.includes('You can not restrict pages in the destination space.') || errorMessage.includes('You can not restrict contents in the destination space.');
};
const $0deb5c3dbfed5cc8$var$cannotMoveDraftError = (errorMessage)=>{
    return errorMessage.includes('You do not have permission to move this draft to another space.');
};
const $0deb5c3dbfed5cc8$var$cannotMoveDraftWithChildrenError = (errorMessage)=>{
    return errorMessage.includes('You cannot move a draft with children to another space without space admin permission.');
};
const $0deb5c3dbfed5cc8$var$isNotSpaceAdminForCrossSpaceMoveError = (errorMessage)=>{
    return errorMessage.includes('Only space admins can move content to another space.');
};
const $0deb5c3dbfed5cc8$var$lacksManageContentOperationError = (errorMessage)=>{
    return errorMessage.includes('Only users who can manage content can move content to another space.');
};
// isTargetSameasSource and isParentChildLoop are the same error, but the api either returns 400/500.
const $0deb5c3dbfed5cc8$var$isParentChildLoopError = (errorMessage)=>{
    return errorMessage.includes('creates a parent-child loop');
};
const $0deb5c3dbfed5cc8$var$isTargetSameAsSourceError = (errorMessage)=>{
    return errorMessage.includes('Can not set page as its own parent.');
};
const $0deb5c3dbfed5cc8$var$isDestinationNonexistantError = (errorMessage)=>{
    return errorMessage.includes('The target page provided does not exist.') || errorMessage.includes('The target content provided does not exist.') || (errorMessage.includes('The target page with ID = ') || errorMessage.includes('The target content with ID = ')) && errorMessage.includes('is archived');
};
const $0deb5c3dbfed5cc8$var$isSourceNonexistantError = (errorMessage)=>{
    return errorMessage.includes('The source page provided does not exist.') || errorMessage.includes('The source content provided does not exist.') || (errorMessage.includes('The source page with ID = ') || errorMessage.includes('The source content with ID =')) && errorMessage.includes('is archived');
};
const $0deb5c3dbfed5cc8$var$isCurrentlyUpdatedError = (errorMessage)=>errorMessage.includes('UnexpectedRollbackException');
const $0deb5c3dbfed5cc8$var$isMovingTooManyPagesError = (errorMessage)=>errorMessage.includes("We can't support moving this many pages at this time");
const $0deb5c3dbfed5cc8$var$isMovingMoreThan100PagesError = (errorMessage)=>errorMessage.includes("We can't support moving more than 100 pages at this time");
const $0deb5c3dbfed5cc8$var$isAttemptingToMoveContentToSelf = (errorMessage)=>errorMessage.includes('Invalid to perform any move operation where source is same as target');
const $0deb5c3dbfed5cc8$var$isPartiallyMovedError = (errorMessage)=>errorMessage.includes("Can't add a parent from another space");
const $0deb5c3dbfed5cc8$var$getI18nMessageForKnown400Error = (errorMessage, IsInEditor, onActionClick, isLivePage)=>{
    if ($0deb5c3dbfed5cc8$var$isConflictingPageNameError(errorMessage)) return $0deb5c3dbfed5cc8$var$getErrorMessageForConflictingPageNamesError(errorMessage, IsInEditor, onActionClick, isLivePage);
    else if ($0deb5c3dbfed5cc8$var$isAttemptingToMoveContentToSelf(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).movingContentToSelfErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).movingContentToSelfErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isParentChildLoopError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).parentChildLoopErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).parentChildLoopErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isRestrictionsPermissionError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).restrictionsPermissionErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).restrictionsPermissionErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isMovingMoreThan100PagesError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).moreThan100PagesErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).moreThan100PagesErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isMovingTooManyPagesError(errorMessage)) // This was previously a configurable limit, but the blanket 100-page limit (isMovingMoreThan100PagesError)
    // has been added behind a feature gate on the backend. Thus, this branch is still needed
    return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).tooManyPagesErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).tooManyPagesErrorDescription
    };
    return undefined;
};
const $0deb5c3dbfed5cc8$var$getI18nMessageForKnown500Error = (errorMessage)=>{
    if ($0deb5c3dbfed5cc8$var$isTargetSameAsSourceError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).parentChildLoopErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).parentChildLoopErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isCurrentlyUpdatedError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).currentlyUpdatedErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).currentlyUpdatedErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isPartiallyMovedError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).partiallyMovedErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).partiallyMovedErrorDescription
    };
    return undefined;
};
const $0deb5c3dbfed5cc8$var$getI18nMessageForKnown404Error = (errorMessage)=>{
    if ($0deb5c3dbfed5cc8$var$isDestinationNonexistantError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).destinationDoesNotExistErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).destinationDoesNotExistErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isSourceNonexistantError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).sourceDoesNotExistErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).sourceDoesNotExistErrorDescription
    };
    return undefined;
};
const $0deb5c3dbfed5cc8$var$getI18nMessageForKnown403Error = (errorMessage)=>{
    if ($0deb5c3dbfed5cc8$var$cannotMoveDraftError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).draftPermissionsErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).draftPermissionsErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$cannotMoveDraftWithChildrenError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).draftWithChildrenErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).draftWithChildrenErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isNotSpaceAdminForCrossSpaceMoveError(errorMessage) || $0deb5c3dbfed5cc8$var$lacksManageContentOperationError(errorMessage)) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).notSpaceAdminForCrossSpaceMoveTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).notSpaceAdminForCrossSpaceMoveDescription
    };
    else return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).permissionsErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).permissionsErrorDescription
    };
};
const $0deb5c3dbfed5cc8$export$b39266804fdbfd96 = (error, { IsInEditor: IsInEditor = false, onActionClick: onActionClick = ()=>{}, isLivePage: isLivePage = false } = {})=>{
    const graphQLError = error?.graphQLErrors?.[0];
    const errorStatus = (0, $aMcHK.getStatusCode)(graphQLError);
    const errorMessage = graphQLError?.message;
    if (errorStatus === '400') return $0deb5c3dbfed5cc8$var$getI18nMessageForKnown400Error(errorMessage, IsInEditor, onActionClick, isLivePage);
    else if (errorStatus === '403') return $0deb5c3dbfed5cc8$var$getI18nMessageForKnown403Error(errorMessage);
    else if (errorStatus === '404') return $0deb5c3dbfed5cc8$var$getI18nMessageForKnown404Error(errorMessage);
    else if (errorStatus === '500') return $0deb5c3dbfed5cc8$var$getI18nMessageForKnown500Error(errorMessage);
    return undefined;
};
const $0deb5c3dbfed5cc8$export$d09796ea79b340a2 = (error, childPagesCount)=>{
    if ((0, $aMcHK.isStatusCodeError)(error, '503') && childPagesCount >= 500) return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).tooManyPagesErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).tooManyPagesErrorDescription
    };
    return {
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).defaultErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).defaultErrorDescription
    };
};
const $0deb5c3dbfed5cc8$export$baffa2cd9ca4747d = ()=>({
        title: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).noCreatePermissionsErrorTitle,
        description: (0, $66e892a19b0f4c22$export$a7357cdd1f0b0168).noCreatePermissionsErrorDescription
    });
module.exports["getI18nMessageForKnownError"] = $0deb5c3dbfed5cc8$export$b39266804fdbfd96;
module.exports["getI18nMessageForUnknownError"] = $0deb5c3dbfed5cc8$export$d09796ea79b340a2;
module.exports["getI18nMessageForNoCreatePermissions"] = $0deb5c3dbfed5cc8$export$baffa2cd9ca4747d;

});

parcelRegister("cdzEA", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $6R5uz = parcelRequire("6R5uz");


var $8aNCk = parcelRequire("8aNCk");


var $bTdbD = parcelRequire("bTdbD");


var $e66a9 = parcelRequire("e66a9");


var $3aAh8 = parcelRequire("3aAh8");

const $2d6a24440faf3c46$var$i18n = (0, $aXWIB.defineMessages)({
    childrenCountText: {
        id: "page-tree.children-count-plural",
        defaultMessage: "{count, plural,\n      one { includes # child }\n      other { includes # children }\n    }"
    },
    untitledDraftText: {
        id: "page-tree.move-dialog.untitled-draft",
        defaultMessage: "Untitled"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2d6a24440faf3c46$var$DragPreviewContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isMovePageDialog: isMovePageDialog, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4lere _2rkofajl _11q7hp5a _1pxwftgi _1e0c1txw _4cvr1h6o _vchhusvi _1bah1yb4",
            __cmplp.isMovePageDialog ? "_1bsbkbql" : "_1bsbdlvw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2d6a24440faf3c46$var$BeforeIcon = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1tcg _4t3i1tcg _1bah1h6o _4cvr1h6o _2hwxze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2d6a24440faf3c46$var$TitleWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2d6a24440faf3c46$var$ChildrenCountContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _18u019bv",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2d6a24440faf3c46$export$905ab40ac2179daa = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { item: item, type: type, childPagesCount: childPagesCount } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($2d6a24440faf3c46$var$i18n.untitledDraftText);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const draftText = t1;
    const isMovePageDialog = type === "move-page-tree";
    const isLive = !!(item?.data?.subType === "live");
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e66a9))), {
            label: ""
        });
        $[2] = t2;
    } else t2 = $[2];
    let beforeIcon = t2;
    if (isMovePageDialog) {
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8aNCk))), {
                label: "",
                color: "var(--ds-icon, #292A2E)"
            });
            $[3] = t3;
        } else t3 = $[3];
        beforeIcon = t3;
    } else if (item.hasChildren || item.data.type === "folder") {
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                label: "",
                size: "small"
            });
            $[4] = t3;
        } else t3 = $[4];
        beforeIcon = t3;
    }
    let t3;
    if ($[5] !== beforeIcon) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2d6a24440faf3c46$var$BeforeIcon, null, beforeIcon);
        $[5] = beforeIcon;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== item.id) {
        t4 = item.id.toString();
        $[7] = item.id;
        $[8] = t4;
    } else t4 = $[8];
    const t5 = item.data.title || draftText;
    const t6 = item.data.status === "DRAFT";
    const t7 = !item.data.emoji ? item.data.type : undefined;
    let t8;
    if ($[9] !== isLive || $[10] !== item.data.emoji || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2d6a24440faf3c46$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3aAh8.PageTreeItemContent), {
            id: t4,
            displayHomePageIcon: false,
            displayEmoji: item.data.emoji,
            displayTitle: t5,
            isDraft: t6,
            contentType: t7,
            draggableState: "idle",
            isSelected: false,
            isLive: isLive
        }));
        $[9] = isLive;
        $[10] = item.data.emoji;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== childPagesCount) {
        t9 = !!childPagesCount && childPagesCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2d6a24440faf3c46$var$ChildrenCountContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTdbD))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$2d6a24440faf3c46$var$i18n.childrenCountText,
            values: {
                count: childPagesCount
            }
        }));
        $[16] = childPagesCount;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== isMovePageDialog || $[19] !== t3 || $[20] !== t8 || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2d6a24440faf3c46$var$DragPreviewContainer, {
            isMovePageDialog: isMovePageDialog
        }, t3, t8, t9);
        $[18] = isMovePageDialog;
        $[19] = t3;
        $[20] = t8;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
};
module.exports["DragPreview"] = $2d6a24440faf3c46$export$905ab40ac2179daa;

});

parcelRegister("3aAh8", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $7gpC4 = parcelRequire("7gpC4");


var $fT2ta = parcelRequire("fT2ta");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");


var $di8q4 = parcelRequire("di8q4");


var $jlIaF = parcelRequire("jlIaF");


var $4K4h4 = parcelRequire("4K4h4");


var $6bZDi = parcelRequire("6bZDi");


var $huWyw = parcelRequire("huWyw");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $9wGTI = parcelRequire("9wGTI");


var $kSPGK = parcelRequire("kSPGK");


var $9eE57 = parcelRequire("9eE57");


var $dYA5q = parcelRequire("dYA5q");


var $hXDOc = parcelRequire("hXDOc");


var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");


var $7aRa9 = parcelRequire("7aRa9");


var $3qtLb = parcelRequire("3qtLb");


var $g0MxG = parcelRequire("g0MxG");








var $6p02T = parcelRequire("6p02T");










const $17e4300d7b59a3d4$export$6c94635022fac1d1 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, title: title, isQuickActionsOpen: isQuickActionsOpen } = t0;
    const t1 = !isQuickActionsOpen && title ? title : null;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t1,
            position: "top",
            delay: 750,
            hideTooltipOnMouseDown: true
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};


const $2703b103d1a678c3$export$cba03ec732da70ea = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn, children: children, title: title, isQuickActionsOpen: isQuickActionsOpen } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isHoverPageCardOptedIn || $[2] !== isQuickActionsOpen || $[3] !== title) {
        t1 = isHoverPageCardOptedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $17e4300d7b59a3d4$export$6c94635022fac1d1), {
            title: (0, $6p02T.cleanExcerpt)(title),
            isQuickActionsOpen: isQuickActionsOpen
        }, children);
        $[0] = children;
        $[1] = isHoverPageCardOptedIn;
        $[2] = isQuickActionsOpen;
        $[3] = title;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};



var $hySOz = parcelRequire("hySOz");


var $jmjWc = parcelRequire("jmjWc");


const $283076e3bd0fbc90$export$eb28ea972995380e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "eczdW",
    name: "HomepageIcon",
    loader: async ()=>(await (parcelRequire("2gltw"))).HomepageIcon
});






const $d246470bc74a0a93$export$86b665ce7b1d6912 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gunMb",
    name: "DraftLozenge",
    loader: async ()=>(await (parcelRequire("3BpiD"))).DraftLozenge
});



var $lkcsM = parcelRequire("lkcsM");


var $8Yfbq = parcelRequire("8Yfbq");





var $inPa6 = parcelRequire("inPa6");





var $1xpoY = parcelRequire("1xpoY");


var $7W8i8 = parcelRequire("7W8i8");




const $20fcf3acba16c07e$export$2920b0197981d122 = 500;


const $f78f73101da794dc$var$logger = (0, $7W8i8.getLogger)('predictLeaveProbability');
// NOTE: while model should (and will) be fetched from Statsig, we need to have a default model
// to avoid errors when the model is not available or buggy. The default model is based on the
// data collected from mouse tracing on Hello over about 4 hours.
const $f78f73101da794dc$var$defaultModel = {
    version: 'default',
    distanceWeight: 0.106,
    speedWeight: 0.072,
    xRangeWeight: 0.095,
    yRangeWeight: 0.048,
    threshold: 0.5,
    stats: {
        distance: {
            mean: 21.22,
            stdDev: 30.59
        },
        speed: {
            mean: 0.14,
            stdDev: 0.21
        },
        xRange: {
            mean: 15.13,
            stdDev: 30.61
        },
        yRange: {
            mean: 8.52,
            stdDev: 5.62
        }
    }
};
const $f78f73101da794dc$var$calculateDistance = (p1, p2)=>{
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
};
function $f78f73101da794dc$var$normalizeFeatures(features, stats) {
    return {
        distance: (features.distance - stats.distance.mean) / stats.distance.stdDev,
        speed: (features.speed - stats.speed.mean) / stats.speed.stdDev,
        xRange: (features.xRange - stats.xRange.mean) / stats.xRange.stdDev,
        yRange: (features.yRange - stats.yRange.mean) / stats.yRange.stdDev
    };
}
const $f78f73101da794dc$var$extractEarlyTraceFeatures = (trace, threshold = (0, $20fcf3acba16c07e$export$2920b0197981d122))=>{
    const earlyPoints = trace.filter((p)=>p.t <= threshold);
    if (earlyPoints.length < 2) return null;
    let totalDistance = 0;
    for(let i = 1; i < earlyPoints.length; i++)totalDistance += $f78f73101da794dc$var$calculateDistance(earlyPoints[i - 1], earlyPoints[i]);
    const timeSpan = earlyPoints[earlyPoints.length - 1].t - earlyPoints[0].t;
    const avgSpeed = timeSpan !== 0 ? totalDistance / timeSpan : 0;
    const xValues = earlyPoints.map((p)=>p.x);
    const yValues = earlyPoints.map((p)=>p.y);
    const xRange = Math.max(...xValues) - Math.min(...xValues);
    const yRange = Math.max(...yValues) - Math.min(...yValues);
    const result = {
        distance: totalDistance,
        speed: avgSpeed,
        xRange: xRange,
        yRange: yRange
    };
    return result;
};
const $f78f73101da794dc$export$9d678332e6ba0864 = (trace)=>{
    const modelStr = (0, $1xpoY.default).getString('confluence-delayed-preload-model', '');
    let model = $f78f73101da794dc$var$defaultModel;
    try {
        model = JSON.parse(modelStr);
    } catch (error) {
        $f78f73101da794dc$var$logger.debug`Error parsing model - ${error}`;
    }
    const result = {
        version: model.version,
        leaveProbability: 0.5
    };
    try {
        const features = $f78f73101da794dc$var$extractEarlyTraceFeatures(trace);
        if (!features) return result;
        const normalizedFeatures = $f78f73101da794dc$var$normalizeFeatures(features, model.stats);
        const score = normalizedFeatures.distance * model.distanceWeight + normalizedFeatures.speed * model.speedWeight + normalizedFeatures.xRange * model.xRangeWeight + normalizedFeatures.yRange * model.yRangeWeight;
        // Convert to probability using sigmoid function
        result.leaveProbability = 1 / (1 + Math.exp(-score));
    } catch (error) {
        $f78f73101da794dc$var$logger.debug`Error predicting leave probability - ${error}`;
    }
    return result;
};


const $80f3b2a1ed983d07$var$sendAnalyticsEvent = (createAnalyticsEvent, action, itemId, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'pageTree',
            actionSubjectId: itemId,
            source: 'pageTree',
            attributes: attributes
        }
    }).fire();
};
const $80f3b2a1ed983d07$var$toMouseTraceString = (mouseTrace)=>{
    return mouseTrace.entries.map(({ x: x, y: y, t: t })=>`(${Math.round(x)}|${Math.round(y)}|${Math.round(t)})`).join('-');
};
// For now this will only collect user's mouse movements compared to the initial target element
// and log them in the following format: (x|y|t)-(x|y|t)-... so later we can TRY using this data
// to determine if the user is intended to click on the page tree item.
const $80f3b2a1ed983d07$var$isUserIntendedToClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))((event, targetRect, mouseTrace, preloadTimeout)=>{
    if (!targetRect) return true;
    const x = event.clientX - targetRect.left;
    const y = event.clientY - targetRect.top;
    const t = performance.now() - mouseTrace.timestamp;
    mouseTrace.entries.push({
        x: x,
        y: y,
        t: t
    });
    // We don't want to store too much data in the mouse trace, so we limit it to 200 entries,
    // the number of entries is arbitrary, but hopefully should be enough to determine if the
    // user is intended to click on the page tree item.
    if (mouseTrace.entries.length > 200) mouseTrace.entries.shift();
    // Evaluate the probability of the user leaving the element after the preload timeout
    if (mouseTrace.leaveProbability === undefined && t > preloadTimeout) {
        const result = (0, $f78f73101da794dc$export$9d678332e6ba0864)(mouseTrace.entries);
        mouseTrace.leaveProbability = result.leaveProbability;
        mouseTrace.modelVersion = result.version;
    }
    return true;
}, 17);
const $80f3b2a1ed983d07$export$e30b04a35ab95455 = ({ itemId: itemId, isLive: isLive, contentType: contentType, isSelected: isSelected })=>{
    const preloadTimeout = (0, $1xpoY.default).getNumber('confluence-delayed-preload-timeout', 500);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const preloadAndLeaveRef = (0, $42omo.useRef)(false);
    const interactionTimeRef = (0, $42omo.useRef)(0);
    const hoverTimeoutRef = (0, $42omo.useRef)(undefined);
    const mouseTraceRef = (0, $42omo.useRef)({
        entries: [],
        timestamp: performance.now()
    });
    const targetRectRef = (0, $42omo.useRef)(undefined);
    const onPreloadMouseEnter = (0, $42omo.useCallback)((event)=>{
        if (isSelected || !(0, $9wGTI.fg)('confluence-delayed-preload-hover')) return;
        targetRectRef.current = event.target.getBoundingClientRect();
        mouseTraceRef.current = {
            entries: [],
            timestamp: performance.now()
        };
        preloadAndLeaveRef.current = false;
        interactionTimeRef.current = performance.now();
        hoverTimeoutRef.current = setTimeout(()=>{
            preloadAndLeaveRef.current = true;
        // NO-OP: with this we just measure user behavior, not actually preload the page yet
        }, preloadTimeout);
    }, // NOTE: dependency list is intentional, as future preloading function will depend on these values
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        itemId,
        isLive,
        contentType,
        isSelected
    ]);
    const onPreloadMouseLeave = (0, $42omo.useCallback)(()=>{
        if (isSelected || !(0, $9wGTI.fg)('confluence-delayed-preload-hover')) return;
        const mouseTrace = $80f3b2a1ed983d07$var$toMouseTraceString(mouseTraceRef.current);
        const modelVersion = mouseTraceRef.current.modelVersion;
        const leaveProbability = mouseTraceRef.current.leaveProbability;
        mouseTraceRef.current = {
            entries: [],
            timestamp: performance.now()
        };
        targetRectRef.current = undefined;
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = undefined;
            if (preloadAndLeaveRef.current) {
                preloadAndLeaveRef.current = false;
                // Here we want to know how many times the user has hovered over the page tree item
                // enough to start the preload, but then left without the navigation.
                $80f3b2a1ed983d07$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', itemId, {
                    isLive: isLive,
                    contentType: contentType,
                    isNav4Enabled: true,
                    preloadTimeout: preloadTimeout,
                    leaveAfter: performance.now() - interactionTimeRef.current,
                    mouseTrace: mouseTrace,
                    leaveProbability: leaveProbability,
                    modelVersion: modelVersion
                });
            }
        }
    }, [
        itemId,
        createAnalyticsEvent,
        isLive,
        contentType,
        preloadTimeout,
        isSelected
    ]);
    const onPreloadMouseDown = (0, $42omo.useCallback)(()=>{
        if (isSelected || !(0, $9wGTI.fg)('confluence-delayed-preload-hover')) return;
        const mouseTrace = $80f3b2a1ed983d07$var$toMouseTraceString(mouseTraceRef.current);
        const { leaveProbability: leaveProbability, version: version } = (0, $f78f73101da794dc$export$9d678332e6ba0864)(mouseTraceRef.current.entries);
        clearTimeout(hoverTimeoutRef.current);
        mouseTraceRef.current = {
            entries: [],
            timestamp: performance.now()
        };
        hoverTimeoutRef.current = undefined;
        preloadAndLeaveRef.current = false;
        $80f3b2a1ed983d07$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndClick', itemId, {
            isLive: isLive,
            contentType: contentType,
            isNav4Enabled: true,
            preloadTimeout: preloadTimeout,
            clickAfter: performance.now() - interactionTimeRef.current,
            mouseTrace: mouseTrace,
            leaveProbability: leaveProbability,
            modelVersion: version
        });
    }, [
        createAnalyticsEvent,
        itemId,
        isLive,
        contentType,
        preloadTimeout,
        isSelected
    ]);
    const onPreloadMouseMove = (0, $42omo.useCallback)((event)=>{
        if (isSelected || !(0, $9wGTI.fg)('confluence-delayed-preload-hover')) return;
        // If we determine that the user is not intended to click, we don't want to preload the page
        // so cancel the preloading timeout and reset the rest of the state.
        if (!$80f3b2a1ed983d07$var$isUserIntendedToClick(event, targetRectRef.current, mouseTraceRef.current, preloadTimeout)) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = undefined;
            preloadAndLeaveRef.current = false;
        }
    }, [
        isSelected,
        preloadTimeout
    ]);
    return {
        isPreloadOnDelayedHoverEnabled: (0, $9wGTI.fg)('confluence-delayed-preload-hover'),
        onPreloadMouseEnter: onPreloadMouseEnter,
        onPreloadMouseLeave: onPreloadMouseLeave,
        onPreloadMouseDown: onPreloadMouseDown,
        onPreloadMouseMove: onPreloadMouseMove
    };
};












var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $dYU3e = parcelRequire("dYU3e");


var $fqIt3 = parcelRequire("fqIt3");


var $nIvaQ = parcelRequire("nIvaQ");

/**
 * Prefetch collabDraft content into the Apollo cache for a given content ID.
 * This is a lightweight version of preloadCollabDraftContent from load-edit-page,
 * without the edit-page-specific side effects (e.g. __SMART_CARDS_IN_DRAFT__).
 */ function $0889ed5704e98880$var$prefetchCollabDraft(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    });
}
// Tracking for prefetch timing — lets us measure if/when the cache was used
// on subsequent navigation. Keyed by contentId.
const $0889ed5704e98880$var$prefetchTimestamps = {};
function $0889ed5704e98880$export$3948cdcdec3474eb(contentId) {
    const timing = $0889ed5704e98880$var$prefetchTimestamps[contentId];
    const cacheStale = (0, $fqIt3.isCollabDraftCacheStale)(contentId);
    const now = performance.now();
    if (!timing) return {
        status: 'not_prefetched',
        cacheStale: cacheStale
    };
    if (!timing.completedAt) {
        const headStartMs = now - timing.startedAt;
        return {
            status: 'in_flight',
            headStartMs: headStartMs,
            cacheStale: cacheStale
        };
    }
    const timeSincePrefetchMs = now - timing.completedAt;
    const prefetchDurationMs = timing.completedAt - timing.startedAt;
    if (cacheStale) return {
        status: 'cache_expired',
        prefetchDurationMs: prefetchDurationMs,
        timeSincePrefetchMs: timeSincePrefetchMs,
        cacheStale: cacheStale
    };
    return {
        status: 'ready',
        prefetchDurationMs: prefetchDurationMs,
        timeSincePrefetchMs: timeSincePrefetchMs,
        cacheStale: cacheStale
    };
}
function $0889ed5704e98880$export$d35410d056b9fa08(contentId) {
    const useCache = !(0, $fqIt3.isCollabDraftCacheStale)(contentId);
    $0889ed5704e98880$var$prefetchTimestamps[contentId] = {
        startedAt: performance.now()
    };
    $0889ed5704e98880$var$prefetchCollabDraft(contentId, useCache).then(()=>{
        (0, $fqIt3.markCollabDraftFetched)(contentId);
        $0889ed5704e98880$var$prefetchTimestamps[contentId].completedAt = performance.now();
    }).catch(()=>{
    // Swallow errors — this is a best-effort prefetch.
    // The real fetch on navigation will handle errors properly.
    });
}


const $7b4f28511d8385e8$export$8b4729b796915618 = (t0)=>{
    const $ = (0, $frIzR.c)(48);
    const { itemId: itemId, isLive: isLive, isDraft: isDraft, contentType: contentType } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [currentContentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (action, contentId, attributes)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: action,
                    actionSubject: "pageTreeCollabDraftPrefetch",
                    actionSubjectId: contentId,
                    source: "pageTree",
                    attributes: attributes
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const sendPrefetchAnalyticsEvent = t1;
    const isCurrentPage = itemId === currentContentId;
    const couldPrefetch = (isLive || isDraft) && !isCurrentPage;
    let t2;
    if ($[2] !== couldPrefetch) {
        t2 = couldPrefetch && (0, $6mKj3.expValEquals)("platform_editor_collabdraft_query_improvements", "isEnabled", true) && (0, $6mKj3.expValEquals)("platform_editor_prefetch_livedoc_collabdraft", "isEnabled", true);
        $[2] = couldPrefetch;
        $[3] = t2;
    } else t2 = $[3];
    const isPrefetchEnabled = t2;
    const prefetchTriggeredRef = (0, $42omo.useRef)(false);
    const prefetchTimeoutRef = (0, $42omo.useRef)(undefined);
    const interactionTimeRef = (0, $42omo.useRef)(0);
    const prefetchIdRef = (0, $42omo.useRef)(null);
    let t3;
    if ($[4] !== itemId) {
        t3 = ()=>`${itemId}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        $[4] = itemId;
        $[5] = t3;
    } else t3 = $[5];
    const generatePrefetchId = t3;
    let t4;
    if ($[6] !== contentType || $[7] !== generatePrefetchId || $[8] !== isDraft || $[9] !== isLive || $[10] !== isPrefetchEnabled || $[11] !== itemId || $[12] !== sendPrefetchAnalyticsEvent) {
        t4 = ()=>{
            if (!isPrefetchEnabled) return;
            const existingPrefetch = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
            if (existingPrefetch.status === "ready" && !existingPrefetch.cacheStale) return;
            prefetchTriggeredRef.current = false;
            interactionTimeRef.current = performance.now();
            prefetchTimeoutRef.current = setTimeout(()=>{
                prefetchTriggeredRef.current = true;
                prefetchIdRef.current = generatePrefetchId();
                (0, $0889ed5704e98880$export$d35410d056b9fa08)(itemId);
                sendPrefetchAnalyticsEvent("prefetchTriggered", itemId, {
                    prefetchId: prefetchIdRef.current,
                    isLive: isLive,
                    isDraft: isDraft,
                    contentType: contentType,
                    prefetchDelayMs: (0, $6mKj3.expVal)("platform_editor_prefetch_livedoc_collabdraft", "delayMs", 200),
                    dwellTimeMs: performance.now() - interactionTimeRef.current
                });
            }, (0, $6mKj3.expVal)("platform_editor_prefetch_livedoc_collabdraft", "delayMs", 200));
        };
        $[6] = contentType;
        $[7] = generatePrefetchId;
        $[8] = isDraft;
        $[9] = isLive;
        $[10] = isPrefetchEnabled;
        $[11] = itemId;
        $[12] = sendPrefetchAnalyticsEvent;
        $[13] = t4;
    } else t4 = $[13];
    const onPrefetchMouseEnter = t4;
    let t5;
    if ($[14] !== contentType || $[15] !== isDraft || $[16] !== isLive || $[17] !== itemId || $[18] !== sendPrefetchAnalyticsEvent) {
        t5 = ()=>{
            if (prefetchTimeoutRef.current) {
                clearTimeout(prefetchTimeoutRef.current);
                prefetchTimeoutRef.current = undefined;
            }
            if (prefetchTriggeredRef.current) {
                const prefetchInfo = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
                sendPrefetchAnalyticsEvent("prefetchUnused", itemId, {
                    prefetchId: prefetchIdRef.current,
                    isLive: isLive,
                    isDraft: isDraft,
                    contentType: contentType,
                    prefetchDelayMs: (0, $6mKj3.expVal)("platform_editor_prefetch_livedoc_collabdraft", "delayMs", 200),
                    dwellTimeMs: performance.now() - interactionTimeRef.current,
                    prefetchStatus: prefetchInfo.status,
                    prefetchDurationMs: prefetchInfo.prefetchDurationMs
                });
                prefetchTriggeredRef.current = false;
                prefetchIdRef.current = null;
            }
        };
        $[14] = contentType;
        $[15] = isDraft;
        $[16] = isLive;
        $[17] = itemId;
        $[18] = sendPrefetchAnalyticsEvent;
        $[19] = t5;
    } else t5 = $[19];
    const onPrefetchMouseLeave = t5;
    let t6;
    if ($[20] !== contentType || $[21] !== isDraft || $[22] !== isLive || $[23] !== isPrefetchEnabled || $[24] !== itemId || $[25] !== sendPrefetchAnalyticsEvent) {
        t6 = ()=>{
            prefetchTriggeredRef.current = false;
            if (prefetchTimeoutRef.current) {
                clearTimeout(prefetchTimeoutRef.current);
                prefetchTimeoutRef.current = undefined;
            }
            if (!isPrefetchEnabled) return;
            const prefetchInfo_0 = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
            sendPrefetchAnalyticsEvent("prefetchAndClick", itemId, {
                prefetchId: prefetchIdRef.current,
                isLive: isLive,
                isDraft: isDraft,
                contentType: contentType,
                prefetchDelayMs: (0, $6mKj3.expVal)("platform_editor_prefetch_livedoc_collabdraft", "delayMs", 200),
                clickAfter: performance.now() - interactionTimeRef.current,
                prefetchStatus: prefetchInfo_0.status,
                prefetchDurationMs: prefetchInfo_0.prefetchDurationMs,
                prefetchTimeSinceMs: prefetchInfo_0.timeSincePrefetchMs,
                prefetchHeadStartMs: prefetchInfo_0.headStartMs,
                prefetchCacheStale: prefetchInfo_0.cacheStale
            });
            prefetchIdRef.current = null;
        };
        $[20] = contentType;
        $[21] = isDraft;
        $[22] = isLive;
        $[23] = isPrefetchEnabled;
        $[24] = itemId;
        $[25] = sendPrefetchAnalyticsEvent;
        $[26] = t6;
    } else t6 = $[26];
    const onPrefetchMouseDown = t6;
    let t7;
    if ($[27] !== contentType || $[28] !== generatePrefetchId || $[29] !== isDraft || $[30] !== isLive || $[31] !== isPrefetchEnabled || $[32] !== itemId || $[33] !== sendPrefetchAnalyticsEvent) {
        t7 = ()=>{
            if (!isPrefetchEnabled) return;
            const existingPrefetch_0 = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
            if (existingPrefetch_0.status === "ready" && !existingPrefetch_0.cacheStale) return;
            interactionTimeRef.current = performance.now();
            prefetchTriggeredRef.current = false;
            prefetchTimeoutRef.current = setTimeout(()=>{
                prefetchTriggeredRef.current = true;
                prefetchIdRef.current = generatePrefetchId();
                (0, $0889ed5704e98880$export$d35410d056b9fa08)(itemId);
                sendPrefetchAnalyticsEvent("prefetchTriggered", itemId, {
                    prefetchId: prefetchIdRef.current,
                    isLive: isLive,
                    isDraft: isDraft,
                    contentType: contentType,
                    prefetchDelayMs: (0, $6mKj3.expVal)("platform_editor_prefetch_livedoc_collabdraft", "delayMs", 200),
                    dwellTimeMs: performance.now() - interactionTimeRef.current,
                    trigger: "focus"
                });
            }, (0, $6mKj3.expVal)("platform_editor_prefetch_livedoc_collabdraft", "delayMs", 200));
        };
        $[27] = contentType;
        $[28] = generatePrefetchId;
        $[29] = isDraft;
        $[30] = isLive;
        $[31] = isPrefetchEnabled;
        $[32] = itemId;
        $[33] = sendPrefetchAnalyticsEvent;
        $[34] = t7;
    } else t7 = $[34];
    const onPrefetchFocus = t7;
    let t8;
    if ($[35] !== contentType || $[36] !== isDraft || $[37] !== isLive || $[38] !== itemId || $[39] !== sendPrefetchAnalyticsEvent) {
        t8 = ()=>{
            if (prefetchTimeoutRef.current) {
                clearTimeout(prefetchTimeoutRef.current);
                prefetchTimeoutRef.current = undefined;
            }
            if (prefetchTriggeredRef.current) {
                const prefetchInfo_1 = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
                sendPrefetchAnalyticsEvent("prefetchUnused", itemId, {
                    prefetchId: prefetchIdRef.current,
                    isLive: isLive,
                    isDraft: isDraft,
                    contentType: contentType,
                    prefetchDelayMs: (0, $6mKj3.expVal)("platform_editor_prefetch_livedoc_collabdraft", "delayMs", 200),
                    dwellTimeMs: performance.now() - interactionTimeRef.current,
                    prefetchStatus: prefetchInfo_1.status,
                    prefetchDurationMs: prefetchInfo_1.prefetchDurationMs,
                    trigger: "blur"
                });
                prefetchTriggeredRef.current = false;
                prefetchIdRef.current = null;
            }
        };
        $[35] = contentType;
        $[36] = isDraft;
        $[37] = isLive;
        $[38] = itemId;
        $[39] = sendPrefetchAnalyticsEvent;
        $[40] = t8;
    } else t8 = $[40];
    const onPrefetchBlur = t8;
    let t9;
    if ($[41] !== isPrefetchEnabled || $[42] !== onPrefetchBlur || $[43] !== onPrefetchFocus || $[44] !== onPrefetchMouseDown || $[45] !== onPrefetchMouseEnter || $[46] !== onPrefetchMouseLeave) {
        t9 = {
            isPrefetchEnabled: isPrefetchEnabled,
            onPrefetchMouseEnter: onPrefetchMouseEnter,
            onPrefetchMouseLeave: onPrefetchMouseLeave,
            onPrefetchMouseDown: onPrefetchMouseDown,
            onPrefetchFocus: onPrefetchFocus,
            onPrefetchBlur: onPrefetchBlur
        };
        $[41] = isPrefetchEnabled;
        $[42] = onPrefetchBlur;
        $[43] = onPrefetchFocus;
        $[44] = onPrefetchMouseDown;
        $[45] = onPrefetchMouseEnter;
        $[46] = onPrefetchMouseLeave;
        $[47] = t9;
    } else t9 = $[47];
    return t9;
};



var $c4LIS = parcelRequire("c4LIS");








var $jGj7w = parcelRequire("jGj7w");

const $7e591ee26122d641$export$9fdf9590bd980095 = ()=>{
    const $ = (0, $frIzR.c)(11);
    const { deselectNestedContent: deselectNestedContent, updateTotalCount: updateTotalCount, getSelectedDescendantCount: getSelectedDescendantCount, decrementAncestors: decrementAncestors, removeLoadingDescendant: removeLoadingDescendant } = (0, $bwL2u.useContentTreeSelectionActions)();
    const { getState: getState } = (0, $jGj7w.usePageTreeActions)();
    const [t0] = (0, $bwL2u.useContentTreeSelection)();
    const { loadingDescendantIds: loadingDescendantIds } = t0;
    let t1;
    if ($[0] !== decrementAncestors || $[1] !== getState) {
        t1 = (pageTreeItem)=>{
            const { pages: pages, rootId: rootId } = getState();
            const ancestorContentIds = new Set();
            const getAncestorIds = (currItem)=>{
                const parentId = currItem.parentId;
                if (parentId && parentId != rootId) {
                    ancestorContentIds.add(currItem.parentId);
                    getAncestorIds(pages[currItem.parentId]);
                }
            };
            getAncestorIds(pageTreeItem);
            decrementAncestors([
                ...ancestorContentIds
            ], pageTreeItem.id);
        };
        $[0] = decrementAncestors;
        $[1] = getState;
        $[2] = t1;
    } else t1 = $[2];
    const decrementAncestorCount = t1;
    let t2;
    if ($[3] !== decrementAncestorCount || $[4] !== deselectNestedContent || $[5] !== getSelectedDescendantCount || $[6] !== getState || $[7] !== loadingDescendantIds || $[8] !== removeLoadingDescendant || $[9] !== updateTotalCount) {
        t2 = (itemId)=>{
            const { pages: pages_0 } = getState();
            const descendants = [];
            const pageTreeItem_0 = getState().pages[itemId];
            const selectedDescendantCount = getSelectedDescendantCount(itemId);
            decrementAncestorCount(pageTreeItem_0);
            const isLoadingDescendants = loadingDescendantIds.has(itemId);
            const traverse = (currItem_0)=>{
                descendants.push({
                    id: currItem_0.id,
                    parentId: currItem_0.parentId ?? undefined
                });
                const children = currItem_0.children || [];
                for (const childId of children){
                    const child = pages_0[childId];
                    if (child) traverse(child);
                }
            };
            traverse(pageTreeItem_0);
            deselectNestedContent(descendants.map($7e591ee26122d641$var$_temp), descendants.map($7e591ee26122d641$var$_temp2));
            if (isLoadingDescendants) removeLoadingDescendant(itemId);
            else updateTotalCount(-selectedDescendantCount - 1);
        };
        $[3] = decrementAncestorCount;
        $[4] = deselectNestedContent;
        $[5] = getSelectedDescendantCount;
        $[6] = getState;
        $[7] = loadingDescendantIds;
        $[8] = removeLoadingDescendant;
        $[9] = updateTotalCount;
        $[10] = t2;
    } else t2 = $[10];
    const deselectContentAndDescendants = t2;
    return deselectContentAndDescendants;
};
function $7e591ee26122d641$var$_temp(t0) {
    const { id: id } = t0;
    return id;
}
function $7e591ee26122d641$var$_temp2(t0) {
    const { parentId: parentId_0 } = t0;
    return parentId_0 ?? "";
}



var $7qclg = parcelRequire("7qclg");

const $f3181cddc4d39a3c$export$b128294488e41c39 = (contentType, emoji)=>{
    // Add other checks for other content types and corresponding feature flags here as they get implemented.
    if (contentType === 'whiteboard') return !!emoji && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
    if (contentType === 'page') return !!emoji;
    return false;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3181cddc4d39a3c$var$TitleWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _o5721q9c _1bto1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f3181cddc4d39a3c$var$contentIconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 'space.050',
    marginLeft: 'space.025',
    width: '24px',
    height: '24px',
    flexShrink: 0
});
const $f3181cddc4d39a3c$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_lcxvglyw _1e0c1txw _1o9zidpf _4cvr1h6o _2hwxu2gc _18u012x7 _4t3i7vkz _1bsb7vkz _bna77vkz _17527vkz _mezj7vkz _w8l57vkz",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f3181cddc4d39a3c$var$emojiWrapperStyles = null;
const $f3181cddc4d39a3c$export$b2a0cd0ad960a454 = ({ hasCoverPicture: _hasCoverPicture, isPageTitleComponent: _isPageTitleComponent, shouldRemoveEmojiLeftPadding: _shouldRemoveEmojiLeftPadding, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1mou1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _ahbq12x7 _12l2u2gc _4t3i7vkz _1bsb7vkz _1o9zidpf"
        ])
    });
};
const $f3181cddc4d39a3c$export$4d23b38ef990da69 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(36);
    const { id: id, displayHomePageIcon: displayHomePageIcon, displayEmoji: displayEmoji, displayTitle: displayTitle, isDraft: isDraft, renderResourcedEmoji: renderResourcedEmoji, contentType: contentType, isSelected: isSelected, draggableState: draggableState, emoji: emoji, isExpanded: isExpanded, isLive: isLive, isDisabled: isDisabled } = t0;
    const iconColor = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    const isDragging = draggableState === "dragging";
    const isEmojiSet = $f3181cddc4d39a3c$export$b128294488e41c39(contentType, emoji);
    let t1;
    if ($[0] !== contentType || $[1] !== isEmojiSet) {
        t1 = contentType && (0, $6bZDi.includesValidContentTreeType)(contentType) && !isEmojiSet;
        $[0] = contentType;
        $[1] = isEmojiSet;
        $[2] = t1;
    } else t1 = $[2];
    const isContentTreeIconVisible = t1;
    const isEmojiOptimized = !!emoji;
    const isEmbedWithoutEmoji = contentType === "embed" && !displayEmoji;
    const iconPrimaryColor = isDragging || isDisabled ? "var(--ds-icon-disabled, #080F214A)" : iconColor;
    const isLiveDoc = contentType === "page" && isLive;
    let t2;
    if ($[3] !== displayHomePageIcon) {
        t2 = displayHomePageIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $283076e3bd0fbc90$export$eb28ea972995380e), null) : null;
        $[3] = displayHomePageIcon;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== contentType || $[6] !== iconPrimaryColor || $[7] !== isContentTreeIconVisible || $[8] !== isExpanded || $[9] !== isLiveDoc) {
        t3 = isContentTreeIconVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: $f3181cddc4d39a3c$var$contentIconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4K4h4.ContentTreeIconLoader), {
            type: isLiveDoc && (0, $9wGTI.fg)("confluence_live_pages_open_beta_trait_opted_in") ? "liveDoc" : contentType,
            label: "",
            color: iconPrimaryColor,
            isExpanded: isExpanded
        }));
        $[5] = contentType;
        $[6] = iconPrimaryColor;
        $[7] = isContentTreeIconVisible;
        $[8] = isExpanded;
        $[9] = isLiveDoc;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== contentType || $[12] !== displayEmoji || $[13] !== emoji || $[14] !== iconPrimaryColor || $[15] !== isEmbedWithoutEmoji || $[16] !== isEmojiOptimized || $[17] !== renderResourcedEmoji) {
        t4 = (displayEmoji || isEmbedWithoutEmoji) && (isEmojiOptimized ? emoji : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
            key: displayEmoji,
            emoji: displayEmoji,
            contentType: contentType,
            context: "pageTree",
            height: 14,
            primaryColor: iconPrimaryColor,
            wrapper: $f3181cddc4d39a3c$export$e31a6cc0a4c97f0e,
            renderResourcedEmoji: renderResourcedEmoji
        }));
        $[11] = contentType;
        $[12] = displayEmoji;
        $[13] = emoji;
        $[14] = iconPrimaryColor;
        $[15] = isEmbedWithoutEmoji;
        $[16] = isEmojiOptimized;
        $[17] = renderResourcedEmoji;
        $[18] = t4;
    } else t4 = $[18];
    let t5;
    if ($[19] !== isDragging || $[20] !== isSelected) {
        t5 = $f3181cddc4d39a3c$var$getTitleTextColor(isDragging, isSelected);
        $[19] = isDragging;
        $[20] = isSelected;
        $[21] = t5;
    } else t5 = $[21];
    let t6;
    if ($[22] !== displayTitle || $[23] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "medium",
            color: t5
        }, displayTitle);
        $[22] = displayTitle;
        $[23] = t5;
        $[24] = t6;
    } else t6 = $[24];
    let t7;
    if ($[25] !== id || $[26] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f3181cddc4d39a3c$var$TitleWrapper, {
            id: id,
            className: "title"
        }, t6);
        $[25] = id;
        $[26] = t6;
        $[27] = t7;
    } else t7 = $[27];
    let t8;
    if ($[28] !== isDraft) {
        t8 = isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d246470bc74a0a93$export$86b665ce7b1d6912), null);
        $[28] = isDraft;
        $[29] = t8;
    } else t8 = $[29];
    let t9;
    if ($[30] !== t2 || $[31] !== t3 || $[32] !== t4 || $[33] !== t7 || $[34] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            as: "span",
            alignBlock: "center"
        }, t2, t3, t4, t7, t8);
        $[30] = t2;
        $[31] = t3;
        $[32] = t4;
        $[33] = t7;
        $[34] = t8;
        $[35] = t9;
    } else t9 = $[35];
    return t9;
});
const $f3181cddc4d39a3c$var$getTitleTextColor = (isDragging, isSelected)=>{
    if (isDragging) return 'color.text.disabled';
    else if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
};
const $f3181cddc4d39a3c$var$PageTreeItemComponent = (t0)=>{
    const $ = (0, $frIzR.c)(209);
    const { item: item, draftText: t1, spaceHomePageId: spaceHomePageId, onExpand: onExpand, onCollapse: onCollapse, onHighlight: onHighlight, draggableState: draggableState, isSuperAdmin: isSuperAdmin, onClick: onClick, spaceKey: spaceKey, indent: indent, dragHandleProps: dragHandleProps, isHoverPageCardOptedIn: isHoverPageCardOptedIn, closeAllHoverPageCards: closeAllHoverPageCards, isQuickActionsOpen: isQuickActionsOpen, setOpenQuickActionsId: setOpenQuickActionsId, isQuickActionsFocused: isQuickActionsFocused, setFocusedQuickActionsId: setFocusedQuickActionsId, editingTitle: editingTitle, setIsEditingTitleId: setIsEditingTitleId, onEnterHoverTarget: onEnterHoverTarget, onLeaveHoverTarget: onLeaveHoverTarget, onBlurHoverTarget: onBlurHoverTarget, isDraft: isDraft, updateSinglePage: updateSinglePage, shouldRenderAfterIcon: shouldRenderAfterIcon, contentStatus: contentStatus, renderResourcedEmoji: renderResourcedEmoji, hideDraftHrefs: hideDraftHrefs, emoji: emoji, justExpanded: justExpanded, flags: flags, renderServerPlaceholder: renderServerPlaceholder } = t0;
    const draftText = t1 === undefined ? "" : t1;
    const intl = (0, $aXWIB.useIntl)();
    const hoverPageCardTriggerRef = (0, $42omo.useRef)(null);
    const displayEmoji = item.data.emoji;
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const [t2] = (0, $bwL2u.useContentTreeSelection)();
    const { selectedContent: selectedContent } = t2;
    let t3;
    if ($[0] !== item.id) {
        t3 = item.id.toString();
        $[0] = item.id;
        $[1] = t3;
    } else t3 = $[1];
    const isChecked = t3 in selectedContent;
    let t4;
    if ($[2] !== item.id || $[3] !== updateSinglePage) {
        t4 = (_, title)=>{
            updateSinglePage(item.id, {
                title: title,
                fullTitle: title
            });
        };
        $[2] = item.id;
        $[3] = updateSinglePage;
        $[4] = t4;
    } else t4 = $[4];
    const onOptimisticUpdate = t4;
    const defaultTitle = item.data.title || draftText;
    const { optimisticTitle: optimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(item.id, defaultTitle, onOptimisticUpdate);
    const displayTitle = optimisticTitle || draftText;
    const contentType = item.data.type;
    const isHighlighted = item.data.isHighlighted;
    const selected = item.data.isSelected;
    const isLive = !!(item?.data?.subType === "live");
    let t5;
    if ($[5] !== hideDraftHrefs || $[6] !== isDraft || $[7] !== item.data.editorVersion || $[8] !== item.data.type || $[9] !== item.data.webui || $[10] !== item.id || $[11] !== spaceKey) {
        t5 = isDraft && hideDraftHrefs ? null : (0, $huWyw.getURLBypassingResumeDraftAction)({
            url: `${(0, $jlIaF.CONTEXT_PATH)}${item.data.webui}`,
            spaceKey: spaceKey,
            contentType: item.data.type,
            editorVersion: item.data.editorVersion,
            contentId: item.id
        });
        $[5] = hideDraftHrefs;
        $[6] = isDraft;
        $[7] = item.data.editorVersion;
        $[8] = item.data.type;
        $[9] = item.data.webui;
        $[10] = item.id;
        $[11] = spaceKey;
        $[12] = t5;
    } else t5 = $[12];
    const bypassHref = t5;
    let t6;
    let t7;
    if ($[13] !== isHighlighted || $[14] !== onHighlight) {
        t6 = ()=>{
            if (isHighlighted) {
                const timeoutId = setTimeout(onHighlight, (0, $3qtLb.ANIMATE_TIME_SEC) * 1000);
                return ()=>clearTimeout(timeoutId);
            }
        };
        t7 = [
            isHighlighted,
            onHighlight
        ];
        $[13] = isHighlighted;
        $[14] = onHighlight;
        $[15] = t6;
        $[16] = t7;
    } else {
        t6 = $[15];
        t7 = $[16];
    }
    (0, $42omo.useEffect)(t6, t7);
    const isExpanded = item.isExpanded;
    let t8;
    let t9;
    if ($[17] !== isExpanded || $[18] !== justExpanded) {
        t8 = ()=>{
            if (justExpanded && isExpanded) (0, $9eE57.perfMarkEnd)({
                subject: "PageTree",
                subjectId: "expandPage"
            });
        };
        t9 = [
            justExpanded,
            isExpanded
        ];
        $[17] = isExpanded;
        $[18] = justExpanded;
        $[19] = t8;
        $[20] = t9;
    } else {
        t8 = $[19];
        t9 = $[20];
    }
    (0, $42omo.useEffect)(t8, t9);
    const editingTitleId = editingTitle?.contentId;
    const isEditingTitle = editingTitleId === item.id;
    const editingTitleIsNewContent = editingTitle?.isNewContent;
    let t10;
    let t11;
    if ($[21] !== contentType || $[22] !== editingTitleIsNewContent || $[23] !== isEditingTitle || $[24] !== item.data.createdDate || $[25] !== selected) {
        t10 = ()=>{
            let isNewContent = false;
            if (editingTitleIsNewContent && isEditingTitle) isNewContent = true;
            else if (selected && item.data.createdDate) {
                const now = new Date();
                const createdDate = new Date(Number(item.data.createdDate));
                if (now.getTime() - createdDate.getTime() < 20000) isNewContent = true;
            }
            if (isNewContent) (0, $9eE57.perfMarkEnd)({
                subject: "PageTree",
                subjectId: "newContentRendered",
                details: {
                    contentType: contentType
                }
            });
        };
        t11 = [
            selected,
            item.data.createdDate,
            editingTitleIsNewContent,
            contentType,
            isEditingTitle
        ];
        $[21] = contentType;
        $[22] = editingTitleIsNewContent;
        $[23] = isEditingTitle;
        $[24] = item.data.createdDate;
        $[25] = selected;
        $[26] = t10;
        $[27] = t11;
    } else {
        t10 = $[26];
        t11 = $[27];
    }
    (0, $42omo.useEffect)(t10, t11);
    const isCursor = item.data.isCursor;
    let t12;
    let t13;
    if ($[28] !== isCursor) {
        t12 = ()=>{
            if (isCursor) (0, $9eE57.perfMarkEnd)({
                subject: "PageTree",
                subjectId: "loadMorePages"
            });
        };
        t13 = [
            isCursor
        ];
        $[28] = isCursor;
        $[29] = t12;
        $[30] = t13;
    } else {
        t12 = $[29];
        t13 = $[30];
    }
    (0, $42omo.useEffect)(t12, t13);
    const [isContextualCreateFocused, setIsContextualCreateFocused] = (0, $42omo.useState)(false);
    let t14;
    if ($[31] !== item.id) {
        t14 = item.id.toString();
        $[31] = item.id;
        $[32] = t14;
    } else t14 = $[32];
    const t15 = contentType || "page";
    const t16 = Boolean(selected);
    let t17;
    if ($[33] !== isLive || $[34] !== t14 || $[35] !== t15 || $[36] !== t16) {
        t17 = {
            itemId: t14,
            isLive: isLive,
            contentType: t15,
            isSelected: t16
        };
        $[33] = isLive;
        $[34] = t14;
        $[35] = t15;
        $[36] = t16;
        $[37] = t17;
    } else t17 = $[37];
    const { onPreloadMouseEnter: onPreloadMouseEnter, onPreloadMouseLeave: onPreloadMouseLeave, onPreloadMouseDown: onPreloadMouseDown, onPreloadMouseMove: onPreloadMouseMove, isPreloadOnDelayedHoverEnabled: isPreloadOnDelayedHoverEnabled } = (0, $80f3b2a1ed983d07$export$e30b04a35ab95455)(t17);
    let t18;
    if ($[38] !== item.id) {
        t18 = item.id.toString();
        $[38] = item.id;
        $[39] = t18;
    } else t18 = $[39];
    const t19 = contentType || "page";
    let t20;
    if ($[40] !== isDraft || $[41] !== isLive || $[42] !== t18 || $[43] !== t19) {
        t20 = {
            itemId: t18,
            isLive: isLive,
            isDraft: isDraft,
            contentType: t19
        };
        $[40] = isDraft;
        $[41] = isLive;
        $[42] = t18;
        $[43] = t19;
        $[44] = t20;
    } else t20 = $[44];
    const { onPrefetchMouseEnter: onPrefetchMouseEnter, onPrefetchMouseLeave: onPrefetchMouseLeave, onPrefetchMouseDown: onPrefetchMouseDown, onPrefetchFocus: onPrefetchFocus, onPrefetchBlur: onPrefetchBlur } = (0, $7b4f28511d8385e8$export$8b4729b796915618)(t20);
    let t21;
    if ($[45] !== contentType || $[46] !== displayEmoji || $[47] !== displayTitle || $[48] !== draggableState || $[49] !== emoji || $[50] !== isDraft || $[51] !== isLive || $[52] !== isMultiSelectActive || $[53] !== isPreloadOnDelayedHoverEnabled || $[54] !== item.id || $[55] !== item.isExpanded || $[56] !== onPrefetchBlur || $[57] !== onPrefetchFocus || $[58] !== onPreloadMouseDown || $[59] !== onPreloadMouseEnter || $[60] !== onPreloadMouseLeave || $[61] !== onPreloadMouseMove || $[62] !== renderResourcedEmoji || $[63] !== selected || $[64] !== spaceHomePageId) {
        t21 = isPreloadOnDelayedHoverEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            role: "presentation",
            onMouseEnter: onPreloadMouseEnter,
            onMouseLeave: onPreloadMouseLeave,
            onFocus: onPrefetchFocus,
            onBlur: onPrefetchBlur,
            onMouseDown: onPreloadMouseDown,
            onMouseMove: onPreloadMouseMove
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f3181cddc4d39a3c$export$4d23b38ef990da69, {
            id: item.id.toString(),
            displayHomePageIcon: item.id === spaceHomePageId,
            isDraft: isDraft,
            displayTitle: displayTitle,
            displayEmoji: displayEmoji,
            contentType: contentType,
            isSelected: selected,
            renderResourcedEmoji: renderResourcedEmoji,
            draggableState: draggableState,
            emoji: emoji,
            isExpanded: item.isExpanded,
            isLive: isLive,
            isDisabled: isMultiSelectActive && isDraft
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f3181cddc4d39a3c$export$4d23b38ef990da69, {
            id: item.id.toString(),
            displayHomePageIcon: item.id === spaceHomePageId,
            isDraft: isDraft,
            displayTitle: displayTitle,
            displayEmoji: displayEmoji,
            contentType: contentType,
            isSelected: selected,
            renderResourcedEmoji: renderResourcedEmoji,
            draggableState: draggableState,
            emoji: emoji,
            isExpanded: item.isExpanded,
            isLive: isLive,
            isDisabled: isMultiSelectActive && isDraft
        });
        $[45] = contentType;
        $[46] = displayEmoji;
        $[47] = displayTitle;
        $[48] = draggableState;
        $[49] = emoji;
        $[50] = isDraft;
        $[51] = isLive;
        $[52] = isMultiSelectActive;
        $[53] = isPreloadOnDelayedHoverEnabled;
        $[54] = item.id;
        $[55] = item.isExpanded;
        $[56] = onPrefetchBlur;
        $[57] = onPrefetchFocus;
        $[58] = onPreloadMouseDown;
        $[59] = onPreloadMouseEnter;
        $[60] = onPreloadMouseLeave;
        $[61] = onPreloadMouseMove;
        $[62] = renderResourcedEmoji;
        $[63] = selected;
        $[64] = spaceHomePageId;
        $[65] = t21;
    } else t21 = $[65];
    const pageTreeItemContent = t21;
    const selectContentAndDescendants = (0, $c4LIS.useNestedSelect)();
    const deselectContentAndDescendants = (0, $7e591ee26122d641$export$9fdf9590bd980095)();
    let t22;
    if ($[66] !== onBlurHoverTarget || $[67] !== onPrefetchBlur) {
        t22 = (e)=>{
            onPrefetchBlur();
            onBlurHoverTarget(e);
        };
        $[66] = onBlurHoverTarget;
        $[67] = onPrefetchBlur;
        $[68] = t22;
    } else t22 = $[68];
    const onBlurCallback = t22;
    const t23 = isChecked && !isDraft;
    let t24;
    if ($[69] !== deselectContentAndDescendants || $[70] !== flags || $[71] !== item.id || $[72] !== selectContentAndDescendants) {
        t24 = (e_0)=>{
            if (e_0.target.checked) selectContentAndDescendants(item.id, true, flags);
            else deselectContentAndDescendants(item.id);
        };
        $[69] = deselectContentAndDescendants;
        $[70] = flags;
        $[71] = item.id;
        $[72] = selectContentAndDescendants;
        $[73] = t24;
    } else t24 = $[73];
    let t25;
    if ($[74] !== intl || $[75] !== item.data.title) {
        t25 = intl.formatMessage($f3181cddc4d39a3c$var$i18n.checkboxLabel, {
            contentTitle: item.data.title
        });
        $[74] = intl;
        $[75] = item.data.title;
        $[76] = t25;
    } else t25 = $[76];
    let t26;
    if ($[77] !== isDraft || $[78] !== t23 || $[79] !== t24 || $[80] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
            isChecked: t23,
            onChange: t24,
            name: "isPageTreeItemSelected",
            "aria-label": t25,
            isDisabled: isDraft
        });
        $[77] = isDraft;
        $[78] = t23;
        $[79] = t24;
        $[80] = t25;
        $[81] = t26;
    } else t26 = $[81];
    const checkBox = t26;
    if (isMultiSelectActive) {
        const selectedItem = selectedContent[item.id];
        const hasDescendantCount = selectedItem && selectedItem.selectedDescendantCount > 0;
        let t27;
        if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
            t27 = {
                contain: "content"
            };
            $[82] = t27;
        } else t27 = $[82];
        let t28;
        if ($[83] !== checkBox || $[84] !== intl || $[85] !== isDraft) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", props, isDraft ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: intl.formatMessage($f3181cddc4d39a3c$var$i18n.draftTooltip)
                }, checkBox) : checkBox));
            $[83] = checkBox;
            $[84] = intl;
            $[85] = isDraft;
            $[86] = t28;
        } else t28 = $[86];
        let t29;
        if ($[87] !== bypassHref || $[88] !== deselectContentAndDescendants || $[89] !== displayTitle || $[90] !== flags || $[91] !== hasDescendantCount || $[92] !== indent || $[93] !== isChecked || $[94] !== isDraft || $[95] !== isSuperAdmin || $[96] !== item || $[97] !== onCollapse || $[98] !== onExpand || $[99] !== pageTreeItemContent || $[100] !== selectContentAndDescendants || $[101] !== selected || $[102] !== selectedItem) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
                entranceDirection: "left"
            }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    ...props_0,
                    style: {
                        ...props_0.style,
                        flexGrow: 1,
                        minWidth: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2703b103d1a678c3$export$cba03ec732da70ea), {
                    title: displayTitle,
                    isHoverPageCardOptedIn: false,
                    isQuickActionsOpen: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lkcsM.PageTreeLinkItem), {
                    isSelected: Boolean(selected),
                    onClick: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                        if (!isDraft) {
                            if (!isChecked) selectContentAndDescendants(item.id, true, flags);
                            else deselectContentAndDescendants(item.id);
                        }
                    },
                    href: bypassHref,
                    item: item,
                    isSuperAdmin: isSuperAdmin,
                    indent: indent,
                    forceHoverBackground: false,
                    isQuickActionsFocused: false,
                    isDisabled: isDraft,
                    beforeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7qclg.BeforeIcon), {
                        item: item,
                        isSuperAdmin: isSuperAdmin,
                        onExpand: (event_0)=>{
                            event_0.preventDefault();
                            event_0.stopPropagation();
                            onExpand?.(item.id);
                        },
                        onCollapse: (event_1)=>{
                            event_1.preventDefault();
                            event_1.stopPropagation();
                            onCollapse?.(item.id);
                        }
                    }),
                    afterIcon: item.hasChildren && !item.isExpanded && hasDescendantCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
                        isBold: true
                    }, "+", selectedItem.selectedDescendantCount) : undefined
                }, pageTreeItemContent))));
            $[87] = bypassHref;
            $[88] = deselectContentAndDescendants;
            $[89] = displayTitle;
            $[90] = flags;
            $[91] = hasDescendantCount;
            $[92] = indent;
            $[93] = isChecked;
            $[94] = isDraft;
            $[95] = isSuperAdmin;
            $[96] = item;
            $[97] = onCollapse;
            $[98] = onExpand;
            $[99] = pageTreeItemContent;
            $[100] = selectContentAndDescendants;
            $[101] = selected;
            $[102] = selectedItem;
            $[103] = t29;
        } else t29 = $[103];
        let t30;
        if ($[104] !== t28 || $[105] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                style: t27
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignInline: "start",
                alignBlock: "center",
                space: "space.0"
            }, t28, t29));
            $[104] = t28;
            $[105] = t29;
            $[106] = t30;
        } else t30 = $[106];
        return t30;
    }
    if (renderServerPlaceholder) {
        const t27 = item.id;
        const t28 = Boolean(selected);
        let t29;
        if ($[107] !== isSuperAdmin || $[108] !== item) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7qclg.BeforeIcon), {
                item: item,
                isSuperAdmin: isSuperAdmin,
                onCollapse: $f3181cddc4d39a3c$var$noop,
                onExpand: $f3181cddc4d39a3c$var$noop
            });
            $[107] = isSuperAdmin;
            $[108] = item;
            $[109] = t29;
        } else t29 = $[109];
        let t30;
        if ($[110] !== bypassHref || $[111] !== dragHandleProps || $[112] !== draggableState || $[113] !== indent || $[114] !== isSuperAdmin || $[115] !== item || $[116] !== pageTreeItemContent || $[117] !== t28 || $[118] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lkcsM.PageTreeLinkItem), {
                dragHandleProps: dragHandleProps,
                isSelected: t28,
                href: bypassHref,
                item: item,
                draggableState: draggableState,
                isSuperAdmin: isSuperAdmin,
                indent: indent,
                onClick: $f3181cddc4d39a3c$var$noop,
                forceHoverBackground: false,
                isQuickActionsFocused: false,
                beforeIcon: t29
            }, pageTreeItemContent);
            $[110] = bypassHref;
            $[111] = dragHandleProps;
            $[112] = draggableState;
            $[113] = indent;
            $[114] = isSuperAdmin;
            $[115] = item;
            $[116] = pageTreeItemContent;
            $[117] = t28;
            $[118] = t29;
            $[119] = t30;
        } else t30 = $[119];
        let t31;
        if ($[120] !== item.id || $[121] !== t30) {
            t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                role: "presentation"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-contentid": t27,
                role: "presentation"
            }, t30)));
            $[120] = item.id;
            $[121] = t30;
            $[122] = t31;
        } else t31 = $[122];
        return t31;
    }
    const t27 = bypassHref ?? "";
    let t28;
    if ($[123] !== closeAllHoverPageCards || $[124] !== contentType || $[125] !== isDraft || $[126] !== isQuickActionsOpen || $[127] !== onPrefetchMouseDown || $[128] !== setOpenQuickActionsId) {
        t28 = ()=>{
            onPrefetchMouseDown();
            if (contentType === "page" && !isDraft) (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.PAGE_TREE_ITEM_CLICK));
            closeAllHoverPageCards();
            isQuickActionsOpen && setOpenQuickActionsId(null);
        };
        $[123] = closeAllHoverPageCards;
        $[124] = contentType;
        $[125] = isDraft;
        $[126] = isQuickActionsOpen;
        $[127] = onPrefetchMouseDown;
        $[128] = setOpenQuickActionsId;
        $[129] = t28;
    } else t28 = $[129];
    const t29 = item.id;
    const t30 = item.id;
    const t31 = item.data.fullTitle || "";
    const t32 = item.data.emojiFromProperties || "";
    let t33;
    if ($[130] !== isContextualCreateFocused || $[131] !== isQuickActionsFocused || $[132] !== item.id || $[133] !== onEnterHoverTarget) {
        t33 = ()=>{
            onEnterHoverTarget({
                itemID: item.id.toString(),
                isQuickActionsFocused: isQuickActionsFocused,
                hoverPageCardTriggerRef: hoverPageCardTriggerRef,
                isContextualCreateFocused: isContextualCreateFocused
            });
        };
        $[130] = isContextualCreateFocused;
        $[131] = isQuickActionsFocused;
        $[132] = item.id;
        $[133] = onEnterHoverTarget;
        $[134] = t33;
    } else t33 = $[134];
    const t34 = Boolean(selected);
    const t35 = isQuickActionsOpen || isContextualCreateFocused;
    let t36;
    if ($[135] !== item.id || $[136] !== onExpand) {
        t36 = (event_2)=>{
            event_2.preventDefault();
            event_2.stopPropagation();
            onExpand?.(item.id);
        };
        $[135] = item.id;
        $[136] = onExpand;
        $[137] = t36;
    } else t36 = $[137];
    let t37;
    if ($[138] !== item.id || $[139] !== onCollapse) {
        t37 = (event_3)=>{
            event_3.preventDefault();
            event_3.stopPropagation();
            onCollapse?.(item.id);
        };
        $[138] = item.id;
        $[139] = onCollapse;
        $[140] = t37;
    } else t37 = $[140];
    let t38;
    if ($[141] !== isSuperAdmin || $[142] !== item || $[143] !== t36 || $[144] !== t37) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7qclg.BeforeIcon), {
            item: item,
            isSuperAdmin: isSuperAdmin,
            onExpand: t36,
            onCollapse: t37
        });
        $[141] = isSuperAdmin;
        $[142] = item;
        $[143] = t36;
        $[144] = t37;
        $[145] = t38;
    } else t38 = $[145];
    let t39;
    if ($[146] !== closeAllHoverPageCards || $[147] !== contentType || $[148] !== displayTitle || $[149] !== isContextualCreateFocused || $[150] !== isQuickActionsOpen || $[151] !== isSuperAdmin || $[152] !== item || $[153] !== setFocusedQuickActionsId || $[154] !== setIsEditingTitleId || $[155] !== setOpenQuickActionsId || $[156] !== shouldRenderAfterIcon || $[157] !== spaceKey) {
        t39 = shouldRenderAfterIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0MxG.PageTreeAfterIconLoader), {
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            isSuperAdmin: isSuperAdmin,
            isQuickActionsOpen: isQuickActionsOpen,
            setOpenQuickActionsId: setOpenQuickActionsId,
            setIsEditingTitleId: setIsEditingTitleId,
            closeAllHoverPageCards: closeAllHoverPageCards,
            spaceKey: spaceKey,
            item: item,
            isContextualCreateFocused: isContextualCreateFocused,
            setIsContextualCreateFocused: setIsContextualCreateFocused,
            displayTitle: displayTitle,
            contentType: contentType
        });
        $[146] = closeAllHoverPageCards;
        $[147] = contentType;
        $[148] = displayTitle;
        $[149] = isContextualCreateFocused;
        $[150] = isQuickActionsOpen;
        $[151] = isSuperAdmin;
        $[152] = item;
        $[153] = setFocusedQuickActionsId;
        $[154] = setIsEditingTitleId;
        $[155] = setOpenQuickActionsId;
        $[156] = shouldRenderAfterIcon;
        $[157] = spaceKey;
        $[158] = t39;
    } else t39 = $[158];
    let t40;
    if ($[159] !== bypassHref || $[160] !== dragHandleProps || $[161] !== draggableState || $[162] !== indent || $[163] !== isQuickActionsFocused || $[164] !== isSuperAdmin || $[165] !== item || $[166] !== onBlurHoverTarget || $[167] !== onClick || $[168] !== onLeaveHoverTarget || $[169] !== pageTreeItemContent || $[170] !== t33 || $[171] !== t34 || $[172] !== t35 || $[173] !== t38 || $[174] !== t39) {
        t40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lkcsM.PageTreeLinkItem), {
            dragHandleProps: dragHandleProps,
            onMouseEnter: t33,
            onMouseLeave: onLeaveHoverTarget,
            onBlur: onBlurHoverTarget,
            isSelected: t34,
            onClick: onClick,
            href: bypassHref,
            item: item,
            draggableState: draggableState,
            isSuperAdmin: isSuperAdmin,
            indent: indent,
            forceHoverBackground: t35,
            isQuickActionsFocused: isQuickActionsFocused,
            beforeIcon: t38,
            afterIcon: t39
        }, pageTreeItemContent);
        $[159] = bypassHref;
        $[160] = dragHandleProps;
        $[161] = draggableState;
        $[162] = indent;
        $[163] = isQuickActionsFocused;
        $[164] = isSuperAdmin;
        $[165] = item;
        $[166] = onBlurHoverTarget;
        $[167] = onClick;
        $[168] = onLeaveHoverTarget;
        $[169] = pageTreeItemContent;
        $[170] = t33;
        $[171] = t34;
        $[172] = t35;
        $[173] = t38;
        $[174] = t39;
        $[175] = t40;
    } else t40 = $[175];
    let t41;
    if ($[176] !== displayTitle || $[177] !== isHoverPageCardOptedIn || $[178] !== isQuickActionsOpen || $[179] !== t40) {
        t41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2703b103d1a678c3$export$cba03ec732da70ea), {
            title: displayTitle,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            isQuickActionsOpen: isQuickActionsOpen
        }, t40);
        $[176] = displayTitle;
        $[177] = isHoverPageCardOptedIn;
        $[178] = isQuickActionsOpen;
        $[179] = t40;
        $[180] = t41;
    } else t41 = $[180];
    let t42;
    if ($[181] !== contentStatus || $[182] !== contentType || $[183] !== editingTitleIsNewContent || $[184] !== indent || $[185] !== isEditingTitle || $[186] !== isLive || $[187] !== item.id || $[188] !== setFocusedQuickActionsId || $[189] !== setIsEditingTitleId || $[190] !== t31 || $[191] !== t32 || $[192] !== t41 || $[193] !== updateSinglePage) {
        t42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hySOz.ConditionalInlineRename), {
            id: t30,
            title: t31,
            displayEmoji: t32,
            isEditingTitle: isEditingTitle,
            isNewContent: editingTitleIsNewContent,
            setIsEditingTitleId: setIsEditingTitleId,
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            updateContentTreeItem: updateSinglePage,
            contentStatus: contentStatus,
            contentType: contentType,
            isLive: isLive,
            indent: indent
        }, t41);
        $[181] = contentStatus;
        $[182] = contentType;
        $[183] = editingTitleIsNewContent;
        $[184] = indent;
        $[185] = isEditingTitle;
        $[186] = isLive;
        $[187] = item.id;
        $[188] = setFocusedQuickActionsId;
        $[189] = setIsEditingTitleId;
        $[190] = t31;
        $[191] = t32;
        $[192] = t41;
        $[193] = updateSinglePage;
        $[194] = t42;
    } else t42 = $[194];
    let t43;
    if ($[195] !== item.id || $[196] !== onBlurCallback || $[197] !== onPrefetchFocus || $[198] !== onPrefetchMouseEnter || $[199] !== onPrefetchMouseLeave || $[200] !== t28 || $[201] !== t42) {
        t43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onPrefetchMouseEnter,
            onMouseLeave: onPrefetchMouseLeave,
            onFocus: onPrefetchFocus,
            onBlur: onBlurCallback,
            onMouseDown: t28,
            ref: hoverPageCardTriggerRef,
            "data-contentid": t29,
            role: "presentation"
        }, t42);
        $[195] = item.id;
        $[196] = onBlurCallback;
        $[197] = onPrefetchFocus;
        $[198] = onPrefetchMouseEnter;
        $[199] = onPrefetchMouseLeave;
        $[200] = t28;
        $[201] = t42;
        $[202] = t43;
    } else t43 = $[202];
    let t44;
    if ($[203] !== t27 || $[204] !== t43) {
        t44 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
            name: "page-tree-item",
            preloadUrl: t27,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
        }, t43);
        $[203] = t27;
        $[204] = t43;
        $[205] = t44;
    } else t44 = $[205];
    let t45;
    if ($[206] !== isLive || $[207] !== t44) {
        t45 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYA5q.LivePagePreloader), {
            isLivePage: isLive
        }, t44);
        $[206] = isLive;
        $[207] = t44;
        $[208] = t45;
    } else t45 = $[208];
    return t45;
};
const $f3181cddc4d39a3c$export$66351858996683dc = (0, $7aRa9.withFlags)($f3181cddc4d39a3c$var$PageTreeItemComponent);
const $f3181cddc4d39a3c$var$i18n = (0, $aXWIB.defineMessages)({
    checkboxLabel: {
        id: "page-tree.page-tree-item.checkbox.label",
        defaultMessage: "{contentTitle} checkbox"
    },
    draftTooltip: {
        id: "page-tree.page-tree-item.draft.tooltip",
        defaultMessage: "Drafts can\u2019t be selected for bulk actions."
    }
});
const $f3181cddc4d39a3c$var$noop = ()=>{};
module.exports["useIsEmojiSetForType"] = $f3181cddc4d39a3c$export$b128294488e41c39;
module.exports["EmojiWrapper"] = $f3181cddc4d39a3c$export$e31a6cc0a4c97f0e;
module.exports["PageTreeItemContent"] = $f3181cddc4d39a3c$export$4d23b38ef990da69;
module.exports["PageTreeItem"] = $f3181cddc4d39a3c$export$66351858996683dc;

});

parcelRegister("2gltw", function(module, exports) {

let $1a5dbbe82d31cb5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1a5dbbe82d31cb5a$var$load("9a2oY"),
    $1a5dbbe82d31cb5a$var$load("fnoJZ")
]).then(()=>parcelRequire('7He8T'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("3BpiD", function(module, exports) {

let $29f873c2177a769e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $29f873c2177a769e$var$load("6gau7").then(()=>parcelRequire('90bwg'));

});

parcelRegister("7qclg", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $6R5uz = parcelRequire("6R5uz");


var $ghftu = parcelRequire("ghftu");


var $e66a9 = parcelRequire("e66a9");


var $4TXTZ = parcelRequire("4TXTZ");

const $562183fc931a4366$var$SPINNER_SIZE_MEDIUM = 16; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $562183fc931a4366$var$PageTreeItemSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s8otz2",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $562183fc931a4366$var$beforeIconStyles = null;
const $562183fc931a4366$export$89817f2a7aa927f4 = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { item: item, isSuperAdmin: isSuperAdmin, onExpand: onExpand, onCollapse: onCollapse } = t0;
    const { isChildrenLoading: isChildrenLoading, hasChildren: hasChildren, isExpanded: isExpanded, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions } = item;
    const shouldDisplayRed = Boolean(!!isSuperAdmin && (hasRestrictions || hasInheritedRestrictions));
    let t1;
    if ($[0] !== onExpand) {
        t1 = (event)=>{
            (0, $4TXTZ.default)("page-tree-item-expand", event.timeStamp);
            onExpand(event);
        };
        $[0] = onExpand;
        $[1] = t1;
    } else t1 = $[1];
    const handleOnExpand = t1;
    let t2;
    if ($[2] !== onCollapse) {
        t2 = (event_0)=>{
            (0, $4TXTZ.default)("page-tree-item-collapse", event_0.timeStamp);
            onCollapse(event_0);
        };
        $[2] = onCollapse;
        $[3] = t2;
    } else t2 = $[3];
    const handleOnCollapse = t2;
    const iconColor = shouldDisplayRed ? "var(--ds-icon-danger, #C9372C)" : undefined;
    if (isChildrenLoading) {
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($562183fc931a4366$var$PageTreeItemSpinner, {
                "data-testid": "tree-item-spinner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
                size: $562183fc931a4366$var$SPINNER_SIZE_MEDIUM
            }));
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    if (hasChildren || item.data.type === "folder") {
        let t3;
        if ($[5] !== handleOnCollapse || $[6] !== handleOnExpand || $[7] !== iconColor || $[8] !== isExpanded || $[9] !== item.id) {
            t3 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                onClick: handleOnCollapse,
                "data-testid": "chevron-down",
                "data-no-global-anchor-handler": true,
                "aria-expanded": isExpanded,
                "aria-labelledby": item.id,
                className: (0, $gMc0m.default)([
                    "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rkofajl _1pbykb7n _1e0c1txw _bfhk1j28 _80omtlke _4t3i1ejb _1bsb1ejb _4cvr1h6o _1bah1h6o _syazazsu _irr31dpa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                color: iconColor,
                label: "",
                size: "small"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                onClick: handleOnExpand,
                "data-testid": "chevron-right",
                "data-no-global-anchor-handler": true,
                "aria-expanded": isExpanded,
                "aria-labelledby": item.id,
                className: (0, $gMc0m.default)([
                    "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rkofajl _1pbykb7n _1e0c1txw _bfhk1j28 _80omtlke _4t3i1ejb _1bsb1ejb _4cvr1h6o _1bah1h6o _syazazsu _irr31dpa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                color: iconColor,
                label: "",
                size: "small"
            }));
            $[5] = handleOnCollapse;
            $[6] = handleOnExpand;
            $[7] = iconColor;
            $[8] = isExpanded;
            $[9] = item.id;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e66a9))), {
            label: "",
            color: "var(--ds-text-subtle, #505258)"
        });
        $[11] = t3;
    } else t3 = $[11];
    return t3;
});
module.exports["BeforeIcon"] = $562183fc931a4366$export$89817f2a7aa927f4;

});

parcelRegister("lUMkS", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");


var $422HI = parcelRequire("422HI");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $di8q4 = parcelRequire("di8q4");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");


var $jmjWc = parcelRequire("jmjWc");


var $ep3mz = parcelRequire("ep3mz");


var $ficwO = parcelRequire("ficwO");


var $9eE57 = parcelRequire("9eE57");


var $2vuKf = parcelRequire("2vuKf");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");

/**
 * @generated SignedSource<<07baad7152a8e8d70a4ee7ef8b4eed07>>
 * @relayHash c4df84ea0fb09cca4d217d3f3b1e6526
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9dcd3c7b3dba0bc2788ae9ccaa6f4ea9319b527b9306aeb8643830dc382a94fc
const $eaeaab3296b1b924$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "action"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "action",
                    "variableName": "action"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "DeleteContentResponsePayload",
            "kind": "LinkedField",
            "name": "deleteContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c4df84ea0fb09cca4d217d3f3b1e6526",
            "id": "9dcd3c7b3dba0bc2788ae9ccaa6f4ea9319b527b9306aeb8643830dc382a94fc",
            "metadata": {},
            "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation PageTreeSmartLinkDropMonitorDeleteMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId}}"
        }
    };
}();
$eaeaab3296b1b924$var$node.hash = "03dea5e17e424646c6535f7b61c07883";
var $eaeaab3296b1b924$export$2e2bcd8739ae039 = $eaeaab3296b1b924$var$node;






var $aXWIB = parcelRequire("aXWIB");


var $f9yl5 = parcelRequire("f9yl5");


var $inPa6 = parcelRequire("inPa6");


var $4T4vf = parcelRequire("4T4vf");


var $jJDs8 = parcelRequire("jJDs8");


var $308Wd = parcelRequire("308Wd");


var $Wsgbu = parcelRequire("Wsgbu");


var $9wGTI = parcelRequire("9wGTI");


var $gMtye = parcelRequire("gMtye");

const $492ff87f1027b57e$var$VIRTUAL_ROOT_IDS = new Set([
    'VIRTUAL_ROOT_ID',
    'VIRTUAL_LOCAL_ROOT_ID'
]);
const $492ff87f1027b57e$var$i18n = (0, $aXWIB.defineMessages)({
    successTitle: {
        id: "smart-link-droppable.drop-monitor.success.title",
        defaultMessage: "\"{title}\" added to content tree"
    },
    successTitleFallback: {
        id: "smart-link-droppable.drop-monitor.success.title-fallback",
        defaultMessage: "Link added to content tree"
    },
    undoAction: {
        id: "smart-link-droppable.drop-monitor.success.undo",
        defaultMessage: "Undo"
    },
    undoSuccessTitle: {
        id: "smart-link-droppable.drop-monitor.undo-success.title",
        defaultMessage: "Smart link removed"
    },
    errorTitle: {
        id: "smart-link-droppable.drop-monitor.error.title",
        defaultMessage: "We're unable to create right now"
    },
    errorDescription: {
        id: "smart-link-droppable.drop-monitor.error.description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    }
});
function $492ff87f1027b57e$export$2a8966ce55c8c689({ spaceKey: spaceKey, flags: flags, onInsert: onInsert, onDelete: onDelete }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [commitMutation] = (0, $308Wd.useMutationInterop)((0, $eaeaab3296b1b924$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/smart-link-droppable"
    });
    const deleteSmartLinkEmbed = (0, $42omo.useCallback)((contentId)=>{
        return commitMutation({
            variables: {
                contentId: contentId,
                action: 'MOVE_TO_TRASH'
            }
        });
    }, [
        commitMutation
    ]);
    const handleUndoSmartLinkEmbed = (0, $42omo.useCallback)((contentId)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'smartLinkDragDropUndo',
                source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                attributes: {
                    dropTarget: 'contentTree'
                }
            }
        }).fire();
        onDelete(contentId);
        deleteSmartLinkEmbed(contentId).then(()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'smartLink',
                    source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                    attributes: {
                        dropTarget: 'contentTree'
                    }
                }
            }).fire();
            if (flags) flags.showSuccessFlag({
                title: formatMessage($492ff87f1027b57e$var$i18n.undoSuccessTitle),
                isAutoDismiss: true
            });
        }).catch(()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleteFailed',
                    actionSubject: 'smartLink',
                    source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                    attributes: {
                        dropTarget: 'contentTree'
                    }
                }
            }).fire();
            if (flags) flags.showErrorFlag({
                title: formatMessage($492ff87f1027b57e$var$i18n.errorTitle),
                description: formatMessage($492ff87f1027b57e$var$i18n.errorDescription),
                isAutoDismiss: true
            });
        });
    }, [
        createAnalyticsEvent,
        deleteSmartLinkEmbed,
        flags,
        formatMessage,
        onDelete
    ]);
    const handleSmartLinkEmbedDrop = (0, $42omo.useCallback)(({ url: url, title: title, iconUrl: iconUrl, parentId: parentId, instruction: instruction, dropTargetId: dropTargetId })=>{
        (0, $Wsgbu.createSmartLinkEmbedContent)({
            createAnalyticsEvent: createAnalyticsEvent,
            spaceKey: spaceKey,
            parentId: $492ff87f1027b57e$var$VIRTUAL_ROOT_IDS.has(parentId) ? undefined : parentId,
            embedUrl: url
        }).then(async (result)=>{
            const contentId = result.contentId;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'smartLink',
                    source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                    attributes: {
                        dropTarget: 'contentTree'
                    }
                }
            }).fire();
            if (contentId) {
                const position = instruction && (instruction.type === 'reorder-above' || instruction.type === 'reorder-below') ? {
                    siblingId: dropTargetId,
                    placement: instruction.type === 'reorder-above' ? 'before' : 'after'
                } : undefined;
                onInsert({
                    contentId: contentId,
                    parentId: parentId,
                    title: title,
                    url: url,
                    iconUrl: iconUrl,
                    position: position
                });
            }
            if (flags) flags.showSuccessFlag({
                id: 'smartLinkDropFlag',
                title: title ? formatMessage($492ff87f1027b57e$var$i18n.successTitle, {
                    title: title
                }) : formatMessage($492ff87f1027b57e$var$i18n.successTitleFallback),
                isAutoDismiss: true,
                actions: contentId ? [
                    {
                        content: formatMessage($492ff87f1027b57e$var$i18n.undoAction),
                        onClick: ()=>{
                            handleUndoSmartLinkEmbed(contentId);
                            flags.hideFlag('smartLinkDropFlag');
                        }
                    }
                ] : undefined
            });
        }).catch(()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createFailed',
                    actionSubject: 'smartLink',
                    source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                    attributes: {
                        dropTarget: 'contentTree'
                    }
                }
            }).fire();
            if (flags) flags.showErrorFlag({
                title: formatMessage($492ff87f1027b57e$var$i18n.errorTitle),
                description: formatMessage($492ff87f1027b57e$var$i18n.errorDescription),
                isAutoDismiss: true
            });
        });
    }, [
        createAnalyticsEvent,
        flags,
        formatMessage,
        handleUndoSmartLinkEmbed,
        onInsert,
        spaceKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return;
        return (0, $4T4vf.monitorForElements)({
            canMonitor: ({ source: source })=>(0, $f9yl5.isSmartLinkDrag)(source.data.type) || !!source.data.url && !!source.data.appearance,
            onDragStart: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'dragged',
                        actionSubject: 'smartLink',
                        source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE)
                    }
                }).fire();
            },
            onDrop: ({ source: source, location: location })=>{
                const { url: url, title: title, iconUrl: iconUrl } = source.data;
                const truncatedTitle = title && title.length > (0, $Wsgbu.MAX_SMART_LINK_EMBED_TITLE_LENGTH) ? `${title.slice(0, (0, $Wsgbu.MAX_SMART_LINK_EMBED_TITLE_LENGTH) - 3)}...` : title;
                const dropTarget = location?.current?.dropTargets[0];
                if (!url || !dropTarget || !dropTarget.data.id) {
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'drop cancelled',
                            actionSubject: 'smartLink',
                            source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE)
                        }
                    }).fire();
                    return;
                }
                const instruction = (0, $jJDs8.extractInstruction)(dropTarget.data);
                const dropTargetId = dropTarget.data.id;
                let parentId;
                if (instruction && (instruction.type === 'reorder-above' || instruction.type === 'reorder-below')) parentId = dropTarget.data.parentId;
                else parentId = dropTargetId;
                handleSmartLinkEmbedDrop({
                    url: url,
                    title: truncatedTitle,
                    iconUrl: iconUrl,
                    parentId: parentId,
                    instruction: instruction,
                    dropTargetId: dropTargetId
                });
            }
        });
    }, [
        createAnalyticsEvent,
        handleSmartLinkEmbedDrop
    ]);
    return null;
}



var $jMyy4 = parcelRequire("jMyy4");


var $3aAh8 = parcelRequire("3aAh8");


var $jGj7w = parcelRequire("jGj7w");

/* PageTreeComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $ccHMk = parcelRequire("ccHMk");


var $9hlns = parcelRequire("9hlns");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");





const $cd81aae1dd865317$export$56ef5168f507b51a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6xpDa",
    name: "TreeMonitorLoader",
    loader: async ()=>(await (parcelRequire("1ewPd"))).TreeMonitor
});



var $4BeGP = parcelRequire("4BeGP");


var $luv00 = parcelRequire("luv00");


var $5Abqh = parcelRequire("5Abqh");


var $gAsUX = parcelRequire("gAsUX");

'use no memo';
function $1a3215c7f6382f73$var$_defineProperty(e, r, t) {
    return (r = $1a3215c7f6382f73$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1a3215c7f6382f73$var$_toPropertyKey(t) {
    var i = $1a3215c7f6382f73$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1a3215c7f6382f73$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $1a3215c7f6382f73$var$INDENT_PER_LEVEL = 12;
const $1a3215c7f6382f73$var$INDENT_PER_LEVEL_NAV_3 = 16; // Container to expand Page tree to the remaining space
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a3215c7f6382f73$var$AkTreeContainerFlex = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zidpf _1bsb1osq _1e0c1txw _2lx21bp4 _nphskb7n _bhl91osq",
            __cmplp.className
        ])
    });
}); // SPINNER_SIZE + 8px => to match the medium (24px) chevron.
const $1a3215c7f6382f73$var$LoadMorePagesButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pk19bv _2hwxidpf _otyr19bv _18u0idpf _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $1a3215c7f6382f73$var$inlineTreeSpinnerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    minHeight: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1
});
const $1a3215c7f6382f73$var$pageTreeContainerCSS = null;
const $1a3215c7f6382f73$var$pageTreeContainerLoadingCSS = null;
const $1a3215c7f6382f73$var$pageTreeDropTargetVerticalInset = "var(--ds-space-050, 4px)";
const $1a3215c7f6382f73$var$pageTreeDropTargetHorizontalInset = `calc(${"var(--ds-space-100, 8px)"} + ${"var(--ds-space-025, 2px)"})`; // To align the page tree's wrapper with shortcuts drop wrapper
const $1a3215c7f6382f73$var$pageTreeDropTargetCSS = null;
const $1a3215c7f6382f73$var$StyledPageTreeContainer = ({ children: children, loading: loading })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "page-tree-container",
        "data-vc": "page-tree-container",
        id: "page-tree-container",
        ...ssrPlaceholderIdProp,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _1o9zidpf _4cvr1y6m",
            loading && "_tzy4105o _lcxvglyw _80om13gf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gAsUX.SmartLinkDropTarget), {
        hideHoveredEdgeBorder: true,
        className: (0, $gMc0m.default)([
            "_19pk8ily _2hwx1dgl _otyr8ily _18u01dgl _ca0q1b66 _u5f3x9pa _n3td1b66 _19bvx9pa"
        ])
    }, children));
};
const $1a3215c7f6382f73$var$InlineTreePaginationSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $1a3215c7f6382f73$var$inlineTreeSpinnerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium",
        testId: "page-tree-loading"
    }));
const $1a3215c7f6382f73$var$LoadPreviousPagesButton = /*#__PURE__*/ (0, $42omo.memo)(({ loadMorePages: loadMorePages })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$LoadMorePagesButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        shouldFitContainer: true,
        spacing: "compact",
        onClick: loadMorePages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "page-tree.pages.show.more.above",
        defaultMessage: "Show more above"
    })));
});
const $1a3215c7f6382f73$var$LoadFollowingPagesButton = /*#__PURE__*/ (0, $42omo.memo)(({ loadMorePages: loadMorePages })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$LoadMorePagesButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        shouldFitContainer: true,
        spacing: "compact",
        onClick: loadMorePages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "page-tree.pages.show.more.below",
        defaultMessage: "Show more below"
    })));
}); /**
     * This is a purely presentational component. Please don't add any
     * non-presentational logic _directly_ to this component - use optional
     * callback props instead.
     */ 
class $1a3215c7f6382f73$export$330dddbe7c08afed extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { tree: tree } = this.props;
        if (Object.keys(tree.items).length) {
            this.props.onInitialLoadComplete?.(Object.keys(tree.items).length);
            this.onInitialLoadCompleteSubmitted = true;
        }
    }
    componentDidUpdate(prevProps) {
        if (this.onInitialLoadCompleteSubmitted) return;
        const { tree: tree } = this.props;
        const justFinishedLoading = prevProps.loading && !this.props.loading || window.__SSR_RENDERED__;
        if (justFinishedLoading) {
            this.props.onInitialLoadComplete?.(Object.keys(tree.items).length);
            this.onInitialLoadCompleteSubmitted = true;
        }
    }
    render() {
        const { tree: tree, loadPreviousPages: loadPreviousPages, loadFollowingPages: loadFollowingPages, isTreeTruncatedPrevious: isTreeTruncatedPrevious, isTreeTruncatedFollowing: isTreeTruncatedFollowing, isDraggable: isDraggable, dragPreview: dragPreview, loading: loading, isNav4Enabled: isNav4Enabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$StyledPageTreeContainer, {
            loading: loading
        }, !isTreeTruncatedPrevious && !isTreeTruncatedFollowing && loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$InlineTreePaginationSpinner, null), isTreeTruncatedPrevious && (!loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$LoadPreviousPagesButton, {
            loadMorePages: loadPreviousPages
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$InlineTreePaginationSpinner, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$AkTreeContainerFlex, {
            "data-testid": "tree-container-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4BeGP.Tree), {
            tree: tree,
            isDragEnabled: isDraggable,
            renderItem: this.props.renderItem,
            renderItemEmptyState: this.props.renderItemEmptyState,
            onExpand: this.expandPage,
            onCollapse: this.collapsePage,
            onDragStart: this.props.onDragStart,
            onDragEnd: this.dragEnd,
            dragPreview: dragPreview,
            indentPerLevel: isNav4Enabled ? $1a3215c7f6382f73$var$INDENT_PER_LEVEL : $1a3215c7f6382f73$var$INDENT_PER_LEVEL_NAV_3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cd81aae1dd865317$export$56ef5168f507b51a), {
            setIsDraggingItem: this.props.setIsDraggingItem
        })), isTreeTruncatedFollowing && (!loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$LoadFollowingPagesButton, {
            loadMorePages: loadFollowingPages
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1a3215c7f6382f73$var$InlineTreePaginationSpinner, null)), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Abqh.SetSSRPartialSuccess), {
            name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree
        }));
    }
    constructor(...args){
        super(...args);
        $1a3215c7f6382f73$var$_defineProperty(this, "onInitialLoadCompleteSubmitted", false);
        $1a3215c7f6382f73$var$_defineProperty(this, "collapsePage", (pageId)=>{
            const { tree: tree, onCollapse: onCollapse } = this.props;
            onCollapse(tree.items[pageId]);
        });
        $1a3215c7f6382f73$var$_defineProperty(this, "expandPage", (pageId)=>{
            const { tree: tree, onExpand: onExpand } = this.props;
            onExpand(tree.items[pageId]);
        });
        $1a3215c7f6382f73$var$_defineProperty(this, "dragEnd", async (source, destination, instruction)=>{
            const { onDragEnd: onDragEnd } = this.props;
            onDragEnd(source, destination, instruction);
        });
    }
}









var $9eCf8 = parcelRequire("9eCf8");

/**
 * @generated SignedSource<<f62e3fa634d2af83f97eb0748208ed3f>>
 * @relayHash 09fa6b69b6ecabf69f28c3d20846542c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 046e70b0a3f96051db04e76206595f6c4fba9a2ca64560160ae4a0685d1b4f0a
const $93d715cfc896c3c6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "value"
    }, v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v7 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v10 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v11 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v7 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v16 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageTree",
                    "variableName": "paginationLimit"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "ptStatuses"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "followingSiblings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeRootLevelQuery",
            "selections": v16 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeRootLevelQuery",
            "selections": v16 /*: any*/ 
        },
        "params": {
            "cacheID": "09fa6b69b6ecabf69f28c3d20846542c",
            "id": "046e70b0a3f96051db04e76206595f6c4fba9a2ca64560160ae4a0685d1b4f0a",
            "metadata": {},
            "name": "PageTreeRootLevelQuery",
            "operationKind": "query",
            "text": "query PageTreeRootLevelQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$isSuperAdmin:Boolean!,$paginationLimit:Int){ptpage(spaceKey:$spaceKey,status:$ptStatuses,pageTree:$paginationLimit){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$93d715cfc896c3c6$var$node.hash = "1d326a119d28d4c0f9ae0adb18f61cbc";
var $93d715cfc896c3c6$export$2e2bcd8739ae039 = $93d715cfc896c3c6$var$node;



var $1oGPE = parcelRequire("1oGPE");





var $k0x5M = parcelRequire("k0x5M");


var $2qvBe = parcelRequire("2qvBe");







/**
 * @generated SignedSource<<fbe27f6a10f59add849b27be40d8f1ab>>
 * @relayHash 721de05816b4a23d4956957fad6733b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7c1ca0f9ddc2648482e7ea8ed8bbfef84a3c38973644e78dc2f1db27d9257083
const $a1f6f5e5f6be4295$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v9 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v10 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v15 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v16 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": [
            {
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v6 /*: any*/ ,
                    v7 /*: any*/ ,
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            },
            v15 /*: any*/ 
        ]
    }, v17 = [
        {
            "alias": "currentPage",
            "args": [
                {
                    "kind": "Literal",
                    "name": "enablePaging",
                    "value": true
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "pageTree",
                    "variableName": "paginationLimit"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "ptStatuses"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                },
                v16 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreePreviousItemsQuery",
            "selections": v17 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreePreviousItemsQuery",
            "selections": v17 /*: any*/ 
        },
        "params": {
            "cacheID": "721de05816b4a23d4956957fad6733b2",
            "id": "7c1ca0f9ddc2648482e7ea8ed8bbfef84a3c38973644e78dc2f1db27d9257083",
            "metadata": {},
            "name": "PageTreePreviousItemsQuery",
            "operationKind": "query",
            "text": "query PageTreePreviousItemsQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage},nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}}"
        }
    };
}();
$a1f6f5e5f6be4295$var$node.hash = "4d500f939ab5ebf8e00183c0d9277bcf";
var $a1f6f5e5f6be4295$export$2e2bcd8739ae039 = $a1f6f5e5f6be4295$var$node;


/**
 * @generated SignedSource<<2fb635add552a7dccfc7c38ddc2a9114>>
 * @relayHash 37c794da865172d609c23565f793e233
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID acc71c1cc1e805fd4f6e7e71f984116c1e247bcb4c88e72d79072f118f5d4c40
const $56adeec417a0fbae$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v9 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v10 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v15 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v16 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": [
            {
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v6 /*: any*/ ,
                    v7 /*: any*/ ,
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            },
            v15 /*: any*/ 
        ]
    }, v17 = [
        {
            "alias": "currentPage",
            "args": [
                {
                    "kind": "Literal",
                    "name": "enablePaging",
                    "value": true
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "pageTree",
                    "variableName": "paginationLimit"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "ptStatuses"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v16 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeFollowingItemsQuery",
            "selections": v17 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeFollowingItemsQuery",
            "selections": v17 /*: any*/ 
        },
        "params": {
            "cacheID": "37c794da865172d609c23565f793e233",
            "id": "acc71c1cc1e805fd4f6e7e71f984116c1e247bcb4c88e72d79072f118f5d4c40",
            "metadata": {},
            "name": "PageTreeFollowingItemsQuery",
            "operationKind": "query",
            "text": "query PageTreeFollowingItemsQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage},nodes{followingSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},id}},followingSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}}"
        }
    };
}();
$56adeec417a0fbae$var$node.hash = "664ef7426d14280a779aeff96cb4c699";
var $56adeec417a0fbae$export$2e2bcd8739ae039 = $56adeec417a0fbae$var$node;











const $851be28f149687b8$export$519f493ae7d5823b = (query)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            skip: true
        };
        $[0] = t0;
    } else t0 = $[0];
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(query, {
        ...t0,
        __callerPackage__: "@confluence/page-tree"
    });
    let t1;
    if ($[1] !== refetch) {
        t1 = (variables)=>refetch(variables);
        $[1] = refetch;
        $[2] = t1;
    } else t1 = $[2];
    const imperativelyCallQuery = t1;
    return imperativelyCallQuery;
};








const $3c47156b255753b0$var$isPageTreeTruncatedDirectionally = {
    previous: (0, $2qvBe.isPageTreeTruncatedPrevious),
    following: (0, $2qvBe.isPageTreeTruncatedFollowing)
};
const $3c47156b255753b0$var$mergePages = {
    previous: (0, $2qvBe.mergePreviousPages),
    following: (0, $2qvBe.mergeFollowingPages)
};
const $3c47156b255753b0$export$a7e70ccb70edf19f = ({ statuses: statuses })=>{
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [rootId, actions] = (0, $jGj7w.usePageTreeState)();
    const getMorePreviousPages = (0, $851be28f149687b8$export$519f493ae7d5823b)((0, $a1f6f5e5f6be4295$export$2e2bcd8739ae039));
    const getMoreFollowingPages = (0, $851be28f149687b8$export$519f493ae7d5823b)((0, $56adeec417a0fbae$export$2e2bcd8739ae039));
    const loadMorePages = (0, $42omo.useCallback)((contentId, spaceKey, isSuperAdmin, cursors, allPages, direction = 'following', previousCounts = {
        children: 0,
        previousSiblings: 0,
        followingSiblings: 0
    })=>{
        (0, $9eE57.perfMarkStart)({
            subject: 'PageTree',
            subjectId: 'loadMorePages'
        });
        const id = cursors?.[direction]?.id || undefined;
        const ancestorIndex = cursors?.[direction]?.ancestorIndex || undefined;
        const directionalGetMorePages = {
            previous: getMorePreviousPages,
            following: getMoreFollowingPages
        }[direction];
        return directionalGetMorePages({
            contentId: id,
            paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
            spaceKey: spaceKey,
            isSuperAdmin: isSuperAdmin,
            statuses: statuses,
            ptStatuses: statuses
        }).then((response)=>{
            const { data: data, error: error } = response;
            if (error) {
                actions.handleLoadingError(error, direction);
                return;
            } else if (data && Object.keys(data).length > 0) {
                const { currentPage: currentPage, rootLevelPages: rootLevelPages } = data;
                const mergedPages = $3c47156b255753b0$var$mergePages[direction](currentPage, allPages, ancestorIndex);
                const childrenLength = mergedPages.children.count;
                const previousSiblingsLength = mergedPages.previousSiblings.count;
                const followingSiblingsLength = mergedPages.followingSiblings.count;
                //infinite loop check:
                if (childrenLength > previousCounts.children || previousSiblingsLength > previousCounts.previousSiblings || followingSiblingsLength > previousCounts.followingSiblings) //congrats one of the counts got bigger, paging was worth it
                {
                    if ($3c47156b255753b0$var$isPageTreeTruncatedDirectionally[direction](currentPage)) {
                        const nextCursors = (0, $2qvBe.getDirectionalCursors)(currentPage, rootId, cursors, direction);
                        return loadMorePages(contentId, spaceKey, isSuperAdmin, nextCursors, mergedPages, direction, {
                            children: childrenLength,
                            previousSiblings: previousSiblingsLength,
                            followingSiblings: followingSiblingsLength
                        });
                    }
                }
                return {
                    mergedPages: mergedPages,
                    rootLevelPages: rootLevelPages
                };
            }
        }).catch((error_0)=>{
            actions.handleLoadingError(error_0, direction);
            return {
                error: error_0
            };
        });
    }, [
        getMorePreviousPages,
        getMoreFollowingPages,
        actions,
        statuses,
        rootId
    ]);
    return {
        loadMorePages: loadMorePages
    };
};








/**
 * @generated SignedSource<<219d219fe1b4b68062493090b419a500>>
 * @relayHash e2382e54faefb52da6b779a5a0e4e131
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46083f55348a2768eb4c27f76700156905d8719d60931948117bb501219e68bd
const $8728d416e54b77da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v10 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v15 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeChildrenQuery",
            "selections": v15 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeChildrenQuery",
            "selections": v15 /*: any*/ 
        },
        "params": {
            "cacheID": "e2382e54faefb52da6b779a5a0e4e131",
            "id": "46083f55348a2768eb4c27f76700156905d8719d60931948117bb501219e68bd",
            "metadata": {},
            "name": "PageTreeChildrenQuery",
            "operationKind": "query",
            "text": "query PageTreeChildrenQuery($contentId:ID!,$statuses:[PTGraphQLPageStatus],$first:Int,$after:String,$isSuperAdmin:Boolean!){ptpage(id:$contentId,status:$statuses){id,title,status,blank,hasChildren,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},children(first:$first,after:$after){nodes{id,title,status,blank,hasChildren,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}}}"
        }
    };
}();
$8728d416e54b77da$var$node.hash = "7f4eadf7c16e9b339dd6bec11ab87380";
var $8728d416e54b77da$export$2e2bcd8739ae039 = $8728d416e54b77da$var$node;









const $1280e1da13e18af8$export$d88ca1c37ff75e1 = ({ statuses: statuses, isSuperAdmin: isSuperAdmin })=>{
    const [state, actions] = (0, $jGj7w.usePageTreeState)();
    const getPageChildren = (0, $851be28f149687b8$export$519f493ae7d5823b)((0, $8728d416e54b77da$export$2e2bcd8739ae039));
    const queryChildren = (0, $42omo.useCallback)((pageId, after, allChildren = {
        count: 0,
        nodes: []
    }, iteration = 0)=>{
        return getPageChildren({
            contentId: pageId,
            statuses: statuses,
            first: (0, $1oGPE.CHILDREN_PAGE_SIZE),
            after: after,
            isSuperAdmin: isSuperAdmin || false
        }).then((response)=>{
            if (response.data) {
                const children = response.data?.ptpage?.children;
                const mergedChildren = children ? (0, $2qvBe.mergeChildren)(allChildren, children) : {
                    nodes: []
                };
                return children?.pageInfo?.hasNextPage && after !== children?.pageInfo?.endCursor && // ensure the new cursor is different
                iteration < 100 // prevent a potential infinite loop
                 ? queryChildren(pageId, children?.pageInfo?.endCursor, mergedChildren, iteration + 1) : {
                    ...mergedChildren,
                    error: null
                };
            }
            return {
                nodes: [],
                error: null
            };
        }).catch((error)=>{
            actions.handleLoadingError(error, 'children');
            return {
                nodes: [],
                error: error
            };
        });
    }, [
        getPageChildren,
        isSuperAdmin,
        statuses,
        actions
    ]);
    const reloadChildren = (0, $42omo.useCallback)(()=>{
        // @ts-ignore
        queryChildren(state.focusedPageId);
    // @ts-ignore
    }, [
        queryChildren,
        state.focusedPageId
    ]);
    return {
        queryChildren: queryChildren,
        reloadChildren: reloadChildren
    };
};



var $ivyMZ = parcelRequire("ivyMZ");




const $34ce551f827e69ec$export$c22e67505d83a820 = (targetPage, paginated, forceFetch, detached, spaceKey, isSuperAdmin)=>{
    const query = targetPage ? (0, $9eCf8.default) : (0, $93d715cfc896c3c6$export$2e2bcd8739ae039);
    const defaultVariables = targetPage ? {
        spaceKey: spaceKey,
        isSuperAdmin: isSuperAdmin,
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        ptStatuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        contentId: targetPage
    } : {
        spaceKey: spaceKey,
        isSuperAdmin: isSuperAdmin,
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        emojiTitleEnabled: true
    };
    const variablesForPagination = {
        paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
        ...defaultVariables
    };
    return {
        query: query,
        options: {
            fetchPolicy: detached ? 'no-cache' : forceFetch ? 'network-only' : 'cache-first',
            variables: paginated === true || !targetPage ? variablesForPagination : defaultVariables
        }
    };
};
const $34ce551f827e69ec$export$b005fb2b94547bd6 = (spaceKey, isSuperAdmin, statuses, onLoadMore)=>{
    const $ = (0, $frIzR.c)(22);
    const [state, actions] = (0, $jGj7w.usePageTreeState)();
    const { focusedPageId: focusedPageId } = state;
    let t0;
    if ($[0] !== statuses) {
        t0 = {
            statuses: statuses
        };
        $[0] = statuses;
        $[1] = t0;
    } else t0 = $[1];
    const { loadMorePages: loadMorePages } = (0, $3c47156b255753b0$export$a7e70ccb70edf19f)(t0);
    let t1;
    if ($[2] !== isSuperAdmin || $[3] !== statuses) {
        t1 = {
            statuses: statuses,
            isSuperAdmin: isSuperAdmin
        };
        $[2] = isSuperAdmin;
        $[3] = statuses;
        $[4] = t1;
    } else t1 = $[4];
    const { reloadChildren: reloadChildren, queryChildren: queryChildren } = (0, $1280e1da13e18af8$export$d88ca1c37ff75e1)(t1);
    let t2;
    if ($[5] !== actions || $[6] !== focusedPageId || $[7] !== isSuperAdmin || $[8] !== loadMorePages || $[9] !== onLoadMore || $[10] !== spaceKey || $[11] !== state) {
        t2 = async (direction)=>{
            actions.setIsPageTreeLoading(true);
            const followingNodeHidden = (0, $2qvBe.isFollowingNodeHidden)(state.initialPages);
            let pages = state.initialPages;
            if (direction === "following" && followingNodeHidden) {
                const { mergedPages: prevPages, error: prevError } = await loadMorePages(focusedPageId, spaceKey, isSuperAdmin, state.cursors, pages, "previous");
                if (prevError) return;
                pages = prevPages;
            }
            const { mergedPages: mergedPages, rootLevelPages: rootLevelPages, error: error } = await loadMorePages(focusedPageId, spaceKey, isSuperAdmin, state.cursors, pages, direction);
            if (error) return;
            const newState = (0, $k0x5M.deriveStateFromData)({
                currentPage: mergedPages,
                rootLevelPages: rootLevelPages,
                space: state.space
            }, spaceKey, state, false, undefined, false);
            actions.setStateWithUIAttributes(newState);
            const flattenedPages = (0, $k0x5M.flattenTreeData)(mergedPages, rootLevelPages);
            actions.setIsPageTreeLoading(false);
            if (onLoadMore) onLoadMore(Object.keys(flattenedPages).length, direction);
        };
        $[5] = actions;
        $[6] = focusedPageId;
        $[7] = isSuperAdmin;
        $[8] = loadMorePages;
        $[9] = onLoadMore;
        $[10] = spaceKey;
        $[11] = state;
        $[12] = t2;
    } else t2 = $[12];
    const loadMoreDirectionalPages = t2;
    let t3;
    if ($[13] !== loadMoreDirectionalPages) {
        t3 = ()=>loadMoreDirectionalPages("previous");
        $[13] = loadMoreDirectionalPages;
        $[14] = t3;
    } else t3 = $[14];
    const loadPreviousPages = t3;
    let t4;
    if ($[15] !== loadMoreDirectionalPages) {
        t4 = ()=>loadMoreDirectionalPages("following");
        $[15] = loadMoreDirectionalPages;
        $[16] = t4;
    } else t4 = $[16];
    const loadFollowingPages = t4;
    let t5;
    if ($[17] !== loadFollowingPages || $[18] !== loadPreviousPages || $[19] !== queryChildren || $[20] !== reloadChildren) {
        t5 = {
            loadPreviousPages: loadPreviousPages,
            loadFollowingPages: loadFollowingPages,
            reloadChildren: reloadChildren,
            queryChildren: queryChildren
        };
        $[17] = loadFollowingPages;
        $[18] = loadPreviousPages;
        $[19] = queryChildren;
        $[20] = reloadChildren;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
};
const $34ce551f827e69ec$export$2876891f14dc554a = (currentPageId, paginated, forceFetch, detached, spaceKey, isSuperAdmin)=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] !== currentPageId || $[1] !== detached || $[2] !== forceFetch || $[3] !== isSuperAdmin || $[4] !== paginated || $[5] !== spaceKey) {
        t0 = $34ce551f827e69ec$export$c22e67505d83a820(currentPageId, paginated, forceFetch, detached, spaceKey, isSuperAdmin);
        $[0] = currentPageId;
        $[1] = detached;
        $[2] = forceFetch;
        $[3] = isSuperAdmin;
        $[4] = paginated;
        $[5] = spaceKey;
        $[6] = t0;
    } else t0 = $[6];
    const { query: query, options: options } = t0;
    const t1 = options.fetchPolicy;
    let t2;
    if ($[7] !== options.variables || $[8] !== t1) {
        t2 = {
            skip: true,
            fetchPolicy: t1,
            variables: options.variables
        };
        $[7] = options.variables;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    return (0, $jMyy4.useQueryInterop)(query, {
        ...t2,
        __callerPackage__: "@confluence/page-tree"
    });
};
const $34ce551f827e69ec$export$4a34638c035ec952 = (spaceKey, expandSpaceHomepage, syntheticItem, t0, t1, statuses, syntheticItemIsDraft, pageTreeStateUpdatesContainer)=>{
    const $ = (0, $frIzR.c)(13);
    const isPeekingFromBlogs = t0 === undefined ? false : t0;
    const isSuperAdmin = t1 === undefined ? false : t1;
    const [state, actions] = (0, $jGj7w.usePageTreeState)();
    let t2;
    if ($[0] !== isSuperAdmin || $[1] !== statuses) {
        t2 = {
            statuses: statuses,
            isSuperAdmin: isSuperAdmin
        };
        $[0] = isSuperAdmin;
        $[1] = statuses;
        $[2] = t2;
    } else t2 = $[2];
    const { queryChildren: queryChildren } = (0, $1280e1da13e18af8$export$d88ca1c37ff75e1)(t2);
    let t3;
    if ($[3] !== actions || $[4] !== expandSpaceHomepage || $[5] !== isPeekingFromBlogs || $[6] !== pageTreeStateUpdatesContainer || $[7] !== queryChildren || $[8] !== spaceKey || $[9] !== state || $[10] !== syntheticItem || $[11] !== syntheticItemIsDraft) {
        t3 = (data)=>{
            if (data && Object.keys(data).length > 0) {
                const spaceHomePageId = data.space?.homepage?.id;
                const newState = (0, $k0x5M.deriveStateFromData)(data, spaceKey, state, isPeekingFromBlogs, syntheticItem, syntheticItemIsDraft, pageTreeStateUpdatesContainer, (0, $9wGTI.fg)("confluence_frontend_whiteboard_emoji_titles"));
                actions.setStateWithUIAttributes(newState);
                const { rootId: rootId, pages: allPages } = newState;
                if (expandSpaceHomepage && spaceHomePageId && rootId !== spaceHomePageId && allPages[spaceHomePageId]) return actions.expandPage(allPages[spaceHomePageId], queryChildren);
                return allPages;
            }
            return data;
        };
        $[3] = actions;
        $[4] = expandSpaceHomepage;
        $[5] = isPeekingFromBlogs;
        $[6] = pageTreeStateUpdatesContainer;
        $[7] = queryChildren;
        $[8] = spaceKey;
        $[9] = state;
        $[10] = syntheticItem;
        $[11] = syntheticItemIsDraft;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};











const $5118cf9ac37d7a42$var$determineMovePageParams = (destinationParent, pageId, destination)=>{
    if (typeof destination.index === 'undefined') return {
        pageId: pageId,
        parentId: destination.parentId
    };
    const movedToFirstPosition = destination.index === 0;
    const currentIndexUnderDestinationParent = destinationParent.children.indexOf(pageId);
    const movedDownOnSameLevel = currentIndexUnderDestinationParent > -1 && currentIndexUnderDestinationParent < destination.index;
    const isSiblingShifted = movedToFirstPosition || movedDownOnSameLevel;
    const siblingIndex = isSiblingShifted ? destination.index : destination.index - 1;
    const siblingId = String(destinationParent.children[siblingIndex]);
    return {
        pageId: pageId,
        siblingId: siblingId,
        positionToSibling: destination.index === 0 ? 'before' : 'after'
    };
};
const $5118cf9ac37d7a42$var$validateMove = (source, destination, pages)=>{
    if (!destination || (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(source, destination) || !pages[destination.parentId]) return 'INVALID_MOVE_LOCATION';
    if (pages[destination.parentId].data.status === 'DRAFT') return 'INVALID_MOVE_LOCATION_DRAFT';
    return null;
};
const $5118cf9ac37d7a42$export$63f1f45217bf3813 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { onMoveInvalid: onMoveInvalid, syntheticItem: syntheticItem, onPageMove: onPageMove, queryChildren: queryChildren } = t0;
    const [, actions] = (0, $jGj7w.usePageTreeState)();
    let t1;
    if ($[0] !== actions || $[1] !== onMoveInvalid || $[2] !== onPageMove || $[3] !== queryChildren || $[4] !== syntheticItem?.id) {
        t1 = (source, destination, instructionType)=>{
            const { pages: pages, space: space } = actions.getState();
            const reason = $5118cf9ac37d7a42$var$validateMove(source, destination, pages);
            if (reason) {
                onMoveInvalid?.({
                    reason: reason
                });
                return;
            }
            const pageId = syntheticItem?.id || pages[source.parentId].children[source.index];
            const contentStatus = pages[pageId]?.data?.status || null;
            const destinationParent = pages[destination.parentId];
            const sourceParent = pages[source.parentId];
            const expandAfter = pageId === syntheticItem?.id;
            actions.movePageInState(pageId, source, destination, queryChildren, expandAfter);
            const movePageParams = $5118cf9ac37d7a42$var$determineMovePageParams(destinationParent, pageId, destination);
            onPageMove(movePageParams, {
                contentStatus: contentStatus,
                destination: destination,
                instructionType: instructionType,
                movedPageTitle: pages[pageId].data.title,
                source: source,
                sourceParent: sourceParent,
                spaceId: space?.id,
                revertMove: ()=>{
                    const { pages: pages_0 } = actions.getState();
                    const updatedSourceParent = pages_0[sourceParent.id];
                    const inverseDestination = updatedSourceParent.children.length > 0 ? source : {
                        parentId: sourceParent.id
                    };
                    actions.movePageInState(pageId, destination, inverseDestination, true, true);
                    return $5118cf9ac37d7a42$var$determineMovePageParams(updatedSourceParent, pageId, inverseDestination);
                }
            });
        };
        $[0] = actions;
        $[1] = onMoveInvalid;
        $[2] = onPageMove;
        $[3] = queryChildren;
        $[4] = syntheticItem?.id;
        $[5] = t1;
    } else t1 = $[5];
    syntheticItem?.id;
    const movePage = t1;
    return movePage;
};



var $55DRn = parcelRequire("55DRn");










var $7sObp = parcelRequire("7sObp");




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5b61e06162a9104b$var$TreeItemEmptyState = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { indent: indent, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_gg0ene": (0, $7sObp.default)(__cmplp.indent, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _4cvr1h6o _80om73ad _4t3i14no _syaz1rpy",
                __cmplp.indent ? "_19bv2uct" : "_19bvidpf",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $5b61e06162a9104b$export$4fcfc92bcfdf296e = ({ item: item, indent: indent })=>{
    if (item.data.type === 'folder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b61e06162a9104b$var$TreeItemEmptyState, {
        indent: indent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        id: "page-tree.folder.empty-state",
        defaultMessage: "There\u2019s nothing in this folder yet."
    }));
};












var $T1bCI = parcelRequire("T1bCI");




var $1GzhS = parcelRequire("1GzhS");




var $hmuev = parcelRequire("hmuev");


var $4WZ5N = parcelRequire("4WZ5N");


var $gKvd9 = parcelRequire("gKvd9");


var $6F6hl = parcelRequire("6F6hl");


var $3gadb = parcelRequire("3gadb");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $jwg5H = parcelRequire("jwg5H");


var $abCbd = parcelRequire("abCbd");


var $eQjI7 = parcelRequire("eQjI7");


var $aqBZ0 = parcelRequire("aqBZ0");


var $bwL2u = parcelRequire("bwL2u");


var $kRW4Y = parcelRequire("kRW4Y");


var $gqqjz = parcelRequire("gqqjz");











var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");

/**
 * Below is the exported type with comments next to it for context because the variable names are not very clear.
 *
 * export type MutationOutputItem = {
	pageID: string;
	hasChildren: boolean;
	areChildrenIncluded: boolean; // Are all descendants included?
	excludedBranchRootPageIDs: string[]; // All direct children that are excluded.
	hasRestrictions: boolean; // Current node has restrictions
	hasInheritedRestrictions: boolean; // Within this tree, there are inherited restrictions
	contentType: string | null;

	// These attributes below will have preset values
	hasSelectedAncestor: boolean; // This is for archived pages w| note, which is not required.
	excludedBranchRootPageHasInheritedRestrictions: boolean[]; // We are not addressing this because we are excluding it.
	isSelected: boolean; // This will always be true in our scenario, we always want to include the current tree item.
};
 */ const $4060ba72f705a372$var$createPrimaryActionInput = ({ treeItem: treeItem, areChildrenIncluded: areChildrenIncluded, excludedBranchRootPageIDs: excludedBranchRootPageIDs = [], hasInheritedRestrictions: hasInheritedRestrictions = false })=>({
        pageID: treeItem.id,
        areChildrenIncluded: areChildrenIncluded,
        hasRestrictions: treeItem.hasRestrictions ?? false,
        hasInheritedRestrictions: hasInheritedRestrictions ?? false,
        excludedBranchRootPageIDs: excludedBranchRootPageIDs,
        hasChildren: treeItem.hasChildren,
        contentType: treeItem.data.type ?? null,
        // These attributes are expected in the schema but will have preset values and can be ignored for our use case.
        isSelected: true,
        excludedBranchRootPageHasInheritedRestrictions: [],
        hasSelectedAncestor: false
    });
const $4060ba72f705a372$export$860ea5d378df4698 = (root, pages, contentIdsWithLoadedChildren, selectedContent)=>{
    // This is a set of contentIds that should be ignored if a parent node has addressed all of its descendants from the areChildrenIncluded argument
    let ignoreSet = new Set();
    // Checking if all descendants are selected and saving the selected descendants in a set to be ignored
    // if and only if all descendants are selected to prevent another recursive traversal against the TreeNodeItem
    const collectSelectedItemsAndStatus = (item)=>{
        const selectedSet = new Set();
        let hasInheritedRestrictions = false;
        const traverse = (currItem)=>{
            if (selectedContent[currItem.id] === undefined || selectedContent[currItem.id].deselectedChildren.size > 0) return false;
            const isSelected = selectedContent.hasOwnProperty(currItem.id);
            if (isSelected) {
                selectedSet.add(currItem.id);
                if (currItem.hasRestrictions && currItem.hasChildren) hasInheritedRestrictions = true;
            }
            const children = currItem.children || [];
            let allChildrenSelected = true;
            for (const childId of children){
                const child = pages[childId];
                if (child.data.status !== 'DRAFT') {
                    if (child) {
                        const childAllSelected = traverse(child);
                        allChildrenSelected = allChildrenSelected && childAllSelected;
                    } else // If the child doesn't exist in pages, treat it as not selected
                    allChildrenSelected = false;
                }
            }
            // Current node must be selected AND all children must be selected
            return isSelected && allChildrenSelected;
        };
        const allSelected = traverse(item);
        return {
            selectedSet: selectedSet,
            allSelected: allSelected,
            hasInheritedRestrictions: hasInheritedRestrictions
        };
    };
    const result = [];
    const getSelectedItems = (treeItem)=>{
        const isSelected = treeItem.id in selectedContent;
        const hasChildren = treeItem.hasChildren;
        const children = treeItem.children;
        if (!ignoreSet.has(treeItem.id) && treeItem.data.status !== 'DRAFT') {
            // Leaf node is selected
            if (isSelected && !hasChildren) result.push($4060ba72f705a372$var$createPrimaryActionInput({
                treeItem: treeItem,
                areChildrenIncluded: false
            }));
            else if (isSelected && hasChildren && !contentIdsWithLoadedChildren.has(treeItem.id)) result.push($4060ba72f705a372$var$createPrimaryActionInput({
                treeItem: treeItem,
                areChildrenIncluded: true
            }));
            else if (isSelected && hasChildren && selectedContent[treeItem.id].deselectedChildren.size > 0) result.push($4060ba72f705a372$var$createPrimaryActionInput({
                treeItem: treeItem,
                areChildrenIncluded: false,
                excludedBranchRootPageIDs: [
                    ...selectedContent[treeItem.id].deselectedChildren
                ]
            }));
            else if (isSelected && hasChildren) {
                const { selectedSet: selectedSet, allSelected: allSelected, hasInheritedRestrictions: hasInheritedRestrictions } = collectSelectedItemsAndStatus(treeItem);
                if (allSelected) {
                    result.push($4060ba72f705a372$var$createPrimaryActionInput({
                        treeItem: treeItem,
                        areChildrenIncluded: true,
                        excludedBranchRootPageIDs: [],
                        hasInheritedRestrictions: hasInheritedRestrictions
                    }));
                    ignoreSet = new Set([
                        ...selectedSet,
                        ...ignoreSet
                    ]);
                } else {
                    // This scenario should never be reached, but this is a just in case. It should also be covered by the archive/delete mutation when it fails.
                    const err = new Error('[Bulk Actions on Content Tree] Error formatting selected items for primary actions (delete or archive)');
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        attribution: (0, $3IBnw.Attribution).DISCO
                    });
                    return err;
                }
            }
        }
        for (const childId of children || []){
            const child = pages[childId];
            if (child) getSelectedItems(child);
        }
        // Has previously been addressed by parent with the areChildrenIncluded argument
        if (isSelected && ignoreSet.has(treeItem.id)) {
            if (!hasChildren) {
                // TODO @awu address the case where nodes with children have also been accounted for
                delete selectedContent[treeItem.id];
                ignoreSet.delete(treeItem.id);
            }
        }
        return result;
    };
    return getSelectedItems(root);
};


const $5153e67ad09ff2bc$export$a2dcefe26b9fbedd = ()=>{
    const $ = (0, $frIzR.c)(8);
    const [t0] = (0, $bwL2u.useContentTreeSelection)();
    const { selectedContent: selectedContent } = t0;
    const { getState: getState } = (0, $jGj7w.usePageTreeActions)();
    let t1;
    if ($[0] !== getState || $[1] !== selectedContent) {
        t1 = ()=>{
            const { rootId: rootId, pages: pages, contentIdsWithLoadedChildren: contentIdsWithLoadedChildren } = getState();
            const selectedContentCopy = {
                ...selectedContent
            };
            return (0, $4060ba72f705a372$export$860ea5d378df4698)(pages[rootId], pages, contentIdsWithLoadedChildren, selectedContentCopy);
        };
        $[0] = getState;
        $[1] = selectedContent;
        $[2] = t1;
    } else t1 = $[2];
    const getPrimaryActionInput = t1;
    let t2;
    if ($[3] !== getState) {
        t2 = ()=>{
            const { spaceKey: spaceKey, spaceId: spaceId } = getState();
            return {
                spaceKey: spaceKey,
                spaceId: spaceId
            };
        };
        $[3] = getState;
        $[4] = t2;
    } else t2 = $[4];
    const getCurrentSpace = t2;
    let t3;
    if ($[5] !== getCurrentSpace || $[6] !== getPrimaryActionInput) {
        t3 = {
            getPrimaryActionInput: getPrimaryActionInput,
            getCurrentSpace: getCurrentSpace
        };
        $[5] = getCurrentSpace;
        $[6] = getPrimaryActionInput;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};















var $1Whri = parcelRequire("1Whri");


var $2W0qg = parcelRequire("2W0qg");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $lGgRw = parcelRequire("lGgRw");


var $ebrpi = parcelRequire("ebrpi");





const $c33509509e92d1b9$var$styles = {
    button: "_2rko1qi0 _1rjc1b66 _18zru2gc _p12f1ns9 _bfhk1aqn",
    activeButton: "_irr31ibz _1di6of27",
    disabledButton: "_lcxvglyw",
    disabledBox: "_80om13gf",
    inline: "_11c8fhey _18zru2gc _4t3izwfg _syaz15cr",
    limitDialog: "_2rko1qi0 _1rjc1b66 _18zru2gc _bfhk1aqn _syaz15cr _1e0c1txw _1bah1h6o _4cvr1h6o",
    popup: "_2rko1qi0 _1bsbkvcq",
    deleteButton: "_irr3s9hg"
};
const $c33509509e92d1b9$export$70bde410d897c00a = (t0)=>{
    const $ = (0, $frIzR.c)(38);
    const { actionText: actionText, actionIcon: actionIcon, actionName: actionName, count: count, onClick: onClick, isSelectionLimitReached: t1, actionLimit: t2, isLoading: t3, isDisabled: t4 } = t0;
    const isSelectionLimitReached = t1 === undefined ? false : t1;
    const actionLimit = t2 === undefined ? 0 : t2;
    const isLoading = t3 === undefined ? false : t3;
    const isDisabled = t4 === undefined ? false : t4;
    const isButtonDisabled = actionName !== (0, $60ad31f4e0dd72f9$export$f320192b45e546dc) && (count === 0 || isLoading || isDisabled);
    if (isSelectionLimitReached) {
        let t5;
        if ($[0] !== actionLimit) {
            t5 = ()=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($c33509509e92d1b9$var$styles.limitDialog)
                }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                    alignBlock: "center",
                    space: "space.100",
                    xcss: (0, $1Whri.cx)($c33509509e92d1b9$var$styles.inline)
                }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
                    ...$c33509509e92d1b9$var$i18n.overTheLimitWarning,
                    values: {
                        limit: actionLimit
                    }
                })));
            $[0] = actionLimit;
            $[1] = t5;
        } else t5 = $[1];
        let t6;
        if ($[2] !== actionText || $[3] !== count) {
            t6 = (triggerProps)=>/*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
                    ...triggerProps,
                    xcss: (0, $1Whri.cx)($c33509509e92d1b9$var$styles.disabledBox)
                }, /*#__PURE__*/ $42omo.createElement((0, $2W0qg.default), {
                    xcss: (0, $1Whri.cx)($c33509509e92d1b9$var$styles.button, $c33509509e92d1b9$var$styles.disabledButton),
                    "aria-disabled": true
                }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
                    alignBlock: "center",
                    space: "space.100",
                    xcss: (0, $1Whri.cx)($c33509509e92d1b9$var$styles.inline)
                }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                    label: "",
                    color: "var(--ds-icon-warning, #E06C00)"
                }), /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
                    ...actionText,
                    values: {
                        count: count
                    }
                }))));
            $[2] = actionText;
            $[3] = count;
            $[4] = t6;
        } else t6 = $[4];
        let t7;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = [
                0,
                -70
            ];
            $[5] = t7;
        } else t7 = $[5];
        let t8;
        if ($[6] !== t5 || $[7] !== t6) {
            t8 = /*#__PURE__*/ $42omo.createElement((0, $lGgRw.default), {
                placement: "right",
                isOpen: true,
                content: t5,
                trigger: t6,
                popupComponent: $c33509509e92d1b9$var$CustomPopupContainer,
                offset: t7,
                shouldRenderToParent: true
            });
            $[6] = t5;
            $[7] = t6;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const t5 = isButtonDisabled && $c33509509e92d1b9$var$styles.disabledBox;
    let t6;
    if ($[9] !== t5) {
        t6 = (0, $1Whri.cx)(t5);
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const t7 = isButtonDisabled && $c33509509e92d1b9$var$styles.disabledButton;
    const t8 = actionName === (0, $60ad31f4e0dd72f9$export$2298ba3671f5c8c7) && $c33509509e92d1b9$var$styles.deleteButton;
    let t9;
    if ($[11] !== t7 || $[12] !== t8) {
        t9 = (0, $1Whri.cx)($c33509509e92d1b9$var$styles.button, $c33509509e92d1b9$var$styles.activeButton, t7, t8);
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    const t10 = `${actionName}Button`;
    let t11;
    if ($[14] !== count || $[15] !== t10) {
        t11 = {
            source: "contentTreeBulkActions",
            attributes: {
                name: t10,
                selectedItemCount: count
            }
        };
        $[14] = count;
        $[15] = t10;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $1Whri.cx)($c33509509e92d1b9$var$styles.inline);
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== actionIcon || $[19] !== isLoading) {
        t13 = isLoading ? /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
            size: "small",
            appearance: "invert"
        }) : actionIcon;
        $[18] = actionIcon;
        $[19] = isLoading;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== count) {
        t14 = {
            count: count
        };
        $[21] = count;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== actionText || $[24] !== t14) {
        t15 = /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
            ...actionText,
            values: t14
        });
        $[23] = actionText;
        $[24] = t14;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== t13 || $[27] !== t15) {
        t16 = /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100",
            xcss: t12
        }, t13, t15);
        $[26] = t13;
        $[27] = t15;
        $[28] = t16;
    } else t16 = $[28];
    let t17;
    if ($[29] !== isButtonDisabled || $[30] !== onClick || $[31] !== t11 || $[32] !== t16 || $[33] !== t9) {
        t17 = /*#__PURE__*/ $42omo.createElement((0, $2W0qg.default), {
            onClick: onClick,
            xcss: t9,
            analyticsContext: t11,
            "aria-disabled": isButtonDisabled
        }, t16);
        $[29] = isButtonDisabled;
        $[30] = onClick;
        $[31] = t11;
        $[32] = t16;
        $[33] = t9;
        $[34] = t17;
    } else t17 = $[34];
    let t18;
    if ($[35] !== t17 || $[36] !== t6) {
        t18 = /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            xcss: t6
        }, t17);
        $[35] = t17;
        $[36] = t6;
        $[37] = t18;
    } else t18 = $[37];
    return t18;
};
// Need custom popup container to allow us to override the border radius styling
const $c33509509e92d1b9$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, ref)=>{
    const $ = (0, $frIzR.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            $c33509509e92d1b9$var$styles.popup
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props || $[6] !== ref) {
        t2 = /*#__PURE__*/ $42omo.createElement("div", {
            ...props,
            ref: ref,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = ref;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
});
const $c33509509e92d1b9$var$i18n = (0, $aXWIB.defineMessages)({
    overTheLimitWarning: {
        id: "page-tree.bulk-actions-menu.over-the-limit-warning",
        defaultMessage: "This action can only be applied to {limit} items at a time. Please deselect some items to continue."
    }
});


const $60ad31f4e0dd72f9$export$4b71c44db98cf846 = 'contentTreeBulkActions';
const $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID = 'bulkAction';
const $60ad31f4e0dd72f9$export$9abc4b344c9f62bb = 'clearSelection';
const $60ad31f4e0dd72f9$export$bcfb39b8f6d9105e = 'bulkArchive';
const $60ad31f4e0dd72f9$export$2298ba3671f5c8c7 = 'bulkDelete';
const $60ad31f4e0dd72f9$export$f320192b45e546dc = 'exit';
const $60ad31f4e0dd72f9$export$e3351feaa340049 = ()=>{
    const $ = (0, $frIzR.c)(49);
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t0, t1] = (0, $bwL2u.useContentTreeSelection)();
    const { count: count, loadingDescendantIds: loadingDescendantIds } = t0;
    const { clearSelection: clearSelection, exitMultiSelect: exitMultiSelect } = t1;
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const isDeleteLimitReached = count > (0, $abCbd.BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT);
    const isArchiveLimitReached = count > (0, $aqBZ0.BULK_ARCHIVE_PAGE_SELECTION_LIMIT);
    const { getPrimaryActionInput: getPrimaryActionInput, getCurrentSpace: getCurrentSpace } = (0, $5153e67ad09ff2bc$export$a2dcefe26b9fbedd)();
    let t2;
    if ($[0] !== getCurrentSpace) {
        t2 = getCurrentSpace();
        $[0] = getCurrentSpace;
        $[1] = t2;
    } else t2 = $[1];
    const { spaceKey: spaceKey, spaceId: spaceId } = t2;
    const isDescendantCountLoading = loadingDescendantIds.size > 0;
    let t3;
    if ($[2] !== createAnalyticsEvent || $[3] !== exitMultiSelect || $[4] !== isModalOpen) {
        t3 = (event)=>{
            if (event.key === "Escape" && !isModalOpen) {
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                        action: "closed",
                        actionSubject: "bulkActionsMenu",
                        attributes: {
                            method: "escapeKey"
                        }
                    }
                }).fire();
                exitMultiSelect();
            }
        };
        $[2] = createAnalyticsEvent;
        $[3] = exitMultiSelect;
        $[4] = isModalOpen;
        $[5] = t3;
    } else t3 = $[5];
    const handleKeydown = t3;
    let t4;
    let t5;
    if ($[6] !== handleKeydown) {
        t4 = ()=>{
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        t5 = [
            handleKeydown
        ];
        $[6] = handleKeydown;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[9] !== clearSelection || $[10] !== count || $[11] !== createAnalyticsEvent || $[12] !== exitMultiSelect || $[13] !== experienceTracker || $[14] !== getPrimaryActionInput || $[15] !== intl || $[16] !== spaceId || $[17] !== spaceKey) {
        t6 = (dialogs, flags)=>{
            setIsModalOpen(true);
            const primaryActionInput = getPrimaryActionInput();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                    attributes: {
                        action: $60ad31f4e0dd72f9$export$bcfb39b8f6d9105e,
                        count: count,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE),
                attributes: {
                    featureName: $60ad31f4e0dd72f9$export$4b71c44db98cf846
                }
            });
            if (primaryActionInput instanceof Error) flags.showErrorFlag({
                title: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.flagErrorTitle),
                description: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.flagErrorDescription)
            });
            else dialogs.showModal((0, $eQjI7.BulkArchivePagesLoader), {
                mutationOutputList: primaryActionInput,
                expectedPageCount: count,
                spaceKey: spaceKey ?? "",
                spaceId: spaceId,
                onSuccess: ()=>{
                    createAnalyticsEvent({
                        type: "sendTrackEvent",
                        data: {
                            source: "bulkArchive",
                            action: "completed",
                            actionSubject: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                            attributes: {
                                action: $60ad31f4e0dd72f9$export$bcfb39b8f6d9105e,
                                count: count,
                                spaceKey: spaceKey
                            }
                        }
                    }).fire();
                    exitMultiSelect();
                    clearSelection();
                    setIsModalOpen(false);
                },
                onClose: ()=>{
                    setIsModalOpen(false);
                },
                featureName: $60ad31f4e0dd72f9$export$4b71c44db98cf846
            });
        };
        $[9] = clearSelection;
        $[10] = count;
        $[11] = createAnalyticsEvent;
        $[12] = exitMultiSelect;
        $[13] = experienceTracker;
        $[14] = getPrimaryActionInput;
        $[15] = intl;
        $[16] = spaceId;
        $[17] = spaceKey;
        $[18] = t6;
    } else t6 = $[18];
    const handleArchiveClick = t6;
    let t7;
    if ($[19] !== count || $[20] !== createAnalyticsEvent || $[21] !== exitMultiSelect || $[22] !== experienceTracker || $[23] !== getPrimaryActionInput || $[24] !== intl || $[25] !== spaceId || $[26] !== spaceKey) {
        t7 = (dialogs_0, flags_0)=>{
            setIsModalOpen(true);
            const primaryActionInput_0 = getPrimaryActionInput();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                    attributes: {
                        action: $60ad31f4e0dd72f9$export$2298ba3671f5c8c7,
                        count: count,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.BULK_DELETE_PAGES_EXPERIENCE),
                attributes: {
                    featureName: $60ad31f4e0dd72f9$export$4b71c44db98cf846
                }
            });
            if (primaryActionInput_0 instanceof Error) flags_0.showErrorFlag({
                title: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.flagErrorTitle),
                description: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.flagErrorDescription)
            });
            else dialogs_0.showModal((0, $jwg5H.BulkDeletePagesActionLoader), {
                mutationOutputList: primaryActionInput_0,
                expectedPageCount: count,
                spaceKey: spaceKey ?? "",
                spaceId: spaceId,
                source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                onSuccess: ()=>{
                    createAnalyticsEvent({
                        type: "sendTrackEvent",
                        data: {
                            source: "bulkDelete",
                            action: "completed",
                            actionSubject: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                            attributes: {
                                action: $60ad31f4e0dd72f9$export$2298ba3671f5c8c7,
                                count: count,
                                spaceKey: spaceKey
                            }
                        }
                    }).fire();
                    window.location.reload();
                    exitMultiSelect();
                    setIsModalOpen(false);
                },
                onClose: ()=>{
                    setIsModalOpen(false);
                },
                featureName: $60ad31f4e0dd72f9$export$4b71c44db98cf846
            });
        };
        $[19] = count;
        $[20] = createAnalyticsEvent;
        $[21] = exitMultiSelect;
        $[22] = experienceTracker;
        $[23] = getPrimaryActionInput;
        $[24] = intl;
        $[25] = spaceId;
        $[26] = spaceKey;
        $[27] = t7;
    } else t7 = $[27];
    const handleDeleteClick = t7;
    let t8;
    if ($[28] !== createAnalyticsEvent || $[29] !== exitMultiSelect || $[30] !== spaceKey) {
        t8 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: "contentTreeBulkActions",
                    action: "closed",
                    actionSubject: "bulkActionsMenu",
                    attributes: {
                        method: "exitActionButton"
                    }
                }
            }).fire();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                    attributes: {
                        action: $60ad31f4e0dd72f9$export$f320192b45e546dc,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
            exitMultiSelect();
        };
        $[28] = createAnalyticsEvent;
        $[29] = exitMultiSelect;
        $[30] = spaceKey;
        $[31] = t8;
    } else t8 = $[31];
    const handleExitClick = t8;
    let t9;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: ""
        });
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[33] !== clearSelection || $[34] !== count || $[35] !== isDescendantCountLoading) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33509509e92d1b9$export$70bde410d897c00a), {
            actionText: $60ad31f4e0dd72f9$var$i18n.selected,
            actionIcon: t9,
            actionName: $60ad31f4e0dd72f9$export$9abc4b344c9f62bb,
            count: count,
            onClick: clearSelection,
            isLoading: isDescendantCountLoading
        });
        $[33] = clearSelection;
        $[34] = count;
        $[35] = isDescendantCountLoading;
        $[36] = t10;
    } else t10 = $[36];
    const countButton = t10;
    let t11;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = [
            (0, $kRW4Y.DialogsStateContainer),
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[37] = t11;
    } else t11 = $[37];
    let t12;
    if ($[38] !== count || $[39] !== countButton || $[40] !== handleArchiveClick || $[41] !== handleDeleteClick || $[42] !== handleExitClick || $[43] !== intl || $[44] !== isArchiveLimitReached || $[45] !== isDeleteLimitReached || $[46] !== isDescendantCountLoading || $[47] !== isModalOpen) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t11
        }, (dialogs_1, flags_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.100",
                alignBlock: "start",
                xcss: $60ad31f4e0dd72f9$var$menuStyles,
                role: "toolbar",
                "aria-label": intl.formatMessage($60ad31f4e0dd72f9$var$i18n.bulkActionsLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
                role: "status",
                "aria-live": "assertive",
                "aria-atomic": "true"
            }, intl.formatMessage($60ad31f4e0dd72f9$var$i18n.announceMenuOpen)), isDescendantCountLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.loadingTooltip),
                position: "right"
            }, countButton) : countButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33509509e92d1b9$export$70bde410d897c00a), {
                actionText: $60ad31f4e0dd72f9$var$i18n.archive,
                actionIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4WZ5N))), {
                    label: ""
                }),
                actionName: $60ad31f4e0dd72f9$export$bcfb39b8f6d9105e,
                count: count,
                onClick: ()=>handleArchiveClick(dialogs_1, flags_1),
                isSelectionLimitReached: isArchiveLimitReached,
                actionLimit: (0, $aqBZ0.BULK_ARCHIVE_PAGE_SELECTION_LIMIT),
                isDisabled: isModalOpen
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33509509e92d1b9$export$70bde410d897c00a), {
                actionText: $60ad31f4e0dd72f9$var$i18n.delete,
                actionIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                    label: ""
                }),
                actionName: $60ad31f4e0dd72f9$export$2298ba3671f5c8c7,
                count: count,
                onClick: ()=>handleDeleteClick(dialogs_1, flags_1),
                isSelectionLimitReached: isDeleteLimitReached,
                actionLimit: (0, $abCbd.BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT),
                isDisabled: isModalOpen
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $60ad31f4e0dd72f9$var$exitButtonStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c33509509e92d1b9$export$70bde410d897c00a), {
                actionText: $60ad31f4e0dd72f9$var$i18n.exit,
                actionName: $60ad31f4e0dd72f9$export$f320192b45e546dc,
                count: count,
                onClick: handleExitClick
            }))));
        $[38] = count;
        $[39] = countButton;
        $[40] = handleArchiveClick;
        $[41] = handleDeleteClick;
        $[42] = handleExitClick;
        $[43] = intl;
        $[44] = isArchiveLimitReached;
        $[45] = isDeleteLimitReached;
        $[46] = isDescendantCountLoading;
        $[47] = isModalOpen;
        $[48] = t12;
    } else t12 = $[48];
    return t12;
};
const $60ad31f4e0dd72f9$var$i18n = (0, $aXWIB.defineMessages)({
    selected: {
        id: "page-tree.bulk-actions-menu.selected",
        defaultMessage: "{count, plural, one {# item} other {# items}} selected"
    },
    archive: {
        id: "page-tree.bulk-actions-menu.archive",
        defaultMessage: "Archive"
    },
    delete: {
        id: "page-tree.bulk-actions-menu.delete",
        defaultMessage: "Delete"
    },
    exit: {
        id: "page-tree.bulk-actions-menu.exit",
        defaultMessage: "Exit"
    },
    bulkActionsLabel: {
        id: "page-tree.bulk-actions-menu.label",
        defaultMessage: "Bulk actions menu"
    },
    announceMenuOpen: {
        id: "page-tree.bulk-actions-menu.announce-menu-open",
        defaultMessage: "Bulk actions menu for the content tree is open."
    },
    loadingTooltip: {
        id: "page-tree.bulk-actions-menu.loading-tooltip",
        defaultMessage: "We\u2019re still processing your selection. This may take longer depending on the amount of content."
    },
    flagErrorTitle: {
        id: "page-tree.bulk-actions-menu.error.title",
        defaultMessage: "Something went wrong"
    },
    flagErrorDescription: {
        id: "page-tree.bulk-actions-menu.error.description",
        defaultMessage: "Refresh and try again. If this keeps happening, contact your space administrator."
    }
});
const $60ad31f4e0dd72f9$var$menuStyles = (0, $ecnYn.xcss)({
    position: 'fixed',
    top: 'calc(316px + var(--topNavigationHeight, 0px))',
    left: 'calc(9px + var(--leftSidebarWidth, 0px))'
});
const $60ad31f4e0dd72f9$var$exitButtonStyle = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});



var $c4LIS = parcelRequire("c4LIS");

/**
 * @generated SignedSource<<861d68f2178f3e9751e1af360f5f88b3>>
 * @relayHash 9eaef2a34ca96ab2ac994463c9f14cdb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab689671758f5e02698c97d26317ddce0a4da5c29c74139f329d82c758697d95
const $67a2e637a8df73cb$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v0 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9eaef2a34ca96ab2ac994463c9f14cdb",
            "id": "ab689671758f5e02698c97d26317ddce0a4da5c29c74139f329d82c758697d95",
            "metadata": {},
            "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
            "operationKind": "query",
            "text": "query useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{key,id}}}}"
        }
    };
}();
$67a2e637a8df73cb$var$node.hash = "6fe5c1685a204de18171323aa7dc40fa";
var $67a2e637a8df73cb$export$2e2bcd8739ae039 = $67a2e637a8df73cb$var$node;






var $8Hyz1 = parcelRequire("8Hyz1");








var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");


var $88DkZ = parcelRequire("88DkZ");

// GraphQL query to get the current user's personal space key
const $f64f941618d0e751$var$useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery = (0, $67a2e637a8df73cb$export$2e2bcd8739ae039);
// Keywords to detect meeting-related pages
const $f64f941618d0e751$var$MEETING_KEYWORDS = [
    '1:1',
    'meeting',
    '<>',
    'weekly',
    'biweekly',
    'ongoing',
    'running',
    'sync',
    'discussion',
    'session',
    '1-1'
];
const $f64f941618d0e751$export$bc0f5ad46d928429 = (pages)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const context = (0, $8Hyz1.usePostOfficeSideNavMessages)();
    const hasTrackedRef = (0, $42omo.useRef)(false);
    const [shouldQueryPersonalSpace, setShouldQueryPersonalSpace] = (0, $42omo.useState)(false);
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    // Only query for personal space info if we detect 1+ meeting pages
    const { data: personalSpaceData } = (0, $jMyy4.useQueryInterop)($f64f941618d0e751$var$useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery, {
        skip: !shouldQueryPersonalSpace || !spaceKey,
        __callerPackage__: "@confluence/page-tree"
    });
    (0, $42omo.useEffect)(()=>{
        if (!pages || Object.keys(pages).length === 0 || !spaceKey || !context) return;
        const oneOnOnePages = Object.values(pages).filter((page)=>{
            const title = page.data?.title?.toLowerCase() || '';
            const fullTitle = page.data?.fullTitle?.toLowerCase() || '';
            return $f64f941618d0e751$var$MEETING_KEYWORDS.some((keyword)=>title.includes(keyword) || fullTitle.includes(keyword));
        });
        // First check if we have 1+ meeting pages
        if (oneOnOnePages.length >= 1) {
            // Enable the personal space query if not already done
            if (!shouldQueryPersonalSpace) {
                setShouldQueryPersonalSpace(true);
                return; // Wait for query to complete
            }
            // Now check if we're in the user's personal space
            const userPersonalSpaceKey = personalSpaceData?.user?.confluence?.space?.key;
            // Only fire analytics if current space is the user's personal space
            if (userPersonalSpaceKey && spaceKey === userPersonalSpaceKey && !hasTrackedRef.current) {
                createAnalyticsEvent((0, $88DkZ.oneOnOnePagesDetectedEvent)(oneOnOnePages.length, Object.keys(pages).length, spaceId)).fire();
                // Enable post office side nav message for 1:1 pages detected
                context.enablePostOfficeSideNavMessage('1_ON_1_LOOM_NUDGE');
                hasTrackedRef.current = true;
            }
        }
    }, [
        pages,
        createAnalyticsEvent,
        spaceId,
        spaceKey,
        personalSpaceData,
        shouldQueryPersonalSpace,
        context
    ]);
};


const $4e592d9a1da9bab1$var$noop = ()=>{};

const $4e592d9a1da9bab1$var$PageTreeErrorComponentLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8EjeO",
    name: "PageTreeErrorComponentLoader",
    loader: async ()=>(await (parcelRequire("eojmu"))).PageTreeErrorComponent
});

const $4e592d9a1da9bab1$var$PageTreeEmptyComponentLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WY7o9",
    name: "PageTreeEmptyComponentLoader",
    loader: async ()=>(await (parcelRequire("bObAT"))).PageTreeEmptyComponent
});

const $4e592d9a1da9bab1$var$FooterCreateButtons = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GuqTT",
    name: "FooterCreateButtons",
    loader: async ()=>(await (parcelRequire("jV7lP"))).FooterCreateButtons
});
const $4e592d9a1da9bab1$var$StopLinkClickSSRInlineScript = ()=>{
    const $ = (0, $frIzR.c)(1);
    const nonceValue = window.__SSR_NONCE_VALUE__;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
            ...nonceValue !== undefined ? {
                nonce: nonceValue
            } : {},
            dangerouslySetInnerHTML: {
                __html: "(function(){\n  const rightChevrons = document.querySelectorAll('[data-testid=\"chevron-right\"]');\n  const downChevrons = document.querySelectorAll('[data-testid=\"chevron-down\"]');\n  const allChevrons = [...rightChevrons, ...downChevrons];\n  for(let i = 0; i <= allChevrons.length; i++){\n    allChevrons[i] ? allChevrons[i].onclick= function(e) {\n      e.preventDefault();\n      e.stopPropagation();\n    }: null;\n  }\n})()"
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $4e592d9a1da9bab1$export$9121ae6cff2a2b9f = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(170);
    const { currentPageId: currentPageId, isPeekingFromBlogs: isPeekingFromBlogs, isSuperAdmin: isSuperAdmin, spaceKey: spaceKey, statuses: statuses, expandSpaceHomepage: t1, onInitialLoadComplete: t2, onLoadMore: t3, onDragStart: t4, onPageMove: t5, setIsPageTreeLoading: t6, onMoveInvalid: onMoveInvalid, renderItem: renderItem, forceFetchCurrentPage: t7, forceFetchedCallback: forceFetchedCallback, optimisticDeleteId: optimisticDeleteId, clearDeleteId: clearDeleteId, highlightPages: t8, isDraggable: isDraggable, syntheticItem: syntheticItem, detached: t9, syntheticItemIsDraft: syntheticItemIsDraft, getIsDraggingItem: getIsDraggingItem, setIsDraggingItem: setIsDraggingItem, dragPreview: dragPreview, renderResourcedEmoji: renderResourcedEmoji, setContentTreeSize: setContentTreeSize, isMovePageTree: isMovePageTree, pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer, isCreateContentRoute: t10, flags: flags } = t0;
    const expandSpaceHomepage = t1 === undefined ? false : t1;
    const onInitialLoadComplete = t2 === undefined ? $4e592d9a1da9bab1$var$noop : t2;
    const onLoadMore = t3 === undefined ? $4e592d9a1da9bab1$var$noop : t3;
    const onDragStart = t4 === undefined ? $4e592d9a1da9bab1$var$noop : t4;
    const onPageMove = t5 === undefined ? $4e592d9a1da9bab1$var$noop : t5;
    const setIsPageTreeLoading = t6 === undefined ? $4e592d9a1da9bab1$var$noop : t6;
    const forceFetchCurrentPage = t7 === undefined ? false : t7;
    let t11;
    if ($[0] !== t8) {
        t11 = t8 === undefined ? [] : t8;
        $[0] = t8;
        $[1] = t11;
    } else t11 = $[1];
    const highlightPages = t11;
    const detached = t9 === undefined ? false : t9;
    const isCreateContentRoute = t10 === undefined ? false : t10;
    let t12;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
            previousPageId: "",
            previousSpaceKey: "",
            previousHighlightedPages: [],
            previousForceFetchCurrentPage: false,
            loadingUseEffect: false
        };
        $[2] = t12;
    } else t12 = $[2];
    const prevPropsRef = (0, $42omo.useRef)(t12);
    const isMountedRef = (0, $42omo.useRef)(true);
    const [state, actions] = (0, $jGj7w.usePageTreeState)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const { pages: pages, space: space, rootId: rootId, isTreeTruncatedPrevious: isTreeTruncatedPrevious, isTreeTruncatedFollowing: isTreeTruncatedFollowing, isPageTreeLoading: isPageTreeLoading } = state;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [contentIdsWithLoadedChildren] = (0, $jGj7w.useContentIdsWithLoadedChildren)();
    const selectContentAndDescendants = (0, $c4LIS.useNestedSelect)();
    let t13;
    let t14;
    if ($[3] !== pages || $[4] !== setContentTreeSize) {
        t13 = ()=>{
            setContentTreeSize && setContentTreeSize(Object.keys(pages).length);
        };
        t14 = [
            pages,
            setContentTreeSize
        ];
        $[3] = pages;
        $[4] = setContentTreeSize;
        $[5] = t13;
        $[6] = t14;
    } else {
        t13 = $[5];
        t14 = $[6];
    }
    (0, $42omo.useEffect)(t13, t14);
    let t15;
    if ($[7] !== onLoadMore || $[8] !== space?.id) {
        t15 = (pageCount, direction)=>{
            if (onLoadMore) onLoadMore(pageCount, space?.id, direction);
        };
        $[7] = onLoadMore;
        $[8] = space?.id;
        $[9] = t15;
    } else t15 = $[9];
    const onLoadMoreFn = t15;
    const { loadPreviousPages: loadPreviousPages, loadFollowingPages: loadFollowingPages, reloadChildren: reloadChildren, queryChildren: queryChildren } = (0, $34ce551f827e69ec$export$b005fb2b94547bd6)(spaceKey, isSuperAdmin, statuses, onLoadMoreFn);
    const { refetch: loadPages } = (0, $34ce551f827e69ec$export$2876891f14dc554a)("1", true, false, detached, spaceKey, isSuperAdmin);
    const { refetch: forceFetchPages } = (0, $34ce551f827e69ec$export$2876891f14dc554a)("1", true, true, detached, spaceKey, isSuperAdmin);
    const { refetch: fetchRoot } = (0, $34ce551f827e69ec$export$2876891f14dc554a)(undefined, true, true, detached, spaceKey, isSuperAdmin);
    const updateData = (0, $34ce551f827e69ec$export$4a34638c035ec952)(spaceKey, expandSpaceHomepage, syntheticItem, isPeekingFromBlogs, isSuperAdmin, statuses, syntheticItemIsDraft, pageTreeStateUpdatesContainer);
    let t16;
    if ($[10] !== actions || $[11] !== match?.name) {
        t16 = (data)=>{
            if (data?.ptpage === null && data?.currentPage !== null && data?.space?.homepage !== null && match?.name === (0, $1NBp8.SPACE_OVERVIEW).name) actions.handleLoadingError(new (0, $422HI.ApolloErrorInterop)({
                errorMessage: "ptpage query unexpectedly returned null"
            }));
        };
        $[10] = actions;
        $[11] = match?.name;
        $[12] = t16;
    } else t16 = $[12];
    match?.name;
    const handleUnexpectedPtpageNull = t16;
    let t17;
    if ($[13] !== actions || $[14] !== forceFetchCurrentPage || $[15] !== forceFetchedCallback || $[16] !== handleUnexpectedPtpageNull || $[17] !== state || $[18] !== updateData) {
        t17 = async (response)=>{
            const { data: data_0, error: error } = response;
            handleUnexpectedPtpageNull(data_0);
            if (error) {
                if (isMountedRef.current) actions.handleLoadingError(error);
                return data_0;
            } else {
                actions.setIsPageTreeLoading(false);
                updateData(data_0);
                if (forceFetchCurrentPage && forceFetchedCallback) forceFetchedCallback(state);
                return data_0;
            }
        };
        $[13] = actions;
        $[14] = forceFetchCurrentPage;
        $[15] = forceFetchedCallback;
        $[16] = handleUnexpectedPtpageNull;
        $[17] = state;
        $[18] = updateData;
        $[19] = t17;
    } else t17 = $[19];
    const handleData = t17;
    let t18;
    if ($[20] !== onMoveInvalid || $[21] !== onPageMove || $[22] !== queryChildren || $[23] !== syntheticItem) {
        t18 = {
            onMoveInvalid: onMoveInvalid,
            syntheticItem: syntheticItem,
            onPageMove: onPageMove,
            queryChildren: queryChildren
        };
        $[20] = onMoveInvalid;
        $[21] = onPageMove;
        $[22] = queryChildren;
        $[23] = syntheticItem;
        $[24] = t18;
    } else t18 = $[24];
    const movePage = (0, $5118cf9ac37d7a42$export$63f1f45217bf3813)(t18);
    let t19;
    if ($[25] !== actions || $[26] !== currentPageId || $[27] !== detached || $[28] !== forceFetchPages || $[29] !== handleData || $[30] !== isSuperAdmin || $[31] !== spaceKey) {
        t19 = ()=>{
            actions.clearError();
            actions.setIsPageTreeLoading(true);
            const { options: options } = (0, $34ce551f827e69ec$export$c22e67505d83a820)(currentPageId, true, false, detached, spaceKey, isSuperAdmin);
            forceFetchPages(options.variables).then((response_0)=>handleData(response_0)).catch((error_0)=>handleData({
                    error: error_0
                }));
        };
        $[25] = actions;
        $[26] = currentPageId;
        $[27] = detached;
        $[28] = forceFetchPages;
        $[29] = handleData;
        $[30] = isSuperAdmin;
        $[31] = spaceKey;
        $[32] = t19;
    } else t19 = $[32];
    const handleRetry = t19;
    let t20;
    if ($[33] !== isPageTreeLoading || $[34] !== setIsPageTreeLoading) {
        t20 = ()=>{
            setIsPageTreeLoading(isPageTreeLoading);
        };
        $[33] = isPageTreeLoading;
        $[34] = setIsPageTreeLoading;
        $[35] = t20;
    } else t20 = $[35];
    const firePropCallbacks = t20;
    let t21;
    if ($[36] !== actions || $[37] !== clearDeleteId || $[38] !== currentPageId || $[39] !== detached || $[40] !== fetchRoot || $[41] !== firePropCallbacks || $[42] !== forceFetchCurrentPage || $[43] !== forceFetchPages || $[44] !== handleData || $[45] !== highlightPages || $[46] !== isCreateContentRoute || $[47] !== isSuperAdmin || $[48] !== loadPages || $[49] !== optimisticDeleteId || $[50] !== pages || $[51] !== queryChildren || $[52] !== space?.homepage?.id || $[53] !== spaceKey) {
        t21 = ()=>{
            if (isCreateContentRoute) return;
            const { previousPageId: previousPageId, previousSpaceKey: previousSpaceKey, previousHighlightedPages: previousHighlightedPages, previousForceFetchCurrentPage: previousForceFetchCurrentPage } = prevPropsRef.current;
            const { options: options_0 } = (0, $34ce551f827e69ec$export$c22e67505d83a820)(currentPageId, true, false, detached, spaceKey, isSuperAdmin);
            const fetchPages = currentPageId ? loadPages : fetchRoot;
            const fetchData = async ()=>{
                const fetchAndHandle = ()=>forceFetchPages(options_0.variables).then((response_1)=>handleData(response_1)).catch((error_1)=>handleData({
                            error: error_1
                        }));
                if (currentPageId && (forceFetchCurrentPage || previousPageId !== currentPageId)) {
                    const currentPageInMemory = pages[currentPageId];
                    const hasHydratedCurrentPageInMemory = currentPageInMemory && !currentPageInMemory.data.isOptimistic;
                    if (forceFetchCurrentPage && !previousForceFetchCurrentPage) return fetchAndHandle();
                    else if (highlightPages.length && !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(previousHighlightedPages, highlightPages)) {
                        const highlightPage = pages[highlightPages[0]];
                        if (!highlightPage) return fetchAndHandle();
                        else {
                            if (highlightPage) return actions.expandPage(highlightPage, queryChildren);
                        }
                    } else {
                        if (!currentPageInMemory || currentPageInMemory.data.isOptimistic || spaceKey !== previousSpaceKey && previousSpaceKey !== "") {
                            const isCrossSpaceTransition = spaceKey !== previousSpaceKey && previousSpaceKey !== "";
                            if (!isCrossSpaceTransition && hasHydratedCurrentPageInMemory && (0, $6mKj3.expVal)("confluence_optimize_overview_transition_nav", "isEnabled", false)) {
                                firePropCallbacks();
                                return;
                            }
                            return fetchAndHandle();
                        } else if (!window.__SSR_RENDERED__ && previousPageId === "") {
                            const isCrossSpaceTransition_0 = spaceKey !== previousSpaceKey && previousSpaceKey !== "";
                            if (!isCrossSpaceTransition_0 && hasHydratedCurrentPageInMemory && (0, $6mKj3.expVal)("confluence_optimize_overview_transition_nav", "isEnabled", false)) {
                                firePropCallbacks();
                                return;
                            }
                            return fetchAndHandle();
                        } else {
                            if (currentPageId !== space?.homepage?.id && previousPageId !== currentPageId && currentPageInMemory && (currentPageInMemory.hasChildren || currentPageInMemory.data.type === "folder")) return actions.expandPage(currentPageInMemory, queryChildren);
                        }
                    }
                }
                if (!currentPageId && spaceKey !== previousSpaceKey) return fetchPages(options_0.variables).then((response_2)=>handleData(response_2)).catch((error_2)=>handleData({
                        error: error_2
                    }));
            };
            if (optimisticDeleteId) actions.optimisticDeleteContent(optimisticDeleteId, clearDeleteId);
            if (!prevPropsRef.current.loadingUseEffect || forceFetchCurrentPage && !previousForceFetchCurrentPage) {
                prevPropsRef.current.loadingUseEffect = true;
                fetchData().then((data_1)=>{
                    if (data_1) firePropCallbacks();
                    prevPropsRef.current.loadingUseEffect = false;
                }).catch((error_3)=>handleData({
                        error: error_3
                    }));
            }
            prevPropsRef.current.previousPageId = currentPageId;
            prevPropsRef.current.previousSpaceKey = spaceKey;
            prevPropsRef.current.previousHighlightedPages = highlightPages;
            prevPropsRef.current.previousForceFetchCurrentPage = forceFetchCurrentPage;
            if (Object.keys(pages).length >= 0) actions.updatePersistedState();
        };
        $[36] = actions;
        $[37] = clearDeleteId;
        $[38] = currentPageId;
        $[39] = detached;
        $[40] = fetchRoot;
        $[41] = firePropCallbacks;
        $[42] = forceFetchCurrentPage;
        $[43] = forceFetchPages;
        $[44] = handleData;
        $[45] = highlightPages;
        $[46] = isCreateContentRoute;
        $[47] = isSuperAdmin;
        $[48] = loadPages;
        $[49] = optimisticDeleteId;
        $[50] = pages;
        $[51] = queryChildren;
        $[52] = space?.homepage?.id;
        $[53] = spaceKey;
        $[54] = t21;
    } else t21 = $[54];
    const t22 = space?.homepage?.id;
    let t23;
    if ($[55] !== actions || $[56] !== clearDeleteId || $[57] !== currentPageId || $[58] !== detached || $[59] !== fetchRoot || $[60] !== firePropCallbacks || $[61] !== forceFetchCurrentPage || $[62] !== forceFetchPages || $[63] !== forceFetchedCallback || $[64] !== handleData || $[65] !== highlightPages || $[66] !== isCreateContentRoute || $[67] !== isPeekingFromBlogs || $[68] !== isSuperAdmin || $[69] !== loadPages || $[70] !== optimisticDeleteId || $[71] !== pages || $[72] !== queryChildren || $[73] !== spaceKey || $[74] !== state || $[75] !== syntheticItem || $[76] !== syntheticItemIsDraft || $[77] !== t22) {
        t23 = [
            actions,
            currentPageId,
            actions.expandPage,
            forceFetchCurrentPage,
            forceFetchPages,
            highlightPages,
            loadPages,
            fetchRoot,
            pages,
            spaceKey,
            forceFetchedCallback,
            queryChildren,
            firePropCallbacks,
            detached,
            handleData,
            isSuperAdmin,
            isPeekingFromBlogs,
            state,
            syntheticItem,
            syntheticItemIsDraft,
            isCreateContentRoute,
            clearDeleteId,
            optimisticDeleteId,
            t22
        ];
        $[55] = actions;
        $[56] = clearDeleteId;
        $[57] = currentPageId;
        $[58] = detached;
        $[59] = fetchRoot;
        $[60] = firePropCallbacks;
        $[61] = forceFetchCurrentPage;
        $[62] = forceFetchPages;
        $[63] = forceFetchedCallback;
        $[64] = handleData;
        $[65] = highlightPages;
        $[66] = isCreateContentRoute;
        $[67] = isPeekingFromBlogs;
        $[68] = isSuperAdmin;
        $[69] = loadPages;
        $[70] = optimisticDeleteId;
        $[71] = pages;
        $[72] = queryChildren;
        $[73] = spaceKey;
        $[74] = state;
        $[75] = syntheticItem;
        $[76] = syntheticItemIsDraft;
        $[77] = t22;
        $[78] = t23;
    } else t23 = $[78];
    (0, $42omo.useEffect)(t21, t23);
    let t24;
    let t25;
    if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = ()=>()=>{
                isMountedRef.current = false;
            };
        t25 = [];
        $[79] = t24;
        $[80] = t25;
    } else {
        t24 = $[79];
        t25 = $[80];
    }
    (0, $42omo.useEffect)(t24, t25);
    let t26;
    if ($[81] !== actions) {
        t26 = (newContent)=>{
            actions.optimisticInsertContent(newContent);
        };
        $[81] = actions;
        $[82] = t26;
    } else t26 = $[82];
    (0, $ficwO.useMessageSubscriber)((0, $ficwO.Message).ContentCreated, t26);
    (0, $f64f941618d0e751$export$bc0f5ad46d928429)(pages);
    const { movePage: movePageHandler } = (0, $55DRn.useMovePageHandler)();
    let t27;
    if ($[83] !== pages || $[84] !== rootId) {
        t27 = {
            rootId: rootId,
            items: pages
        };
        $[83] = pages;
        $[84] = rootId;
        $[85] = t27;
    } else t27 = $[85];
    const memoizedTree = t27;
    let t28;
    if ($[86] !== actions || $[87] !== movePage || $[88] !== syntheticItem) {
        t28 = async (item)=>{
            if (!syntheticItem) return;
            const sourceId = syntheticItem.id;
            if (item.id === sourceId) return;
            const { pages: latestPages } = actions.getState();
            const sourceParentId = Object.keys(latestPages).find((id)=>latestPages[id]?.data?.hasSyntheticChild || latestPages[id]?.children?.includes(sourceId));
            if (!sourceParentId) return;
            const source = {
                parentId: sourceParentId,
                index: latestPages[sourceParentId]?.children?.indexOf(sourceId)
            };
            const destination = {
                parentId: item.id
            };
            source.index !== -1 && movePage(source, destination);
        };
        $[86] = actions;
        $[87] = movePage;
        $[88] = syntheticItem;
        $[89] = t28;
    } else t28 = $[89];
    const onClick = t28;
    const justExpandedId = (0, $42omo.useRef)(null);
    let t29;
    if ($[90] !== actions || $[91] !== contentIdsWithLoadedChildren || $[92] !== flags || $[93] !== isMultiSelectActive || $[94] !== queryChildren || $[95] !== selectContentAndDescendants) {
        t29 = (page)=>{
            (0, $9eE57.perfMarkStart)({
                subject: "PageTree",
                subjectId: "expandPage"
            });
            const wereChildrenPreviouslyLoaded = contentIdsWithLoadedChildren?.has(page.id) ?? false;
            actions.expandPage(page, queryChildren).then(()=>{
                if (isMultiSelectActive && !wereChildrenPreviouslyLoaded && flags) selectContentAndDescendants(page.id, false, flags);
            });
            justExpandedId.current = page.id;
        };
        $[90] = actions;
        $[91] = contentIdsWithLoadedChildren;
        $[92] = flags;
        $[93] = isMultiSelectActive;
        $[94] = queryChildren;
        $[95] = selectContentAndDescendants;
        $[96] = t29;
    } else t29 = $[96];
    const expandPage = t29;
    let t30;
    if ($[97] !== isDraggable || $[98] !== space) {
        t30 = (item_0)=>isDraggable(item_0, {
                space: space
            });
        $[97] = isDraggable;
        $[98] = space;
        $[99] = t30;
    } else t30 = $[99];
    const isTreeDraggable = t30;
    let t31;
    if ($[100] !== actions.getCurrentTreeSize || $[101] !== actions.updateSinglePage || $[102] !== getIsDraggingItem || $[103] !== onClick || $[104] !== renderItem || $[105] !== renderResourcedEmoji || $[106] !== space?.homepage?.id || $[107] !== space?.id) {
        t31 = (params)=>{
            const spaceHomePageId = space?.homepage?.id;
            const displayEmoji = params?.item?.data?.emoji;
            const contentType = params?.item?.data?.type;
            const isSmartLinkEmbed = contentType === "embed";
            let emoji;
            if (displayEmoji && !isSmartLinkEmbed) emoji = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: displayEmoji,
                context: "pageTree",
                height: 14,
                key: displayEmoji,
                wrapper: (0, $3aAh8.EmojiWrapper),
                renderResourcedEmoji: renderResourcedEmoji
            });
            return renderItem({
                ...params,
                spaceHomePageId: spaceHomePageId,
                onClick: onClick,
                updateSinglePage: actions.updateSinglePage,
                getIsDraggingItem: getIsDraggingItem,
                spaceId: space?.id,
                emoji: emoji,
                getContentTreeSize: actions.getCurrentTreeSize,
                justExpanded: params.item.id === justExpandedId.current
            });
        };
        $[100] = actions.getCurrentTreeSize;
        $[101] = actions.updateSinglePage;
        $[102] = getIsDraggingItem;
        $[103] = onClick;
        $[104] = renderItem;
        $[105] = renderResourcedEmoji;
        $[106] = space?.homepage?.id;
        $[107] = space?.id;
        $[108] = t31;
    } else t31 = $[108];
    space?.homepage?.id;
    space?.id;
    const renderPageTreeItem = t31;
    let t32;
    if ($[109] !== onDragStart) {
        t32 = ()=>{
            onDragStart?.();
        };
        $[109] = onDragStart;
        $[110] = t32;
    } else t32 = $[110];
    const onDragStartFn = t32;
    if (state.error) {
        let t33;
        if ($[111] !== handleRetry || $[112] !== state.error.apolloError || $[113] !== state.error.isExpected) {
            t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e592d9a1da9bab1$var$PageTreeErrorComponentLoader, {
                error: state.error.apolloError,
                isExpected: state.error.isExpected,
                onRetry: handleRetry
            });
            $[111] = handleRetry;
            $[112] = state.error.apolloError;
            $[113] = state.error.isExpected;
            $[114] = t33;
        } else t33 = $[114];
        return t33;
    }
    const showFooterCreateButtons = !detached && spaceKey !== "" && !isMultiSelectActive;
    if (!isPageTreeLoading && (space?.homepage?.id && rootId == space?.homepage?.id && pages[rootId]?.children?.length == 0 || !space?.homepage?.id && Object.keys(pages).length <= 2 || space?.homepage?.id && rootId != space?.homepage?.id && Object.keys(pages).length < 3)) {
        let t33;
        if ($[115] !== actions || $[116] !== isPageTreeLoading || $[117] !== onInitialLoadComplete || $[118] !== rootId || $[119] !== showFooterCreateButtons || $[120] !== spaceKey) {
            t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e592d9a1da9bab1$var$PageTreeEmptyComponentLoader, {
                rootId: rootId,
                spaceKey: spaceKey,
                isPageTreeLoading: isPageTreeLoading,
                showFooterCreateButtons: showFooterCreateButtons,
                onInitialLoadComplete: onInitialLoadComplete,
                actions: actions
            });
            $[115] = actions;
            $[116] = isPageTreeLoading;
            $[117] = onInitialLoadComplete;
            $[118] = rootId;
            $[119] = showFooterCreateButtons;
            $[120] = spaceKey;
            $[121] = t33;
        } else t33 = $[121];
        return t33;
    }
    let t33;
    if ($[122] !== isMovePageTree) {
        t33 = !isMovePageTree && {
            renderItemEmptyState: $5b61e06162a9104b$export$4fcfc92bcfdf296e
        };
        $[122] = isMovePageTree;
        $[123] = t33;
    } else t33 = $[123];
    let t34;
    if ($[124] !== actions.collapsePage || $[125] !== dragPreview || $[126] !== expandPage || $[127] !== isPageTreeLoading || $[128] !== isTreeDraggable || $[129] !== isTreeTruncatedFollowing || $[130] !== isTreeTruncatedPrevious || $[131] !== loadFollowingPages || $[132] !== loadPreviousPages || $[133] !== memoizedTree || $[134] !== movePage || $[135] !== onDragStartFn || $[136] !== onInitialLoadComplete || $[137] !== renderPageTreeItem || $[138] !== setIsDraggingItem || $[139] !== t33) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1a3215c7f6382f73$export$330dddbe7c08afed), {
            isDraggable: isTreeDraggable,
            isTreeTruncatedPrevious: isTreeTruncatedPrevious,
            isTreeTruncatedFollowing: isTreeTruncatedFollowing,
            loadPreviousPages: loadPreviousPages,
            loadFollowingPages: loadFollowingPages,
            onCollapse: actions.collapsePage,
            onDragStart: onDragStartFn,
            onDragEnd: movePage,
            onExpand: expandPage,
            onInitialLoadComplete: onInitialLoadComplete,
            tree: memoizedTree,
            loading: isPageTreeLoading,
            renderItem: renderPageTreeItem,
            ...t33,
            setIsDraggingItem: setIsDraggingItem,
            dragPreview: dragPreview
        });
        $[124] = actions.collapsePage;
        $[125] = dragPreview;
        $[126] = expandPage;
        $[127] = isPageTreeLoading;
        $[128] = isTreeDraggable;
        $[129] = isTreeTruncatedFollowing;
        $[130] = isTreeTruncatedPrevious;
        $[131] = loadFollowingPages;
        $[132] = loadPreviousPages;
        $[133] = memoizedTree;
        $[134] = movePage;
        $[135] = onDragStartFn;
        $[136] = onInitialLoadComplete;
        $[137] = renderPageTreeItem;
        $[138] = setIsDraggingItem;
        $[139] = t33;
        $[140] = t34;
    } else t34 = $[140];
    let t35;
    if ($[141] !== isPageTreeLoading || $[142] !== showFooterCreateButtons || $[143] !== spaceKey) {
        t35 = showFooterCreateButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e592d9a1da9bab1$var$FooterCreateButtons, {
            spaceKey: spaceKey,
            isContentTreeLoading: isPageTreeLoading
        });
        $[141] = isPageTreeLoading;
        $[142] = showFooterCreateButtons;
        $[143] = spaceKey;
        $[144] = t35;
    } else t35 = $[144];
    let t36;
    if ($[145] !== isMultiSelectActive) {
        t36 = isMultiSelectActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $60ad31f4e0dd72f9$export$e3351feaa340049), null);
        $[145] = isMultiSelectActive;
        $[146] = t36;
    } else t36 = $[146];
    let t37;
    if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
        t37 = [
            (0, $c0urc.ReloadType).content
        ];
        $[147] = t37;
    } else t37 = $[147];
    const t38 = reloadChildren;
    let t39;
    if ($[148] !== t38) {
        t39 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
            name: "pagetree",
            types: t37,
            reload: t38
        });
        $[148] = t38;
        $[149] = t39;
    } else t39 = $[149];
    let t40;
    if ($[150] !== actions || $[151] !== movePageHandler || $[152] !== queryChildren) {
        t40 = (params_0)=>actions.optimisticInsertSmartLinkEmbed({
                ...params_0,
                queryChildren: queryChildren,
                movePage: async (moveParams)=>{
                    if (params_0.position) await movePageHandler(moveParams);
                }
            });
        $[150] = actions;
        $[151] = movePageHandler;
        $[152] = queryChildren;
        $[153] = t40;
    } else t40 = $[153];
    let t41;
    if ($[154] !== actions) {
        t41 = (contentId)=>actions.optimisticDeleteContent(contentId, undefined);
        $[154] = actions;
        $[155] = t41;
    } else t41 = $[155];
    let t42;
    if ($[156] !== flags || $[157] !== spaceKey || $[158] !== t40 || $[159] !== t41) {
        t42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $492ff87f1027b57e$export$2a8966ce55c8c689), {
            spaceKey: spaceKey,
            flags: flags,
            onInsert: t40,
            onDelete: t41
        });
        $[156] = flags;
        $[157] = spaceKey;
        $[158] = t40;
        $[159] = t41;
        $[160] = t42;
    } else t42 = $[160];
    let t43;
    if ($[161] !== renderServerPlaceholder) {
        t43 = renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e592d9a1da9bab1$var$StopLinkClickSSRInlineScript, null);
        $[161] = renderServerPlaceholder;
        $[162] = t43;
    } else t43 = $[162];
    let t44;
    if ($[163] !== t34 || $[164] !== t35 || $[165] !== t36 || $[166] !== t39 || $[167] !== t42 || $[168] !== t43) {
        t44 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t34, t35, t36, t39, t42, t43);
        $[163] = t34;
        $[164] = t35;
        $[165] = t36;
        $[166] = t39;
        $[167] = t42;
        $[168] = t43;
        $[169] = t44;
    } else t44 = $[169];
    return t44;
});
const $4e592d9a1da9bab1$export$a6bc5c2967fe3170 = (t0)=>{
    const $ = (0, $frIzR.c)(57);
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ ...props } = t0);
        t1 = (0, $34ce551f827e69ec$export$c22e67505d83a820)(props.currentPageId, true, false, false, props.spaceKey, props.isSuperAdmin);
        $[0] = t0;
        $[1] = props;
        $[2] = t1;
    } else {
        props = $[1];
        t1 = $[2];
    }
    const { query: query, options: options } = t1;
    let t2;
    if ($[3] !== options.variables) {
        t2 = {
            variables: options.variables,
            fetchPolicy: "cache-only"
        };
        $[3] = options.variables;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)(query, {
        ...t2,
        __callerPackage__: "@confluence/page-tree"
    });
    const [t3] = (0, $ep3mz.usePageState)();
    const { contentId: selectedPageId } = t3;
    const derrivedCurrentPage = props.detached ? props.currentPageId : selectedPageId;
    let t4;
    if ($[5] !== refetch) {
        t4 = ()=>{
            if (refetch) refetch();
        };
        $[5] = refetch;
        $[6] = t4;
    } else t4 = $[6];
    const handleRetry = t4;
    if (error) {
        let t5;
        if ($[7] !== error || $[8] !== handleRetry) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e592d9a1da9bab1$var$PageTreeErrorComponentLoader, {
                error: error,
                onRetry: handleRetry
            });
            $[7] = error;
            $[8] = handleRetry;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t5;
    if ($[10] !== props.clearDeleteId || $[11] !== props.currentPageId || $[12] !== props.detached || $[13] !== props.dragPreview || $[14] !== props.expandSpaceHomepage || $[15] !== props.flags || $[16] !== props.forceFetchCurrentPage || $[17] !== props.forceFetchedCallback || $[18] !== props.getIsDraggingItem || $[19] !== props.highlightPages || $[20] !== props.isCreateContentRoute || $[21] !== props.isDraggable || $[22] !== props.isMovePageTree || $[23] !== props.isPeekingFromBlogs || $[24] !== props.isSuperAdmin || $[25] !== props.onDragStart || $[26] !== props.onInitialLoadComplete || $[27] !== props.onLoadMore || $[28] !== props.onMoveInvalid || $[29] !== props.onPageMove || $[30] !== props.optimisticDeleteId || $[31] !== props.pageTreeStateUpdatesContainer || $[32] !== props.renderItem || $[33] !== props.renderResourcedEmoji || $[34] !== props.setContentTreeSize || $[35] !== props.setIsDraggingItem || $[36] !== props.setIsPageTreeLoading || $[37] !== props.setOpenQuickActionsId || $[38] !== props.spaceKey || $[39] !== props.statuses || $[40] !== props.syntheticItem || $[41] !== props.syntheticItemIsDraft || $[42] !== selectedPageId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e592d9a1da9bab1$export$9121ae6cff2a2b9f, {
            currentPageId: props.currentPageId,
            isPeekingFromBlogs: props.isPeekingFromBlogs,
            isSuperAdmin: props.isSuperAdmin,
            spaceKey: props.spaceKey,
            statuses: props.statuses,
            setIsPageTreeLoading: props.setIsPageTreeLoading,
            expandSpaceHomepage: props.expandSpaceHomepage,
            onInitialLoadComplete: props.onInitialLoadComplete,
            onLoadMore: props.onLoadMore,
            onDragStart: props.onDragStart,
            onPageMove: props.onPageMove,
            onMoveInvalid: props.onMoveInvalid,
            renderItem: props.renderItem,
            isDraggable: props.isDraggable,
            syntheticItem: props.syntheticItem,
            detached: props.detached,
            syntheticItemIsDraft: props.syntheticItemIsDraft,
            forceFetchCurrentPage: props.forceFetchCurrentPage,
            forceFetchedCallback: props.forceFetchedCallback,
            optimisticDeleteId: props.optimisticDeleteId,
            clearDeleteId: props.clearDeleteId,
            highlightPages: props.highlightPages,
            getIsDraggingItem: props.getIsDraggingItem,
            setIsDraggingItem: props.setIsDraggingItem,
            setOpenQuickActionsId: props.setOpenQuickActionsId,
            dragPreview: props.dragPreview,
            renderResourcedEmoji: props.renderResourcedEmoji,
            setContentTreeSize: props.setContentTreeSize,
            selectedPageId: selectedPageId,
            isMovePageTree: props.isMovePageTree,
            pageTreeStateUpdatesContainer: props.pageTreeStateUpdatesContainer,
            isCreateContentRoute: props.isCreateContentRoute,
            flags: props.flags
        });
        $[10] = props.clearDeleteId;
        $[11] = props.currentPageId;
        $[12] = props.detached;
        $[13] = props.dragPreview;
        $[14] = props.expandSpaceHomepage;
        $[15] = props.flags;
        $[16] = props.forceFetchCurrentPage;
        $[17] = props.forceFetchedCallback;
        $[18] = props.getIsDraggingItem;
        $[19] = props.highlightPages;
        $[20] = props.isCreateContentRoute;
        $[21] = props.isDraggable;
        $[22] = props.isMovePageTree;
        $[23] = props.isPeekingFromBlogs;
        $[24] = props.isSuperAdmin;
        $[25] = props.onDragStart;
        $[26] = props.onInitialLoadComplete;
        $[27] = props.onLoadMore;
        $[28] = props.onMoveInvalid;
        $[29] = props.onPageMove;
        $[30] = props.optimisticDeleteId;
        $[31] = props.pageTreeStateUpdatesContainer;
        $[32] = props.renderItem;
        $[33] = props.renderResourcedEmoji;
        $[34] = props.setContentTreeSize;
        $[35] = props.setIsDraggingItem;
        $[36] = props.setIsPageTreeLoading;
        $[37] = props.setOpenQuickActionsId;
        $[38] = props.spaceKey;
        $[39] = props.statuses;
        $[40] = props.syntheticItem;
        $[41] = props.syntheticItemIsDraft;
        $[42] = selectedPageId;
        $[43] = t5;
    } else t5 = $[43];
    let t6;
    if ($[44] !== data || $[45] !== derrivedCurrentPage || $[46] !== props.detached || $[47] !== props.highlightPages || $[48] !== props.isPeekingFromBlogs || $[49] !== props.onCollapse || $[50] !== props.onExpand || $[51] !== props.onLoadError || $[52] !== props.spaceKey || $[53] !== props.syntheticItem || $[54] !== props.syntheticItemIsDraft || $[55] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jGj7w.PageTreeStateContainer), {
            currentPageId: derrivedCurrentPage,
            highlightPages: props.highlightPages,
            initialData: data,
            spaceKey: props.spaceKey,
            syntheticItem: props.syntheticItem,
            onExpand: props.onExpand,
            onCollapse: props.onCollapse,
            onLoadError: props.onLoadError,
            syntheticItemIsDraft: props.syntheticItemIsDraft,
            isPeekingFromBlogs: props.isPeekingFromBlogs,
            detached: props.detached
        }, t5);
        $[44] = data;
        $[45] = derrivedCurrentPage;
        $[46] = props.detached;
        $[47] = props.highlightPages;
        $[48] = props.isPeekingFromBlogs;
        $[49] = props.onCollapse;
        $[50] = props.onExpand;
        $[51] = props.onLoadError;
        $[52] = props.spaceKey;
        $[53] = props.syntheticItem;
        $[54] = props.syntheticItemIsDraft;
        $[55] = t5;
        $[56] = t6;
    } else t6 = $[56];
    return t6;
};
module.exports["PageTreeCoordinator"] = $4e592d9a1da9bab1$export$a6bc5c2967fe3170;

});

parcelRegister("1ewPd", function(module, exports) {

let $0e608fa17fe2b2e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e608fa17fe2b2e2$var$load("f9QHk").then(()=>parcelRequire('e14IX'));

});

parcelRegister("eojmu", function(module, exports) {

let $a7a2536a3b09abf8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a7a2536a3b09abf8$var$load("6wr18"),
    $a7a2536a3b09abf8$var$load("ffEVr"),
    $a7a2536a3b09abf8$var$load("Wowvf"),
    $a7a2536a3b09abf8$var$load("hhss7"),
    $a7a2536a3b09abf8$var$load("3L1uC")
]).then(()=>parcelRequire('akCro'));

});

parcelRegister("bObAT", function(module, exports) {

let $898d5b8d4ab6c582$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $898d5b8d4ab6c582$var$load("ewwba").then(()=>parcelRequire('2gSlC'));

});

parcelRegister("jV7lP", function(module, exports) {

let $e8090af21f4428e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8090af21f4428e6$var$load("6wr18"),
    $e8090af21f4428e6$var$load("ffEVr"),
    $e8090af21f4428e6$var$load("3DgZV"),
    $e8090af21f4428e6$var$load("dhqJV")
]).then(()=>parcelRequire('fzbVm'));

});

parcelRegister("6CrbN", function(module, exports) {

var $42omo = parcelRequire("42omo");

// Using a getter rather than a value so that setting
// `isDragging` does not cause the whole tree to re-render
function $df238d2ddc4e210d$var$create() {
    let isDragging = false;
    return {
        setIsDraggingItem (value) {
            isDragging = value;
        },
        getIsDraggingItem () {
            return isDragging;
        }
    };
}
function $df238d2ddc4e210d$export$db01cee314a3998b() {
    const [api] = (0, $42omo.useState)($df238d2ddc4e210d$var$create);
    return api;
}
module.exports["useIsDragging"] = $df238d2ddc4e210d$export$db01cee314a3998b;

});

parcelRegister("bP5d8", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f7c88c77c90ab79e$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    flagErrorTitle: {
        id: "page-tree.dragndrop.failed.title",
        defaultMessage: "Something went wrong"
    },
    flagErrorDescription: {
        id: "page-tree.dragndrop.failed.description",
        defaultMessage: "Refresh and try again. If this keeps happening, contact your space administrator."
    },
    paginateErrorDescription: {
        id: "page-tree.paginate-content.failed.description",
        defaultMessage: "We encountered a network error while loading more content. Refresh and try again. If this keeps happening, contact your space administrator."
    },
    flagMovePagePermissionErrorTitle: {
        id: "page-tree.dragndrop.permissions.error.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You can't move this content"
    },
    flagMovePagePermissionErrorDescription: {
        id: "page-tree.dragndrop.permissions.error.decription",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "You don't have permission to move this restricted content. Contact your space administrator."
    },
    flagUndoTitle: {
        id: "page-tree.dragndrop.undo.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Moved \"{pageTitle}\""
    },
    flagUndoUntitled: {
        id: "page-tree.dragndrop.undo.untitled",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Moved \"Untitled\""
    },
    flagUndoAction: {
        id: "page-tree.dragndrop.undo.action",
        defaultMessage: "Undo"
    },
    flagLargePageTreeTitle: {
        id: "page-tree.dragndrop.lpt.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We can't move this content"
    },
    flagLargePageTreeDescription: {
        id: "page-tree.dragndrop.lpt.description",
        defaultMessage: "Drag and drop is not available for a list of 500 or more. Refresh and try again without expanding the content tree."
    },
    flagLargePageTreeSettingsAction: {
        id: "page-tree.dragndrop.lpt.settings.action",
        defaultMessage: "Go to space settings"
    },
    flagLargePageTreeRefreshAction: {
        id: "page-tree.dragndrop.lpt.refresh.action",
        defaultMessage: "Refresh page"
    },
    flagInvalidMoveDraftTitle: {
        id: "page-tree.dragndrop.invalid-move-draft.title",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You can't move content under a draft"
    },
    flagInvalidMoveDraftDescription: {
        id: "page-tree.dragndrop.invalid-move-draft.description",
        defaultMessage: "Publish the draft to move content here."
    },
    untitledDraftText: {
        id: "page-tree.untitled-draft",
        defaultMessage: "Untitled"
    }
});
module.exports["i18n"] = $f7c88c77c90ab79e$export$a7357cdd1f0b0168;

});

parcelRegister("jGj7w", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");


var $fl9IL = parcelRequire("fl9IL");


var $da6ky = parcelRequire("da6ky");


var $fG32j = parcelRequire("fG32j");


var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $3SAD5 = parcelRequire("3SAD5");


var $k0x5M = parcelRequire("k0x5M");


var $2qvBe = parcelRequire("2qvBe");

const $388cba5c68dad66f$export$106b50bd1e988b07 = {
    expandedPages: new Set(),
    loadingPages: new Set(),
    pages: {},
    space: null,
    spaceKey: null,
    rootId: null,
    isTreeTruncatedPrevious: false,
    isTreeTruncatedFollowing: false,
    cursors: {},
    initialPages: {},
    error: null,
    blogPeekRoot: undefined,
    focusedPageId: null,
    isPageTreeLoading: true,
    contentIdsWithLoadedChildren: new Set()
};
let $388cba5c68dad66f$export$841cc07eee4356f9 = $388cba5c68dad66f$export$106b50bd1e988b07;
const $388cba5c68dad66f$export$1c57db10a4d0e1b8 = (spaceKey)=>Object.keys($388cba5c68dad66f$export$841cc07eee4356f9.pages).length > 0 && //there are pages in the package level variable
    $388cba5c68dad66f$export$841cc07eee4356f9.spaceKey === spaceKey; //and the persisted state has the same spacekey as the props
const $388cba5c68dad66f$export$e324594224ef24da = {
    initializeState: ()=>({ setState: setState, dispatch: dispatch }, { currentPageId: currentPageId, spaceKey: spaceKey, highlightPages: highlightPages = [], initialData: data, isPeekingFromBlogs: isPeekingFromBlogs, syntheticItem: syntheticItem, syntheticItemIsDraft: syntheticItemIsDraft, detached: detached })=>{
            if ($388cba5c68dad66f$export$1c57db10a4d0e1b8(spaceKey) && !detached) setState({
                ...$388cba5c68dad66f$export$841cc07eee4356f9,
                pages: (0, $k0x5M.transformUIAttributes)($388cba5c68dad66f$export$841cc07eee4356f9.pages, currentPageId, $388cba5c68dad66f$export$841cc07eee4356f9.expandedPages, $388cba5c68dad66f$export$841cc07eee4356f9.loadingPages, highlightPages)
            });
            else if (data && Object.keys(data).length > 0) {
                const stateFromData = (0, $k0x5M.deriveStateFromData)(data, spaceKey, {
                    ...$388cba5c68dad66f$export$106b50bd1e988b07,
                    expandedPages: new Set(),
                    loadingPages: new Set()
                }, isPeekingFromBlogs, syntheticItem, syntheticItemIsDraft);
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes(stateFromData));
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setIsPageTreeLoading(false));
            } else setState({
                ...$388cba5c68dad66f$export$106b50bd1e988b07,
                expandedPages: new Set(),
                loadingPages: new Set(),
                spaceKey: spaceKey
            });
        },
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    //only fires when props change on the container
    derivedStateFromPropsReplacement: ()=>({ dispatch: dispatch, getState: getState }, { currentPageId: currentPageId, highlightPages: highlightPages = [], spaceKey: spaceKey })=>{
            //should really check if any of these props changed
            const { pages: pages, expandedPages: expandedPages, loadingPages: loadingPages } = getState();
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                pages: (0, $k0x5M.transformUIAttributes)(pages, currentPageId, expandedPages, loadingPages, highlightPages),
                spaceKey: spaceKey
            }));
        },
    updatePersistedState: ()=>({ getState: getState }, { detached: detached })=>{
            if (!detached) {
                //don't save state if we're in the move page dialog
                const state = getState();
                $388cba5c68dad66f$export$841cc07eee4356f9 = state;
            }
        },
    setStateWithUIAttributes: (stateObj)=>({ setState: setState, getState: getState, dispatch: dispatch }, { currentPageId: currentPageId, highlightPages: highlightPages = [] })=>{
            //this is a brute force access to state, it kinda doesn't follow the conventions of sweet state...buuut the alternative is a lot of very samey setters
            setState({
                ...stateObj
            });
            const { pages: pages, expandedPages: expandedPages, loadingPages: loadingPages, cursors: cursors } = getState();
            //this function allows us to transformUIAttributes universally on update
            //toDo: move these properties to state and simply read the sweet state via hooks lower in the tree rather than updating the pages state
            setState({
                //this is
                pages: (0, $k0x5M.transformUIAttributes)(pages, currentPageId, expandedPages, loadingPages, highlightPages, cursors)
            });
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setFocusPageId());
        },
    addLoadingPage: (pageId)=>({ getState: getState, dispatch: dispatch })=>{
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                loadingPages: getState().loadingPages.add(pageId)
            }));
        },
    setIsPageTreeLoading: (bool)=>({ setState: setState })=>{
            setState({
                isPageTreeLoading: bool
            });
        },
    setIsTreeTruncated: (bool)=>({ setState: setState })=>{
            setState({
                isTreeTruncated: bool
            });
        },
    setIsTreeTruncatedPrevious: (bool)=>({ setState: setState })=>{
            setState({
                isTreeTruncatedPrevious: bool
            });
        },
    setIsTreeTruncatedFollowing: (bool)=>({ setState: setState })=>{
            setState({
                isTreeTruncatedFollowing: bool
            });
        },
    deleteLoadingPage: (pageId)=>({ getState: getState, dispatch: dispatch })=>{
            const { loadingPages: loadingPages } = getState();
            loadingPages.delete(pageId);
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                loadingPages: loadingPages
            }));
        },
    expandPage: (page, queryChildren)=>async ({ getState: getState, setState: setState, dispatch: dispatch }, { onExpand: onExpand })=>{
            const { pages: pages, expandedPages: expandedPages, loadingPages: loadingPages, space: space, contentIdsWithLoadedChildren: contentIdsWithLoadedChildren } = getState();
            const expandedPage = pages[page.id];
            if (expandedPages.has(page.id) || !expandedPage.hasChildren && expandedPage.data.type !== 'folder') return;
            const mergedExpansions = [
                page.id,
                ...(0, $2qvBe.getAncestryIds)(page.id, pages, expandedPages)
            ];
            if (expandedPage.hasChildren && !(0, $2qvBe.childrenAreLatest)(expandedPage)) {
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                    loadingPages: loadingPages.add(expandedPage.id)
                }));
                const children = {};
                const { nodes: nodes, error: error } = await queryChildren(expandedPage.id);
                if (error) //toDo: handle loading children error here, then reset state so they can attempt to re-expand
                return;
                const queriedChildren = (0, $2qvBe.getPages)({
                    nodes: nodes
                });
                queriedChildren.forEach((child)=>{
                    children[child.id] = (0, $k0x5M.createTreeItem)(child);
                });
                // It's possible for the childen to change locally (via DnD) while the queryChildren request is in-flight.
                // Get the latest children now (after the request finished) to prevent a loss of state.
                const latestPages = getState().pages;
                const latestChildren = latestPages[expandedPage.id].children;
                latestChildren.forEach((id)=>{
                    children[id] = latestPages[id];
                });
                const childIds = (0, (/*@__PURE__*/$parcel$interopDefault($da6ky)))([
                    ...(0, $2qvBe.getIds)(queriedChildren),
                    ...latestChildren
                ]);
                let allPages = (0, $2qvBe.mergePages)(latestPages, children);
                allPages = (0, $fl9IL.default)(allPages, (editedAllPages)=>{
                    // @ts-ignore hasAdditionalChildren not available in AK tree. Can remove when using pragmatic types.
                    editedAllPages[expandedPage.id].hasAdditionalChildren = false;
                });
                loadingPages.delete(expandedPage.id);
                const finalPages = (0, $k0x5M.setChildren)(allPages, expandedPage.id, childIds);
                dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                    loadingPages: //use dispatch to make sure that if special properties are changed the tree is re-jiggered
                    loadingPages,
                    pages: finalPages
                }));
                if (onExpand) onExpand(finalPages[expandedPage.id], {
                    spaceId: space?.id
                });
            }
            setState({
                contentIdsWithLoadedChildren: new Set([
                    ...mergedExpansions,
                    contentIdsWithLoadedChildren
                ])
            });
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                expandedPages: new Set(mergedExpansions)
            }));
        },
    expandSpaceHomepage: ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { pages: pages, expandedPages: expandedPages, contentIdsWithLoadedChildren: contentIdsWithLoadedChildren, space: space } = getState();
            const homepageId = space?.homepage?.id;
            if (!homepageId) return;
            // the home page might still not be loaded in some weirder cases
            const expandedPage = pages[homepageId];
            if (expandedPages.has(homepageId) || !expandedPage?.hasChildren) return;
            const mergedExpansions = [
                homepageId,
                ...(0, $2qvBe.getAncestryIds)(homepageId, pages, expandedPages)
            ];
            setState({
                contentIdsWithLoadedChildren: new Set([
                    ...mergedExpansions,
                    ...contentIdsWithLoadedChildren
                ])
            });
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                expandedPages: new Set(mergedExpansions)
            }));
        },
    collapsePage: (page)=>({ getState: getState, dispatch: dispatch }, { onCollapse: onCollapse })=>{
            const { expandedPages: expandedPages, space: space } = getState();
            expandedPages.delete(page.id);
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                expandedPages: expandedPages
            }));
            if (onCollapse) onCollapse(page, {
                spaceId: space?.id
            });
        },
    movePageInState: (pageId, source, destination, queryChildren, expandAfter)=>({ getState: getState, dispatch: dispatch })=>{
            const { rootId: rootId, pages: pages, expandedPages: expandedPages } = getState();
            let newTree = {
                rootId: rootId,
                items: pages
            };
            const destinationParent = newTree.items[destination.parentId];
            if (source.index === undefined) {
                newTree = (0, $3SAD5.removeChild)(newTree, source.parentId, pageId);
                newTree = (0, $3SAD5.addChild)(newTree, destination.parentId, pageId, destination.index);
            } else newTree = (0, $3SAD5.moveItemOnTree)(newTree, source, destination);
            if (newTree.items[source.parentId].children.length === 0) expandedPages.delete(source.parentId);
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                pages: newTree.items,
                rootId: newTree.rootId,
                expandedPages: expandedPages
            }));
            if (expandAfter) dispatch($388cba5c68dad66f$export$e324594224ef24da.expandPage(destinationParent, queryChildren));
        },
    handleLoadingError: (apolloError, location)=>({ setState: setState }, { onLoadError: onLoadError })=>{
            if (!apolloError) return;
            const errorState = {
                apolloError: apolloError,
                location: location
            };
            if ((0, $fG32j.isSpaceRestrictedError)(apolloError) || (0, $95rLf.isExpectedApolloError)(apolloError)) {
                // Until we have a proper "restricted" state, we will show the
                // error state in case of restricted error, but mark the error
                // as expected so the experience will still succeed
                (0, $7Sm4c.markErrorAsHandled)(apolloError);
                errorState.isExpected = true;
            }
            //todo: to handle loading children and previous next errors without causing the whole tree to crash we may want to wrap this in if(location)
            //however that means the error will not be reported and we need a programatic way of ding that. OR new places to render the error handler at the top / bottom/ as a child of tree elements
            setState({
                error: errorState
            });
            if (onLoadError) onLoadError(apolloError, {
                isExpected: errorState.isExpected,
                location: errorState.location
            });
        },
    clearError: ()=>({ setState: setState })=>{
            setState({
                error: null
            });
        },
    updateSinglePage: (id, data)=>({ getState: getState, dispatch: dispatch })=>{
            const { pages: pages } = getState();
            // Do nothing if we aren't tracking this page state in the pagetree
            if (!pages[id]) return;
            const pageToUpdate = {
                ...pages[id],
                data: {
                    ...pages[id].data,
                    ...data
                }
            };
            dispatch($388cba5c68dad66f$export$e324594224ef24da.setStateWithUIAttributes({
                pages: {
                    ...pages,
                    [id]: pageToUpdate
                }
            }));
        },
    setFocusPageId: ()=>({ getState: getState, setState: setState }, { currentPageId: currentPageId, highlightPages: highlightPages = [] })=>{
            const { blogPeekRoot: blogPeekRoot } = getState();
            const focusedPageId = blogPeekRoot || currentPageId || highlightPages[0];
            setState({
                focusedPageId: focusedPageId
            });
        },
    getCurrentTreeSize: ()=>({ getState: getState })=>{
            const { pages: pages } = getState();
            return Object.keys(pages).length;
        },
    optimisticInsertContent: ({ contentId: contentId, spaceKey: newContentSpaceKey, parentId: maybeParentId, type: type, subType: subType })=>({ getState: getState, setState: setState })=>{
            const { pages: pages, rootId: rootId, spaceKey: currentSpaceKey } = getState();
            const parentId = maybeParentId || rootId;
            if (pages[contentId]) return; // Page already exists
            if (newContentSpaceKey !== currentSpaceKey) return; // Content was created in a different space
            if (!pages[parentId]?.isExpanded) return; // At this time we only support optimistic insertions for expanded pages
            if (type !== 'page' || subType) return; // At this time we only support optimistic insertions for regular pages
            const newPage = (0, $k0x5M.createTreeItem)({
                id: contentId,
                parentId: parentId,
                type: type,
                title: '',
                status: 'DRAFT',
                ancestors: [],
                children: [],
                hasChildren: false,
                isSelected: true,
                createdDate: {
                    value: new Date().getTime()
                },
                isOptimistic: true
            });
            const parentPage = {
                ...pages[parentId],
                children: [
                    ...pages[parentId].children,
                    contentId
                ],
                hasChildren: true
            };
            const newPages = {
                ...pages,
                [parentId]: parentPage,
                [contentId]: newPage
            };
            setState({
                pages: newPages
            });
        },
    optimisticInsertSmartLinkEmbed: ({ contentId: contentId, parentId: maybeParentId, title: title, url: url, iconUrl: iconUrl, queryChildren: queryChildren, position: position, movePage: movePage })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { pages: pages, rootId: rootId } = getState();
            const parentId = maybeParentId || rootId;
            if (pages[contentId]) return; // Content already exists in the tree
            if (!parentId || !pages[parentId]) return; // Parent doesn't exist in the tree
            const { spaceKey: spaceKey } = getState();
            const newItem = (0, $k0x5M.createTreeItem)({
                id: contentId,
                parentId: parentId,
                type: 'embed',
                title: title || url,
                status: 'CURRENT',
                links: {
                    webui: `/spaces/${spaceKey}/embed/${contentId}`
                },
                ancestors: [],
                children: [],
                hasChildren: false,
                isSelected: false,
                createdDate: {
                    value: new Date().getTime()
                },
                isOptimistic: true
            });
            // Set the icon URL as the emoji field directly on the tree item data.
            // createTreeItem extracts emoji from page.metadata.properties, which we don't have
            // for optimistic inserts. For embeds, the emoji field stores the favicon URL.
            if (iconUrl) newItem.data.emoji = iconUrl;
            const newPages = {
                ...pages,
                [parentId]: {
                    ...pages[parentId],
                    children: [
                        ...pages[parentId].children,
                        contentId
                    ],
                    hasChildren: true
                },
                [contentId]: newItem
            };
            setState({
                pages: newPages
            });
            // Expand the parent so the newly inserted item is visible
            const parentPage = newPages[parentId];
            if (!parentPage.isExpanded) dispatch($388cba5c68dad66f$export$e324594224ef24da.expandPage(parentPage, queryChildren));
            // Reposition to the exact drop location if a sibling position was specified
            if (position && movePage) {
                const { siblingId: siblingId, placement: placement } = position;
                const targetOffset = placement === 'before' ? 0 : 1;
                const { pages: currentPages } = getState();
                const parentChildren = currentPages[parentId]?.children || [];
                const siblingIndex = parentChildren.indexOf(siblingId);
                if (siblingIndex >= 0) dispatch($388cba5c68dad66f$export$e324594224ef24da.movePageInState(contentId, {
                    parentId: parentId,
                    index: parentChildren.length - 1
                }, {
                    parentId: parentId,
                    index: siblingIndex + targetOffset
                }, undefined));
                await movePage({
                    pageId: contentId,
                    siblingId: siblingId,
                    positionToSibling: placement
                });
            }
        },
    optimisticDeleteContent: (contentId, deleteCallback)=>({ getState: getState, setState: setState })=>{
            const { pages: pages, rootId: rootId } = getState();
            const targetPage = pages?.[contentId];
            const parentId = targetPage?.parentId || rootId;
            if (!targetPage || !parentId || !pages[parentId]?.children) {
                if (deleteCallback) deleteCallback();
                return; // Page doesn't exist, parent doesn't exist, or parent has no children
            }
            const parentPage = {
                ...pages[parentId],
                children: pages[parentId].children.filter((childId)=>childId !== contentId),
                hasChildren: pages[parentId].children.length > 1
            };
            //copy pages minus the targetPage
            const { [contentId]: _deletedKey, ...otherPages } = pages;
            const newPages = {
                ...otherPages,
                [parentId]: parentPage
            };
            setState({
                pages: newPages
            });
            if (deleteCallback) deleteCallback();
        }
};
const $388cba5c68dad66f$var$Store = (0, $1P1Tu.createStore)({
    // @ts-ignore
    initialState: {
        ...$388cba5c68dad66f$export$106b50bd1e988b07,
        expandedPages: new Set(),
        loadingPages: new Set()
    },
    actions: $388cba5c68dad66f$export$e324594224ef24da,
    name: 'pageTreeState'
});
const $388cba5c68dad66f$export$f4ecd42d78b0271b = (0, $FOT9i.createContainer)($388cba5c68dad66f$var$Store, {
    onInit: $388cba5c68dad66f$export$e324594224ef24da.initializeState,
    // @ts-ignore
    onUpdate: $388cba5c68dad66f$export$e324594224ef24da.derivedStateFromPropsReplacement
});
const $388cba5c68dad66f$export$7e29a7688fb5a693 = (0, $9zUhf.createHook)($388cba5c68dad66f$var$Store);
const $388cba5c68dad66f$export$187b5f4b52e93ae2 = (0, $9zUhf.createActionsHook)($388cba5c68dad66f$var$Store);
const $388cba5c68dad66f$export$abe36402cc730165 = (0, $9zUhf.createHook)($388cba5c68dad66f$var$Store, {
    selector: (state)=>state.contentIdsWithLoadedChildren
});
module.exports["PageTreeStateContainer"] = $388cba5c68dad66f$export$f4ecd42d78b0271b;
module.exports["usePageTreeState"] = $388cba5c68dad66f$export$7e29a7688fb5a693;
module.exports["usePageTreeActions"] = $388cba5c68dad66f$export$187b5f4b52e93ae2;
module.exports["useContentIdsWithLoadedChildren"] = $388cba5c68dad66f$export$abe36402cc730165;

});

parcelRegister("k0x5M", function(module, exports) {

var $fl9IL = parcelRequire("fl9IL");


var $dL6iS = parcelRequire("dL6iS");


var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");


var $dd6Gw = parcelRequire("dd6Gw");


var $2qvBe = parcelRequire("2qvBe");


var $9rjMR = parcelRequire("9rjMR");

const $30e0f79174576267$export$cb621630a8c199ba = (page, isWhiteboardEmojiFGEnabled = false)=>{
    const { text: title, emoji: displayEmoji, selectedEmoji: emojiFromProperties } = (0, $brn6e.getTitleAndEmoji)(page.title, (0, $8rneB.getEmojiFromPublishedPageProperties)(page), (0, $8rneB.getEmojiFromDraftPageProperties)(page), page.status, undefined, isWhiteboardEmojiFGEnabled || page.type !== 'whiteboard');
    const editorVersion = (0, $dd6Gw.getEditorVersionFromPageProperties)(page);
    // editor should be v1, v2, or ""
    return {
        id: page.id,
        children: (0, $2qvBe.getPages)(page.children),
        parentId: page.parentId || null,
        hasChildren: page.hasChildren,
        isExpanded: false,
        isChildrenLoading: false,
        hasRestrictions: page.hasRestrictions || false,
        hasInheritedRestrictions: page.hasInheritedRestrictions || false,
        // Disallow dropping onto drafts
        blockedInstructions: page.status === 'CURRENT' ? undefined : [
            'make-child'
        ],
        data: {
            title: title || '',
            fullTitle: page.title,
            status: page.status,
            blank: page.blank,
            emoji: displayEmoji,
            emojiFromProperties: emojiFromProperties,
            webui: page.links?.webui,
            type: page.type,
            editorVersion: editorVersion,
            subType: page.subType,
            createdDate: page.createdDate?.value,
            isSelected: page.isSelected,
            isOptimistic: page.isOptimistic
        }
    };
};
const $30e0f79174576267$export$b960af109265079f = (currentPage, dictionary = {}, isWhiteboardEmojiFGEnabled = false)=>{
    if (!currentPage) return;
    if (dictionary[currentPage.id]) //there should be no duplicates in server data
    throw new Error('pageTree Data malformed: contains duplicate pages');
    const children = (0, $2qvBe.getPages)(currentPage.children);
    const ancestors = (0, $2qvBe.getPages)(currentPage.nearestAncestors);
    const siblings = [
        ...(0, $2qvBe.getPages)(currentPage.previousSiblings),
        ...(0, $2qvBe.getPages)(currentPage.followingSiblings)
    ];
    dictionary[currentPage.id] = $30e0f79174576267$export$cb621630a8c199ba(currentPage, isWhiteboardEmojiFGEnabled);
    siblings.forEach((sibling)=>$30e0f79174576267$export$b960af109265079f(sibling, dictionary, isWhiteboardEmojiFGEnabled));
    ancestors.forEach((ancestor)=>$30e0f79174576267$export$b960af109265079f(ancestor, dictionary, isWhiteboardEmojiFGEnabled));
    children.forEach((child)=>$30e0f79174576267$export$b960af109265079f(child, dictionary, isWhiteboardEmojiFGEnabled));
    return dictionary;
};
const $30e0f79174576267$export$b57e3e464385c213 = (rootLevel, dictionary = {}, immutable = true)=>{
    const rootLevelPages = (0, $2qvBe.getPages)(rootLevel).map((page)=>{
        const rootLevelPage = $30e0f79174576267$export$cb621630a8c199ba(page);
        dictionary[page.id] = rootLevelPage;
        return rootLevelPage;
    });
    dictionary[0, $9rjMR.VIRTUAL_ROOT_ID] = {
        id: (0, $9rjMR.VIRTUAL_ROOT_ID),
        children: (0, $2qvBe.getIds)(rootLevelPages),
        parentId: null,
        hasChildren: true,
        isExpanded: true,
        isChildrenLoading: false,
        hasRestrictions: false,
        hasInheritedRestrictions: false,
        data: {
            title: '',
            status: '',
            blank: false,
            webui: ''
        }
    };
    dictionary[0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID] = {
        id: (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID),
        children: [],
        parentId: (0, $9rjMR.VIRTUAL_ROOT_ID),
        hasChildren: true,
        isExpanded: true,
        isChildrenLoading: false,
        hasRestrictions: false,
        hasInheritedRestrictions: false,
        data: {
            title: '',
            status: '',
            blank: false,
            webui: ''
        }
    };
    if (immutable) dictionary = $30e0f79174576267$export$1cf768f83edbc2e0(dictionary);
    return dictionary;
};
const $30e0f79174576267$export$215c1b4f1ba88b23 = (currentPage, rootLevelPages, isWhiteboardEmojiFGEnabled = false)=>{
    let pages = {};
    if (!currentPage) return pages;
    pages = $30e0f79174576267$export$b960af109265079f(currentPage, pages, isWhiteboardEmojiFGEnabled) || {};
    pages = $30e0f79174576267$export$b57e3e464385c213(rootLevelPages, pages, false);
    const ancestors = (0, $2qvBe.getPages)(currentPage.nearestAncestors);
    const children = (0, $2qvBe.getPages)(currentPage.children);
    const currentLevel = [
        ...[
            ...(0, $2qvBe.getPages)(currentPage.previousSiblings)
        ].reverse(),
        {
            id: currentPage.id,
            children: children
        },
        ...(0, $2qvBe.getPages)(currentPage.followingSiblings)
    ];
    // Build references upwards to current page's ancestors
    ancestors.forEach((ancestor, i)=>{
        const ancestorIsParent = i === 0;
        let childrenOfAncestor = [];
        if (ancestorIsParent) childrenOfAncestor = currentLevel;
        else {
            const childOfAncestor = ancestors[i - 1];
            childrenOfAncestor = [
                ...[
                    ...(0, $2qvBe.getPages)(childOfAncestor.previousSiblings)
                ].reverse(),
                childOfAncestor,
                ...(0, $2qvBe.getPages)(childOfAncestor.followingSiblings)
            ];
        }
        const page = pages[ancestor.id];
        if (page) page.children = (0, $2qvBe.getIds)(childrenOfAncestor);
    });
    // Build references downwards to current page's children
    pages[currentPage.id].children = (0, $2qvBe.getIds)(children);
    let deepestLevel = currentLevel;
    if (ancestors.length) {
        const deepestAncestor = ancestors[ancestors.length - 1];
        deepestLevel = [
            ...[
                ...(0, $2qvBe.getPages)(deepestAncestor.previousSiblings)
            ].reverse(),
            deepestAncestor,
            ...(0, $2qvBe.getPages)(deepestAncestor.followingSiblings)
        ];
    }
    pages[0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID].children = (0, $2qvBe.getIds)(deepestLevel);
    pages = $30e0f79174576267$export$1cf768f83edbc2e0(pages);
    return pages;
};
const $30e0f79174576267$export$1b13d58aa3b1c997 = (pages, currentPageId, expandedPages, loadingPages, highlightPages, cursors)=>(0, $fl9IL.default)(pages, (transformedPages)=>{
        for(const id in transformedPages)if (transformedPages.hasOwnProperty(id)) {
            const transformedPage = transformedPages[id];
            transformedPage.isExpanded = expandedPages.has(id);
            transformedPage.isChildrenLoading = loadingPages.has(id);
            transformedPage.data.isSelected = transformedPage.id === currentPageId;
            transformedPage.data.isHighlighted = highlightPages?.includes(transformedPage.id) || false;
            if (cursors?.previous?.id === transformedPage.id || cursors?.following?.id === transformedPage.id) transformedPage.data.isCursor = true;
        }
    });
const $30e0f79174576267$export$1cf768f83edbc2e0 = (pages)=>(0, $fl9IL.default)(pages, (newPages)=>{
        const pageIds = Object.keys(newPages);
        // assign parent id's based on parents children
        pageIds.forEach((id)=>{
            const page = newPages[id];
            if (page && page.children && page.children.length) page.children.forEach((child)=>{
                if (typeof child === 'string' && // In some cases one page can have both VIRTUAL_LOCAL_ROOT_ID and VIRTUAL_ROOT_ID as parent.
                // In this situation VIRTUAL_LOCAL_ROOT_ID has higher priority.
                !(page.id === (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID) && newPages[child].parentId === (0, $9rjMR.VIRTUAL_ROOT_ID))) newPages[child].parentId = page.id;
            });
        });
    });
const $30e0f79174576267$export$d4cb3dfdb7a8fc7d = (pages, expandedParentId, childrenIds)=>{
    const pagesWithChildren = (0, $fl9IL.default)(pages, (pagesWithChildren)=>{
        pagesWithChildren[expandedParentId].children = childrenIds;
    });
    const withMovedChildren = $30e0f79174576267$var$moveChildrenIfNeeded(pagesWithChildren, childrenIds, expandedParentId);
    return $30e0f79174576267$export$1cf768f83edbc2e0(withMovedChildren);
};
const $30e0f79174576267$var$moveChildrenIfNeeded = (pages, childrenIds, latestParentId)=>(0, $fl9IL.default)(pages, (newPages)=>{
        childrenIds.forEach((childId)=>{
            if (newPages[childId] && newPages[childId].parentId && newPages[childId].parentId !== latestParentId) {
                const oldParent = newPages[newPages[childId].parentId];
                oldParent.children = (0, (/*@__PURE__*/$parcel$interopDefault($dL6iS)))(oldParent.children, childId);
            }
        });
    });
const $30e0f79174576267$var$handleSyntheticItem = (syntheticItem, allPages, rootId, syntheticItemIsDraft)=>{
    allPages = {
        ...allPages
    };
    if (syntheticItem && syntheticItem.id) {
        if (!allPages[syntheticItem.id] && !allPages[rootId].children.some((id)=>id === syntheticItem.id)) // If an item with same id isn't present in the tree we got from the server - put it at the very top.
        // Otherwise, we'll leave it where it was, and just override its properties
        allPages[rootId] = {
            ...allPages[rootId],
            children: [
                syntheticItem.id,
                ...allPages[rootId].children
            ]
        };
        const existingPageData = allPages[syntheticItem.id]?.data || {};
        allPages[syntheticItem.id] = {
            ...syntheticItem,
            data: syntheticItemIsDraft ? {
                ...existingPageData,
                ...syntheticItem.data
            } : {
                ...syntheticItem.data,
                ...existingPageData
            }
        };
    }
    return allPages;
};
const $30e0f79174576267$var$correctTreeFlattener = (currentPage, rootLevelPages, isWhiteboardEmojiFGEnabled = false)=>{
    return currentPage ? $30e0f79174576267$export$215c1b4f1ba88b23(currentPage, rootLevelPages, isWhiteboardEmojiFGEnabled) : $30e0f79174576267$export$b57e3e464385c213(rootLevelPages);
};
const $30e0f79174576267$var$determineInitiallyExpandedPages = //only gets doesn't set.
(pages, expandedPages, currentPage, rootLevel, pageTreeStateUpdatesContainer)=>{
    /**
   * Determines the initially expanded subtree after pages are fetched.
   * The current page's ancestors are the only pages that will have children,
   * which is how initially expanded subtree is determined below. Simply sets State
   *
   * @param {object} pages
   */ for(const id in pages){
        const page = pages[id];
        if (page.hasChildren && (0, $2qvBe.childrenAreLatest)(page) && page.isExpanded) expandedPages.add(page.id);
    }
    // Don't expand during creation flow for content that has inline
    // renaming instead of a create content route, such as folders
    const editingTitle = pageTreeStateUpdatesContainer?.state?.editingTitle;
    const isCurrentPageInCreationFlow = editingTitle?.isNewContent && currentPage?.id === editingTitle?.contentId;
    if (currentPage && !rootLevel && !isCurrentPageInCreationFlow) {
        expandedPages.add(currentPage.id);
        const ancestors = currentPage.nearestAncestors.nodes;
        ancestors.forEach((page)=>{
            expandedPages.add(page.id);
        });
    }
    return expandedPages;
};
const $30e0f79174576267$export$bce2ae002a2919ea = (data, spaceKey, state, isPeekingFromBlogs, syntheticItem, syntheticItemIsDraft, pageTreeStateUpdatesContainer, isWhiteboardEmojiFGEnabled = false)=>{
    //need to determine if there is no homepage, if not we must populate rootLevelPages / syntheticLocalRoot
    const { space: space } = data;
    const rootLevelPages = {
        nodes: [],
        pageInfo: {}
    };
    let currentPage;
    let rootLevel = null;
    if (data?.ptpage?.followingSiblings && !data?.currentPage) {
        currentPage = {
            ...data.ptpage,
            previousSiblings: {
                nodes: [],
                pageInfo: {}
            },
            children: {
                nodes: [],
                pageInfo: {}
            },
            nearestAncestors: {
                nodes: [],
                pageInfo: {}
            }
        };
        rootLevel = (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID); // if we are displaying only root level pages, always use virtual root
    } else currentPage = data?.currentPage;
    const serverPages = $30e0f79174576267$var$correctTreeFlattener(currentPage, rootLevelPages, isWhiteboardEmojiFGEnabled);
    // @ts-ignore
    let allPages = (0, $2qvBe.mergePages)(state.pages, serverPages);
    const spaceHomePageId = space?.homepage?.id;
    const rootId = rootLevel || (0, $2qvBe.getRootId)(allPages, currentPage?.id, spaceHomePageId);
    const cursors = (0, $2qvBe.getDirectionalCursors)(currentPage, rootId, {});
    //set the space overview root now that we have it
    //"noHomepageFound" prevents infinite loop if space.homepage.id is undefined & returns
    //the orphaned page root
    const blogPeekRoot = isPeekingFromBlogs ? space.homepage && space.homepage.id || 'noHomepageFound' : undefined;
    allPages = $30e0f79174576267$var$handleSyntheticItem(syntheticItem, allPages, rootId, syntheticItemIsDraft);
    const expandedPages = $30e0f79174576267$var$determineInitiallyExpandedPages(allPages, state.expandedPages, currentPage, rootLevel, pageTreeStateUpdatesContainer);
    const newState = {
        rootId: rootId,
        pages: allPages,
        space: space,
        spaceKey: spaceKey,
        expandedPages: expandedPages,
        isTreeTruncatedPrevious: (0, $2qvBe.isPageTreeTruncatedPrevious)(currentPage),
        isTreeTruncatedFollowing: (0, $2qvBe.isPageTreeTruncatedFollowing)(currentPage),
        cursors: cursors,
        initialPages: currentPage,
        blogPeekRoot: blogPeekRoot
    };
    return newState;
};
module.exports["createTreeItem"] = $30e0f79174576267$export$cb621630a8c199ba;
module.exports["flattenTreeData"] = $30e0f79174576267$export$215c1b4f1ba88b23;
module.exports["transformUIAttributes"] = $30e0f79174576267$export$1b13d58aa3b1c997;
module.exports["setChildren"] = $30e0f79174576267$export$d4cb3dfdb7a8fc7d;
module.exports["deriveStateFromData"] = $30e0f79174576267$export$bce2ae002a2919ea;

});

parcelRegister("2qvBe", function(module, exports) {

var $fl9IL = parcelRequire("fl9IL");


var $aDQuI = parcelRequire("aDQuI");


var $9rjMR = parcelRequire("9rjMR");

const $2d6e196d41c25516$export$f4348e32a399a3d5 = (parent)=>{
    return parent?.nodes?.length ? parent.nodes : [];
};
const $2d6e196d41c25516$export$24b60fe7179439bc = (pages)=>pages.map((page)=>page.id);
const $2d6e196d41c25516$export$dfdcab00b0f585a9 = (pages, currentPageId, spaceHomePageId)=>{
    if (!spaceHomePageId || !pages || !currentPageId) return 0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID;
    const currentPage = pages[currentPageId];
    if (!currentPage) return 0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID;
    switch(currentPageId){
        case spaceHomePageId:
            return spaceHomePageId;
        case 0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID:
            return 0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID;
        default:
            return $2d6e196d41c25516$export$dfdcab00b0f585a9(pages, currentPage.parentId, spaceHomePageId);
    }
};
const $2d6e196d41c25516$export$34b8009d9e031a81 = (page)=>(!page.hasChildren || Boolean(page.children) && page.children.length > 0) && !page.hasAdditionalChildren;
const $2d6e196d41c25516$export$a03c6b8408b76abc = (allPages, newPages)=>(0, $fl9IL.default)(allPages, (mergedPages)=>{
        for(const pageId in newPages){
            const oldPage = allPages[pageId];
            const newPage = newPages[pageId];
            if (oldPage) {
                const children = $2d6e196d41c25516$export$34b8009d9e031a81(newPage) ? newPage.children : oldPage.children;
                const parentId = //ensures when paginating we don't accidentally leave behind a page incorrectly pointing to
                // the Virtual root causing the space overview to display in the tree
                oldPage.parentId === (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID) && newPage?.parentId || oldPage.parentId;
                mergedPages[pageId] = {
                    ...newPage,
                    parentId: parentId,
                    children: children
                };
            } else mergedPages[pageId] = newPage;
        }
        return mergedPages;
    });
const $2d6e196d41c25516$export$f44f2073cd5157ff = (allChildren, newChildren)=>({
        nodes: [
            ...allChildren.nodes,
            ...newChildren.nodes
        ]
    });
const $2d6e196d41c25516$export$b7edc5fdcf19d0d6 = (page)=>{
    if (!page) return false;
    const { followingSiblings: followingSiblings, nearestAncestors: nearestAncestors } = page;
    const pagesDontExistBelowForKnownAncestors = !(followingSiblings?.pageInfo?.hasNextPage || nearestAncestors.nodes.some((ancestor)=>ancestor.followingSiblings?.pageInfo?.hasNextPage));
    const moreAncestorsExist = nearestAncestors?.pageInfo?.hasNextPage;
    return pagesDontExistBelowForKnownAncestors && moreAncestorsExist;
};
const $2d6e196d41c25516$export$617edbc60225ba65 = (page)=>{
    if (!page) return false;
    const { previousSiblings: previousSiblings, nearestAncestors: nearestAncestors } = page;
    return nearestAncestors?.pageInfo?.hasNextPage || previousSiblings?.pageInfo?.hasNextPage || nearestAncestors.nodes.some((ancestor)=>ancestor.previousSiblings?.pageInfo?.hasNextPage);
};
const $2d6e196d41c25516$export$d5bc22e72508f579 = (page)=>{
    if (!page) return false;
    const { followingSiblings: followingSiblings, children: children, nearestAncestors: nearestAncestors } = page;
    if ($2d6e196d41c25516$export$b7edc5fdcf19d0d6(page)) return true;
    return followingSiblings?.pageInfo?.hasNextPage || children?.pageInfo?.hasNextPage || // we only request children on first load
    nearestAncestors.nodes.some((ancestor)=>ancestor.followingSiblings?.pageInfo?.hasNextPage);
};
const $2d6e196d41c25516$export$e96fe946844343ed = (pageId, allPages, idSet)=>{
    if (allPages[pageId]) {
        const { parentId: parentId } = allPages[pageId];
        if (parentId) {
            idSet.add(parentId);
            return $2d6e196d41c25516$export$e96fe946844343ed(parentId, allPages, idSet);
        }
    }
    return idSet;
};
const $2d6e196d41c25516$var$emptyField = ()=>({
        nodes: [],
        pageInfo: {
            hasNextPage: false
        }
    });
const $2d6e196d41c25516$var$emptyFieldWithNextPage = ()=>({
        nodes: [],
        pageInfo: {
            hasNextPage: true
        }
    });
/*
 * if ancestorIndex is -2, and we need to shift UP one level and utilize children
 * if ancestorIndex is -1, no changes are needed
 * if ancestorIndex is 0 or higher, we need to shift DOWN n levels, where n = ancestorIndex + 1.
 */ const $2d6e196d41c25516$var$shiftedSiblings = (currentPage, ancestorIndex, fieldName)=>{
    const allSiblings = [
        currentPage[fieldName],
        ...currentPage.nearestAncestors.nodes.map((a)=>a[fieldName])
    ];
    return {
        children: ancestorIndex < -1 ? allSiblings.shift() : $2d6e196d41c25516$var$emptyField(),
        siblings: ancestorIndex < 0 ? allSiblings.shift() : $2d6e196d41c25516$var$emptyField(),
        ancestorSiblings: [
            ...Array.from({
                length: Math.max(0, ancestorIndex)
            }).map($2d6e196d41c25516$var$emptyField),
            ...allSiblings
        ]
    };
};
const $2d6e196d41c25516$var$removeSiblingsFromAncestors = (currentPage)=>{
    return {
        nodes: [
            ...currentPage.nearestAncestors.nodes.map((ancestor)=>{
                const { previousSiblings: previousSiblings, followingSiblings: followingSiblings, ...otherFields } = ancestor;
                // Show more above bug - if currentpage has no following siblings when merging
                // and in feature gate, we set hasNextPage optimistically to true
                return {
                    previousSiblings: $2d6e196d41c25516$var$emptyField(),
                    followingSiblings: !followingSiblings ? $2d6e196d41c25516$var$emptyFieldWithNextPage() : $2d6e196d41c25516$var$emptyField(),
                    ...otherFields
                };
            })
        ],
        pageInfo: currentPage.nearestAncestors.pageInfo
    };
};
const $2d6e196d41c25516$export$6fd1afbfe6d62ded = (currentPage, allPages, ancestorIndex)=>{
    if (!allPages) return currentPage;
    return (0, $fl9IL.default)(allPages, (mergedPages)=>{
        var _mpFollowingSiblings_pageInfo, _mpChildren_pageInfo;
        const { followingSiblings: mpFollowingSiblings, nearestAncestors: mpNearestAncestors, children: mpChildren } = mergedPages;
        const { children: children, siblings: siblings, ancestorSiblings: ancestorSiblings } = $2d6e196d41c25516$var$shiftedSiblings(currentPage, ancestorIndex, 'followingSiblings');
        // followingSiblings
        mpFollowingSiblings.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($aDQuI)))(mpFollowingSiblings?.nodes, siblings?.nodes, 'id');
        (_mpFollowingSiblings_pageInfo = mpFollowingSiblings.pageInfo).hasNextPage && (_mpFollowingSiblings_pageInfo.hasNextPage = siblings?.pageInfo?.hasNextPage);
        // children
        mpChildren.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($aDQuI)))(mpChildren?.nodes, children?.nodes, 'id');
        (_mpChildren_pageInfo = mpChildren.pageInfo).hasNextPage && (_mpChildren_pageInfo.hasNextPage = children?.pageInfo?.hasNextPage);
        // nearestAncestors.followingSiblings
        ancestorSiblings.forEach((ancestorSiblingsAtLevel, i)=>{
            const ancestor = mpNearestAncestors?.nodes?.[i];
            if (ancestor) {
                var _ancestor_followingSiblings_pageInfo;
                ancestor.followingSiblings.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($aDQuI)))(ancestor.followingSiblings?.nodes, ancestorSiblingsAtLevel?.nodes, 'id');
                (_ancestor_followingSiblings_pageInfo = ancestor.followingSiblings.pageInfo).hasNextPage && (_ancestor_followingSiblings_pageInfo.hasNextPage = ancestorSiblingsAtLevel.pageInfo?.hasNextPage);
            }
        });
        return mergedPages;
    });
};
const $2d6e196d41c25516$export$880f73148296bc22 = (currentPage, allPages, ancestorIndex)=>{
    if (!allPages) return currentPage;
    return (0, $fl9IL.default)(allPages, (mergedPages)=>{
        var _mpPreviousSiblings_pageInfo, _mpNearestAncestors_pageInfo;
        const { previousSiblings: mpPreviousSiblings, nearestAncestors: mpNearestAncestors } = mergedPages;
        const { siblings: siblings, ancestorSiblings: ancestorSiblings } = $2d6e196d41c25516$var$shiftedSiblings(currentPage, ancestorIndex, 'previousSiblings');
        // previousSiblings
        mpPreviousSiblings.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($aDQuI)))(mpPreviousSiblings.nodes, siblings.nodes, 'id');
        (_mpPreviousSiblings_pageInfo = mpPreviousSiblings.pageInfo).hasNextPage && (_mpPreviousSiblings_pageInfo.hasNextPage = siblings.pageInfo.hasNextPage);
        // nearestAncestors
        const ancestors = $2d6e196d41c25516$var$removeSiblingsFromAncestors(currentPage);
        mpNearestAncestors.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($aDQuI)))(mpNearestAncestors.nodes, ancestors.nodes, 'id');
        (_mpNearestAncestors_pageInfo = mpNearestAncestors.pageInfo).hasNextPage && (_mpNearestAncestors_pageInfo.hasNextPage = ancestors.pageInfo.hasNextPage);
        // nearestAncestors.previousSiblings
        ancestorSiblings.forEach((ancestorSiblingsAtLevel, i)=>{
            if (i < mpNearestAncestors.nodes.length) {
                var _ancestor_previousSiblings_pageInfo;
                const ancestor = mpNearestAncestors.nodes[i];
                ancestor.previousSiblings.nodes = (0, (/*@__PURE__*/$parcel$interopDefault($aDQuI)))(ancestor.previousSiblings.nodes, ancestorSiblingsAtLevel.nodes, 'id');
                (_ancestor_previousSiblings_pageInfo = ancestor.previousSiblings.pageInfo).hasNextPage && (_ancestor_previousSiblings_pageInfo.hasNextPage = ancestorSiblingsAtLevel.pageInfo.hasNextPage);
            }
        });
        return mergedPages;
    });
};
const $2d6e196d41c25516$export$91bc0c39412b216c = (currentPage, rootId, previousCursors, direction)=>{
    if (!currentPage) return previousCursors;
    const previous = direction === 'following' ? previousCursors.previous : $2d6e196d41c25516$var$getPreviousCursor(currentPage, previousCursors.previous);
    const following = direction === 'previous' ? previousCursors.following : $2d6e196d41c25516$var$getFollowingCursor(currentPage, previousCursors.following, rootId);
    return {
        previous: previous,
        following: following
    };
};
const $2d6e196d41c25516$var$getPreviousCursor = (currentPage, lastCursor)=>{
    // if current page has ancestors, get deepest ancestor, else current node
    // if page has previous siblings, then previousmost sibling, otherwise current node
    const ancestorIndex = currentPage.nearestAncestors.nodes.length - 1;
    const adjustedIndex = ancestorIndex + (lastCursor?.ancestorIndex ?? -1) + 1;
    const furthestAncestor = currentPage.nearestAncestors.nodes[ancestorIndex] ?? currentPage;
    const siblingIndex = furthestAncestor.previousSiblings.nodes.length - 1;
    const firstPage = furthestAncestor.previousSiblings.nodes[siblingIndex] ?? furthestAncestor;
    return {
        id: firstPage.id,
        ancestorIndex: adjustedIndex
    };
};
const $2d6e196d41c25516$var$getFollowingCursor = (currentPage, lastCursor, rootId)=>{
    // find deepest ancestor's deepest following sibling
    // if none, then last following sibling
    // if no sibling, then last child
    // if no children, then current page
    //findLastIndex is not supported in testing or SSR as it's not supported in node until 18.0.0 and we're on 16.20.0
    if (!Array.prototype.findLastIndex) Array.prototype.findLastIndex = function(callback, thisArg) {
        for(let i = this.length - 1; i >= 0; i--){
            if (callback.call(thisArg, this[i], i, this)) return i;
        }
        return -1;
    };
    const ancestorIndex = currentPage.nearestAncestors.nodes.findLastIndex((a)=>a.id !== rootId && a.followingSiblings.nodes.length > 0);
    const adjustedIndex = ancestorIndex + (lastCursor?.ancestorIndex ?? -1) + 1;
    if (ancestorIndex >= 0) {
        const siblings = currentPage.nearestAncestors.nodes[ancestorIndex].followingSiblings.nodes;
        const siblingIndex = siblings.length - 1;
        const sibling = siblings[siblingIndex];
        return {
            id: sibling.id,
            ancestorIndex: adjustedIndex
        };
    }
    const siblingIndex = currentPage.followingSiblings.nodes.length - 1;
    if (siblingIndex >= 0 && currentPage.id !== rootId) {
        const sibling = currentPage.followingSiblings.nodes[siblingIndex];
        return {
            id: sibling.id,
            ancestorIndex: adjustedIndex
        };
    }
    const childIndex = currentPage.children.nodes.length - 1;
    if (childIndex >= 0) {
        const child = currentPage.children.nodes[childIndex];
        return {
            id: child.id,
            ancestorIndex: adjustedIndex - 1
        };
    }
    return {
        id: currentPage.id,
        ancestorIndex: adjustedIndex
    };
};
module.exports["getPages"] = $2d6e196d41c25516$export$f4348e32a399a3d5;
module.exports["getIds"] = $2d6e196d41c25516$export$24b60fe7179439bc;
module.exports["getRootId"] = $2d6e196d41c25516$export$dfdcab00b0f585a9;
module.exports["childrenAreLatest"] = $2d6e196d41c25516$export$34b8009d9e031a81;
module.exports["mergePages"] = $2d6e196d41c25516$export$a03c6b8408b76abc;
module.exports["mergeChildren"] = $2d6e196d41c25516$export$f44f2073cd5157ff;
module.exports["isFollowingNodeHidden"] = $2d6e196d41c25516$export$b7edc5fdcf19d0d6;
module.exports["isPageTreeTruncatedPrevious"] = $2d6e196d41c25516$export$617edbc60225ba65;
module.exports["isPageTreeTruncatedFollowing"] = $2d6e196d41c25516$export$d5bc22e72508f579;
module.exports["getAncestryIds"] = $2d6e196d41c25516$export$e96fe946844343ed;
module.exports["mergeFollowingPages"] = $2d6e196d41c25516$export$6fd1afbfe6d62ded;
module.exports["mergePreviousPages"] = $2d6e196d41c25516$export$880f73148296bc22;
module.exports["getDirectionalCursors"] = $2d6e196d41c25516$export$91bc0c39412b216c;

});

parcelRegister("c4LIS", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $dJIaO = parcelRequire("dJIaO");


var $bwL2u = parcelRequire("bwL2u");


var $jGj7w = parcelRequire("jGj7w");

const $a5a7295fb74e8ae6$export$bc80720d71558aaa = ()=>{
    const $ = (0, $frIzR.c)(8);
    const [t0, t1] = (0, $bwL2u.useContentTreeSelection)();
    const { selectedContent: selectedContent } = t0;
    const { selectNestedContent: selectNestedContent } = t1;
    const { getState: getState } = (0, $jGj7w.usePageTreeActions)();
    let t2;
    if ($[0] !== getState) {
        t2 = (itemId)=>{
            const { pages: pages, rootId: rootId } = getState();
            const ancestorContentIds = new Set();
            const getIds = (currItem)=>{
                const parentId = currItem.parentId;
                if (parentId && parentId != rootId) {
                    ancestorContentIds.add(currItem.parentId);
                    getIds(pages[parentId]);
                }
            };
            getIds(pages[itemId]);
            return ancestorContentIds;
        };
        $[0] = getState;
        $[1] = t2;
    } else t2 = $[1];
    const getAncestorIds = t2;
    const updateDescendantCount = (0, $dJIaO.useSelectionCount)();
    let t3;
    if ($[2] !== getAncestorIds || $[3] !== getState || $[4] !== selectNestedContent || $[5] !== selectedContent || $[6] !== updateDescendantCount) {
        t3 = (itemId_0, isExplicitlySelected, flags)=>{
            const { pages: pages_0 } = getState();
            const descendants = [];
            const isPreviouslySelected = itemId_0 in selectedContent;
            const isOnExpandOnSelectedParent = isPreviouslySelected && !isExplicitlySelected;
            const pageTreeItem = getState().pages[itemId_0];
            let countToRemove = 0;
            const traverse = (currItem_0, isCountRemoved)=>{
                let currIsCountRemoved = isCountRemoved;
                if (currItem_0 && currItem_0.id != pageTreeItem.id && currItem_0.id in selectedContent && !currIsCountRemoved) {
                    countToRemove = countToRemove + (selectedContent[currItem_0.id]?.selectedDescendantCount + 1);
                    countToRemove;
                    currIsCountRemoved = true;
                }
                descendants.push({
                    id: currItem_0.id,
                    parentId: currItem_0.parentId ?? undefined
                });
                const children = currItem_0.children || [];
                for (const childId of children){
                    const child = pages_0[childId];
                    if (child && child.data.status != "DRAFT") traverse(child, currIsCountRemoved);
                }
            };
            if (!isPreviouslySelected && isExplicitlySelected || isOnExpandOnSelectedParent) {
                traverse(pageTreeItem, false);
                selectNestedContent(descendants);
                updateDescendantCount(pageTreeItem, [
                    ...getAncestorIds(itemId_0)
                ], [
                    pageTreeItem.id,
                    ...descendants.map($a5a7295fb74e8ae6$var$_temp)
                ], isExplicitlySelected, countToRemove, flags);
            }
        };
        $[2] = getAncestorIds;
        $[3] = getState;
        $[4] = selectNestedContent;
        $[5] = selectedContent;
        $[6] = updateDescendantCount;
        $[7] = t3;
    } else t3 = $[7];
    const selectContentAndDescendants = t3;
    return selectContentAndDescendants;
};
function $a5a7295fb74e8ae6$var$_temp(item) {
    return item.id;
}
module.exports["useNestedSelect"] = $a5a7295fb74e8ae6$export$bc80720d71558aaa;

});

parcelRegister("9rjMR", function(module, exports) {
const $6df5fbff1b31b2b4$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $6df5fbff1b31b2b4$export$3b2fc9888fc801ce = 'VIRTUAL_LOCAL_ROOT_ID';
module.exports["VIRTUAL_ROOT_ID"] = $6df5fbff1b31b2b4$export$70918a400db2b6af;
module.exports["VIRTUAL_LOCAL_ROOT_ID"] = $6df5fbff1b31b2b4$export$3b2fc9888fc801ce;

});

parcelRegister("dJIaO", function(module, exports) {

var $6sfpn = parcelRequire("6sfpn");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $bwL2u = parcelRequire("bwL2u");


var $lvOsp = parcelRequire("lvOsp");

const $78f326507364f46a$var$ContentMetadataQuery = (0, $6sfpn.default);
const $78f326507364f46a$export$8e70fdefe25376ca = ()=>{
    const { updateSelectedDescendantsCount: updateSelectedDescendantsCount, updateTotalCount: updateTotalCount, addLoadingDescendant: addLoadingDescendant, removeLoadingDescendant: removeLoadingDescendant, incrementAncestors: incrementAncestors, updateParent: updateParent, getState: getState } = (0, $bwL2u.useContentTreeSelectionActions)();
    const intl = (0, $aXWIB.useIntl)();
    const latestArgsRef = (0, $42omo.useRef)(null);
    const [fetchMetadata] = (0, $lvOsp.useLazyQueryInterop)($78f326507364f46a$var$ContentMetadataQuery, {
        fetchPolicy: 'network-only',
        onCompleted: (data)=>{
            if (latestArgsRef.current) {
                const nodes = [
                    ...data?.pageContent?.nodes ?? [],
                    ...data?.whiteboardContent?.nodes ?? [],
                    ...data?.databaseContent?.nodes ?? [],
                    ...data?.embedContent?.nodes ?? [],
                    ...data?.folderContent?.nodes ?? []
                ];
                const { item: item, ancestorIds: ancestorIds, isExplicitlySelected: isExplicitlySelected, countToRemove: countToRemove } = latestArgsRef.current;
                const itemId = item.id;
                const { selectedContent: selectedContent } = getState();
                const isCurrentlySelected = !!selectedContent[itemId];
                const isParentSelected = item.parentId && item.parentId in selectedContent;
                let selectedCount = 0;
                nodes.forEach((node)=>{
                    if (!node || !node.id) return;
                    if (node.id === itemId) selectedCount = node.visibleDescendantsCount;
                    if (isCurrentlySelected) updateSelectedDescendantsCount(node.id, node.visibleDescendantsCount);
                    removeLoadingDescendant(node.id);
                });
                // Only update counts if content is explicitly selected.
                if (isExplicitlySelected && isCurrentlySelected) {
                    if (isParentSelected && typeof item.parentId === 'string') // If the parent is selected, we need to update the excludedChildren array.
                    updateParent(itemId, item.parentId);
                    incrementAncestors([
                        ...ancestorIds
                    ], selectedCount, countToRemove);
                    updateTotalCount(selectedCount + 1 - countToRemove); // +1 for the content itself
                } else if (countToRemove > 0) // Remove count that have been previously addressed.
                updateTotalCount(-countToRemove);
            }
        },
        onError: (err)=>{
            (0, $7Sm4c.markErrorAsHandled)(err);
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).DISCO
            });
            if (latestArgsRef.current) {
                const { flags: flags } = latestArgsRef.current;
                flags.showErrorFlag({
                    title: intl.formatMessage($78f326507364f46a$export$a7357cdd1f0b0168.flagErrorTitle),
                    description: intl.formatMessage($78f326507364f46a$export$a7357cdd1f0b0168.flagErrorDescription)
                });
            }
        },
        __callerPackage__: "@confluence/content-tree-actions"
    });
    const updateDescendantCount = (0, $42omo.useCallback)((item, ancestorIds, contentForCount, isExplicitlySelected, countToRemove, flags)=>{
        latestArgsRef.current = {
            item: item,
            ancestorIds: ancestorIds,
            isExplicitlySelected: isExplicitlySelected,
            countToRemove: countToRemove,
            flags: flags
        };
        contentForCount.forEach((id)=>addLoadingDescendant(id));
        fetchMetadata({
            variables: {
                contentIds: contentForCount
            }
        });
    }, [
        addLoadingDescendant,
        fetchMetadata
    ]);
    return updateDescendantCount;
};
const $78f326507364f46a$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    flagErrorTitle: {
        id: "content-tree-actions.selection-count.failed.title",
        defaultMessage: "Something went wrong"
    },
    flagErrorDescription: {
        id: "content-tree-actions.selection-count.failed.description",
        defaultMessage: "Refresh and try again. If this keeps happening, contact your space administrator."
    }
});
module.exports["useSelectionCount"] = $78f326507364f46a$export$8e70fdefe25376ca;

});

parcelRegister("6sfpn", function(module, exports) {
/**
 * @generated SignedSource<<5cfd17896a0a877518fcea64726e87ab>>
 * @relayHash aaceb57db889606b21c3c3c643965743
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6117ca94007bfe7c67d3f7a8081ddd2b570cefdee16d7939a12dc66c4723dd7
const $871f673e8fbdbffe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentIds"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "ids",
        "variableName": "contentIds"
    }, v2 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "visibleDescendantsCount"
                }
            ]
        }
    ], v3 = [
        {
            "alias": "pageContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "whiteboardContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "databaseContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "database"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "embedContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "embed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "folderContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "folder"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSelectionCountContentMetadataQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSelectionCountContentMetadataQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "aaceb57db889606b21c3c3c643965743",
            "id": "e6117ca94007bfe7c67d3f7a8081ddd2b570cefdee16d7939a12dc66c4723dd7",
            "metadata": {},
            "name": "useSelectionCountContentMetadataQuery",
            "operationKind": "query",
            "text": "query useSelectionCountContentMetadataQuery($contentIds:[ID!]!){pageContent:content(ids:$contentIds,type:\"page\"){nodes{id,visibleDescendantsCount}},whiteboardContent:content(ids:$contentIds,type:\"whiteboard\"){nodes{id,visibleDescendantsCount}},databaseContent:content(ids:$contentIds,type:\"database\"){nodes{id,visibleDescendantsCount}},embedContent:content(ids:$contentIds,type:\"embed\"){nodes{id,visibleDescendantsCount}},folderContent:content(ids:$contentIds,type:\"folder\"){nodes{id,visibleDescendantsCount}}}"
        }
    };
}();
$871f673e8fbdbffe$var$node.hash = "441ec5092d7845001c1a3d59a8aa9473";
var $871f673e8fbdbffe$export$2e2bcd8739ae039 = $871f673e8fbdbffe$var$node;
module.exports["default"] = $871f673e8fbdbffe$export$2e2bcd8739ae039;

});


//# sourceMappingURL=MovePageDialog.438ace2d.js.map
